import { ReactNode } from 'react';

type IconType = {
  width: number;
  height: number;
  stroke?: string;
  fill?: string;
  className?: string;
  children?: ReactNode;
  onClick?: () => void;
  gradient?: boolean;
};

export const HelmetIconOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9001 5.22268C8.8921 6.61868 8.15126 7.83872 7.04406 8.52268C6.8005 8.67072 6.50926 8.73072 6.2245 8.68264L2.67217 8.06272C2.38643 8.01468 2.13291 7.85872 1.95439 7.63472C1.41963 6.96672 1.1001 6.12268 1.1001 5.19868C1.1001 3.00668 2.91045 1.23471 5.11806 1.30267C7.20438 1.36273 8.91162 3.13471 8.9001 5.22268ZM7.8663 3.58871C7.30946 2.61762 6.27374 1.93734 5.1001 1.90267C3.23213 1.84672 1.7001 3.34271 1.7001 5.19868C1.7001 5.97876 1.97041 6.69476 2.42295 7.25872C2.51299 7.37476 2.63818 7.44672 2.77529 7.47072L6.32686 8.09068C6.46494 8.11468 6.6081 8.08676 6.72938 8.01068C7.1839 7.72964 7.56514 7.3424 7.83818 6.88372L5.53214 6.31468C5.06846 6.19876 4.68526 5.87464 4.49774 5.43472L4.25694 4.87072C3.98174 4.22668 4.46338 3.51469 5.16258 3.5307L7.8663 3.58871ZM8.1003 6.33276C8.22746 5.98508 8.29774 5.61 8.3001 5.21868C8.30206 4.86372 8.24482 4.51908 8.13742 4.19477L5.1497 4.1307C4.88602 4.12269 4.70498 4.39468 4.8085 4.63472L5.0497 5.19868C5.16338 5.46672 5.39522 5.66272 5.67606 5.73072L8.1003 6.33276Z"
        fill={fill}
      />
    </svg>
  );
};

export const FlashIconFill = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.2978 4.21029C8.19071 4.00111 7.97821 3.87111 7.74321 3.87111H5.66905V1.66695C5.66905 1.3907 5.49988 1.15695 5.23821 1.07195C4.9753 0.986531 4.70405 1.07611 4.54238 1.29861L1.75239 5.14029C1.61405 5.33154 1.59489 5.58029 1.70197 5.79029C1.80905 5.99904 2.02155 6.12904 2.25655 6.12904H4.3303V8.33362C4.3303 8.60946 4.49946 8.84279 4.76113 8.92779C4.82696 8.94946 4.89363 8.95987 4.95905 8.95987C5.15321 8.95987 5.33696 8.86821 5.4578 8.70154L8.24738 4.85987C8.38571 4.66862 8.40488 4.41987 8.2978 4.21029Z"
        fill={fill}
      />
    </svg>
  );
};

export const FlashIconOutLine = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00536 8.9021C4.93336 8.9021 4.85736 8.89014 4.78536 8.86614C4.49336 8.77014 4.30136 8.5101 4.30136 8.1981V6.18214H2.40937C2.14537 6.18214 1.90538 6.0381 1.78938 5.8021C1.66938 5.5661 1.68937 5.29014 1.84537 5.07414L4.52536 1.38615C4.70536 1.13815 5.01336 1.03815 5.30536 1.13415C5.59736 1.23015 5.78936 1.49012 5.78936 1.80212V3.81813H7.68136C7.94536 3.81813 8.18136 3.96211 8.30136 4.19811C8.42136 4.4341 8.40136 4.71014 8.24536 4.92614L5.56536 8.61414C5.42936 8.80214 5.22536 8.9021 5.00536 8.9021ZM5.08536 1.69811C5.06136 1.69811 5.03336 1.70615 5.00936 1.73815L2.33338 5.42614C2.30138 5.47014 2.31337 5.51014 2.32537 5.53014C2.33737 5.55014 2.36137 5.58214 2.41337 5.58214H4.60536C4.76936 5.58214 4.90536 5.71814 4.90536 5.88214V8.1981C4.90536 8.2581 4.94136 8.2821 4.97336 8.2941C5.00536 8.3061 5.04936 8.30614 5.08136 8.25814L7.75736 4.57014C7.78936 4.52614 7.77737 4.48614 7.76537 4.46614C7.75337 4.44614 7.72936 4.41414 7.67736 4.41414H5.48536C5.32136 4.41414 5.18536 4.27814 5.18536 4.11413V1.79811C5.18536 1.73811 5.14936 1.71412 5.11736 1.70212C5.10536 1.70212 5.09336 1.69811 5.08136 1.69811H5.08536Z"
        fill={fill}
      />
    </svg>
  );
};

export const ArrowLeftIconOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0711 4.92892L4 12L11.0711 19.0711L12.4853 17.6568L7.83 12.9999L21 13V11L7.83 10.9999L12.4853 6.34314L11.0711 4.92892Z"
        fill={fill}
      />
    </svg>
  );
};

export const ArrowRightIconOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9289 4.92892L21 12L13.9289 19.0711L12.5147 17.6568L17.17 12.9999L4 13V11L17.17 10.9999L12.5147 6.34314L13.9289 4.92892Z"
        fill={fill}
      />
    </svg>
  );
};

export const ChevronLeftIconOutline = ({
  className,
  width,
  height,
  fill,
}: IconType) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5953 7.05372L8.6496 9.99941L11.5953 12.9463L10.4168 14.1248L6.29199 10L10.4168 5.87521L11.5953 7.05372Z"
        fill={fill}
      />
    </svg>
  );
};
export const ArrowLeftIconFill = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.4075 6.5352C4.8379 6.1448 3.8823 5.4132 3.8823 4.9C3.8823 4.3868 4.8379 3.6552 5.4075 3.2648C5.5443 3.1712 5.7311 3.206 5.8243 3.3428C5.9179 3.4788 5.8827 3.6668 5.7467 3.7596C5.1119 4.1948 4.5207 4.7336 4.4819 4.912C4.5207 5.0668 5.1119 5.6056 5.7467 6.0408C5.8827 6.1336 5.9179 6.3204 5.8243 6.4576C5.7311 6.594 5.5443 6.6288 5.4075 6.5352ZM8.8999 4.9C8.8999 2.0208 7.8795 1 4.9999 1C2.1207 1 1.0999 2.0208 1.0999 4.9C1.0999 7.7792 2.1207 8.8 4.9999 8.8C7.8795 8.8 8.8999 7.7792 8.8999 4.9Z"
        fill={fill}
      />
    </svg>
  );
};
export const ArrowTopRighttIconFill = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 16H8V9.41L16.59 18L18 16.59L9.41 8H16V6H6L6 16Z"
        fill={fill}
      />
    </svg>
  );
};

export const NewArrowLeftIconFill = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.65215 9.45642C6.74079 8.83178 5.21183 7.66122 5.21183 6.8401C5.21183 6.01898 6.74079 4.84842 7.65215 4.22378C7.87103 4.07402 8.16991 4.1297 8.31903 4.34858C8.46879 4.56618 8.41247 4.86698 8.19487 5.01546C7.17919 5.71178 6.23327 6.57386 6.17119 6.8593C6.23327 7.10698 7.17919 7.96906 8.19487 8.66538C8.41247 8.81386 8.46879 9.11274 8.31903 9.33226C8.16991 9.5505 7.87103 9.60618 7.65215 9.45642ZM13.24 6.8401C13.24 2.23338 11.6074 0.600098 6.99999 0.600097C2.39327 0.600097 0.759991 2.23338 0.75999 6.8401C0.75999 11.4468 2.39327 13.0801 6.99999 13.0801C11.6073 13.0801 13.24 11.4468 13.24 6.8401Z"
        fill={fill}
      />
    </svg>
  );
};

export const NewArrowLeftIconOutline = ({
  width,
  height,
  stroke,
}: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 7L10.5 12"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 17L10.5 12"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowDownIconOutLine = ({ width, height, stroke }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.46444 9.05017L11.9992 12.585L15.5355 9.05017L16.9497 10.4644L11.9999 15.4141L7.05024 10.4644L8.46444 9.05017Z"
        fill={stroke}
      />
    </svg>
  );
};

export const DownIconSquare = ({
  className = '',
  width,
  height,
  stroke,
}: IconType) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 10.7239V5.27588"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5013 8.21436C10.5013 8.21436 8.81601 10.7237 8.00001 10.7237C7.18401 10.7237 5.50131 8.21436 5.50131 8.21436"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.83334 8.00015C1.83334 12.6248 3.37534 14.1668 8.00001 14.1668C12.6247 14.1668 14.1667 12.6248 14.1667 8.00015C14.1667 3.3755 12.6247 1.8335 8.00001 1.8335C3.37534 1.8335 1.83334 3.3755 1.83334 8.00015Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CreditCardIconSquare = ({
  className = '',
  width,
  height,
  stroke,
}: IconType) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3571 3.02588H4.64366C3.01962 3.02588 2.00134 4.17581 2.00134 5.8031V10.1946C2.00134 11.8226 3.01443 12.9718 4.64366 12.9718H11.3564C12.9864 12.9718 14.0001 11.8226 14.0001 10.1946V5.8031C14.0001 4.17581 12.9864 3.02588 11.3571 3.02588Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 6.55615H13.9987"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.59961 10.1133H5.55173"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.18884 10.1133H8.14098"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProfileIconFill = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.99859 6.32275C3.2015 6.32275 1.6665 6.60609 1.6665 7.73942C1.6665 8.87317 3.19192 9.1665 4.99859 9.1665C6.79567 9.1665 8.33067 8.88359 8.33067 7.74984C8.33067 6.61609 6.80567 6.32275 4.99859 6.32275Z"
        fill={fill}
      />
      <path
        d="M4.99846 5.24325C6.22262 5.24325 7.20346 4.262 7.20346 3.03825C7.20346 1.8145 6.22262 0.833252 4.99846 0.833252C3.77471 0.833252 2.79346 1.8145 2.79346 3.03825C2.79346 4.262 3.77471 5.24325 4.99846 5.24325Z"
        fill={fill}
      />
    </svg>
  );
};

export const ProfileIconOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.2665 7.5805C8.2665 8.95383 6.38317 9.11259 4.96692 9.11259L4.86557 9.1125C3.96326 9.11031 1.6665 9.05334 1.6665 7.57217C1.6665 6.22686 3.47415 6.04707 4.87962 6.04029L5.06827 6.04017C5.97052 6.04236 8.2665 6.09933 8.2665 7.5805ZM4.96692 6.66509C3.1915 6.66509 2.2915 6.97008 2.2915 7.57217C2.2915 8.17967 3.1915 8.48759 4.96692 8.48759C6.74192 8.48759 7.6415 8.18258 7.6415 7.5805C7.6415 6.973 6.74192 6.66509 4.96692 6.66509ZM4.96692 0.833252C6.18692 0.833252 7.179 1.82575 7.179 3.04575C7.179 4.26575 6.18692 5.25784 4.96692 5.25784H4.95359C3.73609 5.25409 2.74984 4.26117 2.75399 3.0445C2.75399 1.82575 3.7465 0.833252 4.96692 0.833252ZM4.96692 1.42825C4.07484 1.42825 3.349 2.15367 3.349 3.04575C3.34609 3.93492 4.0665 4.65992 4.95484 4.66325L4.96692 4.96075V4.66325C5.85859 4.66325 6.584 3.93742 6.584 3.04575C6.584 2.15367 5.85859 1.42825 4.96692 1.42825Z"
        fill={fill}
      />
    </svg>
  );
};

export const NotificationFill = ({
  className = '',
  width,
  height,
  fill,
}: IconType) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="vuesax/bold/notification">
        <g id="notification">
          <path
            id="Vector"
            d="M19.3399 14.49L18.3399 12.83C18.1299 12.46 17.9399 11.76 17.9399 11.35V8.82C17.9399 6.47 16.5599 4.44 14.5699 3.49C14.0499 2.57 13.0899 2 11.9899 2C10.8999 2 9.91994 2.59 9.39994 3.52C7.44994 4.49 6.09994 6.5 6.09994 8.82V11.35C6.09994 11.76 5.90994 12.46 5.69994 12.82L4.68994 14.49C4.28994 15.16 4.19994 15.9 4.44994 16.58C4.68994 17.25 5.25994 17.77 5.99994 18.02C7.93994 18.68 9.97994 19 12.0199 19C14.0599 19 16.0999 18.68 18.0399 18.03C18.7399 17.8 19.2799 17.27 19.5399 16.58C19.7999 15.89 19.7299 15.13 19.3399 14.49Z"
            fill={fill}
          />
          <path
            id="Vector_2"
            d="M14.8302 20.01C14.4102 21.17 13.3002 22 12.0002 22C11.2102 22 10.4302 21.68 9.88018 21.11C9.56018 20.81 9.32018 20.41 9.18018 20C9.31018 20.02 9.44018 20.03 9.58018 20.05C9.81018 20.08 10.0502 20.11 10.2902 20.13C10.8602 20.18 11.4402 20.21 12.0202 20.21C12.5902 20.21 13.1602 20.18 13.7202 20.13C13.9302 20.11 14.1402 20.1 14.3402 20.07C14.5002 20.05 14.6602 20.03 14.8302 20.01Z"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  );
};

export const HomeIconFill = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.76416 2.6319C7.77615 2.64246 7.78801 2.65291 7.79974 2.66325C8.75494 3.50405 8.93454 3.72445 8.93454 5.68525C8.93454 9.20005 7.91774 9.20005 4.90014 9.20005C1.88212 9.20005 0.865723 9.20005 0.865723 5.68525C0.865723 3.72485 1.04532 3.50445 2.00012 2.66405C2.00759 2.65746 2.01511 2.65083 2.02268 2.64416C2.16273 2.52068 2.32048 2.38159 2.49732 2.21765C2.59242 2.14049 2.68591 2.06109 2.78443 1.9774C2.79572 1.96781 2.80708 1.95816 2.81852 1.94845C3.41972 1.43685 4.16814 0.800049 4.88894 0.800049C5.61814 0.800049 6.41814 1.47445 7.00214 1.96685L7.02387 1.98514C7.1194 2.06557 7.2096 2.1415 7.29254 2.20845C7.47344 2.37575 7.62765 2.51162 7.76416 2.6319ZM6.36315 6.60397C6.36315 6.74197 6.22875 6.85397 6.06315 6.85397H3.73713C3.57153 6.85397 3.43713 6.74197 3.43713 6.60397C3.43713 6.46597 3.57153 6.35397 3.73713 6.35397H6.06315C6.22875 6.35397 6.36315 6.46597 6.36315 6.60397Z"
        fill={fill}
      />
    </svg>
  );
};

export const HomeIconOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_357_31607)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.43164 6.65425C3.43164 6.48857 3.56595 6.35425 3.73164 6.35425H6.05762C6.2233 6.35425 6.35762 6.48857 6.35762 6.65425C6.35762 6.81993 6.2233 6.95425 6.05762 6.95425H3.73164C3.56595 6.95425 3.43164 6.81993 3.43164 6.65425Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.82371 2.59101C2.65869 2.74386 2.51053 2.87524 2.37882 2.99133C2.36023 3.00772 2.34202 3.02375 2.32419 3.03945C2.21262 3.13769 2.11547 3.22325 2.0282 3.3038C1.82607 3.49038 1.6984 3.63126 1.60811 3.78882C1.42711 4.10466 1.35977 4.54755 1.35977 5.68515C1.35977 6.50759 1.40899 7.09799 1.52023 7.52607C1.62943 7.94627 1.79221 8.18711 2.00785 8.34187C2.23307 8.50355 2.55459 8.59983 3.03875 8.64975C3.52243 8.69959 4.12576 8.69995 4.89416 8.69995C5.66256 8.69995 6.26592 8.69959 6.7496 8.64975C7.23376 8.59983 7.55528 8.50355 7.78048 8.34187C7.99612 8.18711 8.15892 7.94627 8.26812 7.52607C8.37936 7.09799 8.42856 6.50759 8.42856 5.68515C8.42856 4.54751 8.36132 4.10462 8.1804 3.78877C8.09016 3.63122 7.96252 3.49036 7.76044 3.30378C7.67312 3.22316 7.57588 3.13752 7.4642 3.03916C7.44648 3.02354 7.42836 3.00761 7.40988 2.99132C7.2782 2.87523 7.13004 2.74386 6.965 2.591C6.86732 2.51212 6.76612 2.42676 6.66124 2.3383C6.4328 2.14561 6.18684 1.93817 5.92152 1.75073C5.52756 1.47242 5.17076 1.29995 4.88296 1.29995C4.59612 1.29995 4.2442 1.47244 3.85542 1.75116C3.60171 1.93306 3.36961 2.13075 3.15154 2.3165C3.03887 2.41246 2.92995 2.50524 2.82371 2.59101ZM3.50582 1.26354C3.90595 0.976667 4.39264 0.699951 4.88296 0.699951C5.37196 0.699951 5.8626 0.974479 6.26772 1.26067C6.55412 1.46299 6.8374 1.70175 7.0746 1.90162C7.17576 1.98687 7.26852 2.06505 7.34952 2.1303C7.35496 2.13468 7.36024 2.13924 7.36536 2.14398C7.52776 2.2946 7.67392 2.42423 7.80664 2.54122C7.82464 2.55709 7.84244 2.57277 7.86008 2.58828C7.97124 2.68616 8.07452 2.77711 8.16748 2.86294C8.38316 3.0621 8.56472 3.25258 8.70104 3.49054C8.9732 3.96569 9.02856 4.57039 9.02856 5.68515C9.02856 6.52011 8.97984 7.17275 8.84884 7.67699C8.71576 8.18903 8.49196 8.56975 8.13036 8.82931C7.77832 9.08199 7.33192 9.19291 6.81112 9.24659C6.29324 9.29995 5.65952 9.29995 4.90904 9.29995H4.87932C4.1288 9.29995 3.49509 9.29995 2.97723 9.24659C2.45643 9.19291 2.01002 9.08199 1.65798 8.82931C1.29637 8.56975 1.07258 8.18903 0.939518 7.67699C0.808494 7.17275 0.759766 6.52011 0.759766 5.68515C0.759766 4.57035 0.81523 3.96565 1.08753 3.49049C1.22389 3.25254 1.40549 3.06207 1.62123 2.86292C1.7141 2.77719 1.81727 2.68635 1.92829 2.5886C1.94603 2.57298 1.96396 2.55719 1.98209 2.54122C2.11481 2.42423 2.26097 2.2946 2.42337 2.14398C2.4285 2.13922 2.4338 2.13465 2.43925 2.13026C2.5241 2.06196 2.62312 1.97777 2.73174 1.88542C2.96133 1.69022 3.23379 1.45857 3.50582 1.26354Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_357_31607">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CartIconFill = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.35967 1.15629L1.36669 1.00364C1.19599 0.977703 1.03362 1.09294 1.00447 1.26685C0.975328 1.43693 1.0919 1.60276 1.25844 1.63253L1.88712 1.74308L2.27015 6.37832C2.31595 6.9396 2.77393 7.37289 3.32766 7.37289H7.86996C8.39871 7.37289 8.84836 6.97787 8.9233 6.44168L9.31883 3.65229C9.3563 3.39758 9.32715 3.11695 9.16062 2.92135C8.99408 2.72575 8.82754 2.63646 8.57357 2.63646H2.95087C2.81764 2.63646 2.70939 2.5344 2.6969 2.39791L2.6178 1.44544C2.60531 1.30086 2.50122 1.18223 2.35967 1.15629ZM6.05204 3.99783C5.91397 3.99783 5.80204 4.10976 5.80204 4.24783C5.80204 4.38591 5.91397 4.49783 6.05204 4.49783H7.20746C7.34553 4.49783 7.45746 4.38591 7.45746 4.24783C7.45746 4.10976 7.34553 3.99783 7.20746 3.99783H6.05204Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.98106 8.58447C4.10648 8.58447 4.20773 8.68614 4.20773 8.81114C4.20773 8.93656 4.10648 9.03822 3.98106 9.03822C3.85564 9.03822 3.75439 8.93656 3.75439 8.81114C3.75439 8.68614 3.85564 8.58447 3.98106 8.58447Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.98122 8.87606C4.01724 8.87606 4.04622 8.84679 4.04622 8.81106C4.04622 8.77609 4.01759 8.74647 3.98122 8.74647C3.94486 8.74647 3.91622 8.77609 3.91622 8.81106C3.91622 8.84679 3.94521 8.87606 3.98122 8.87606ZM3.46289 8.81106C3.46289 8.52533 3.69437 8.29272 3.98122 8.29272C4.26807 8.29272 4.49956 8.52532 4.49956 8.81106C4.49956 9.09686 4.26842 9.32981 3.98122 9.32981C3.69403 9.32981 3.46289 9.09686 3.46289 8.81106Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.01475 8.58447C7.14017 8.58447 7.24184 8.68614 7.24184 8.81114C7.24184 8.93656 7.14017 9.03822 7.01475 9.03822C6.88934 9.03822 6.78809 8.93656 6.78809 8.81114C6.78809 8.68614 6.88934 8.58447 7.01475 8.58447Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.01443 8.87606C7.05044 8.87606 7.07943 8.84679 7.07943 8.81106C7.07943 8.77609 7.05079 8.74647 7.01443 8.74647C6.97876 8.74647 6.94984 8.77539 6.94984 8.81106C6.94984 8.84749 6.97911 8.87606 7.01443 8.87606ZM6.49609 8.81106C6.49609 8.52533 6.72758 8.29272 7.01443 8.29272C7.30058 8.29272 7.53318 8.52463 7.53318 8.81106C7.53318 9.09756 7.30093 9.32981 7.01443 9.32981C6.72723 9.32981 6.49609 9.09686 6.49609 8.81106Z"
        fill={fill}
      />
    </svg>
  );
};

export const CartIconOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.81407 8.41772C3.93949 8.41772 4.04074 8.51939 4.04074 8.64439C4.04074 8.76981 3.93949 8.87147 3.81407 8.87147C3.68865 8.87147 3.5874 8.76981 3.5874 8.64439C3.5874 8.51939 3.68865 8.41772 3.81407 8.41772Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.81423 8.70931C3.85025 8.70931 3.87923 8.68004 3.87923 8.64431C3.87923 8.60934 3.8506 8.57973 3.81423 8.57973C3.77787 8.57973 3.74923 8.60934 3.74923 8.64431C3.74923 8.68004 3.77822 8.70931 3.81423 8.70931ZM3.2959 8.64431C3.2959 8.35858 3.52738 8.12598 3.81423 8.12598C4.10108 8.12598 4.33257 8.35858 4.33257 8.64431C4.33257 8.93011 4.10143 9.16306 3.81423 9.16306C3.52703 9.16306 3.2959 8.93011 3.2959 8.64431Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.84776 8.41772C6.97318 8.41772 7.07484 8.51939 7.07484 8.64439C7.07484 8.76981 6.97318 8.87147 6.84776 8.87147C6.72234 8.87147 6.62109 8.76981 6.62109 8.64439C6.62109 8.51939 6.72234 8.41772 6.84776 8.41772Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.84743 8.70931C6.88345 8.70931 6.91243 8.68004 6.91243 8.64431C6.91243 8.60934 6.8838 8.57973 6.84743 8.57973C6.81177 8.57973 6.78285 8.60864 6.78285 8.64431C6.78285 8.68074 6.81212 8.70931 6.84743 8.70931ZM6.3291 8.64431C6.3291 8.35858 6.56059 8.12598 6.84743 8.12598C7.13359 8.12598 7.36618 8.35788 7.36618 8.64431C7.36618 8.93081 7.13393 9.16306 6.84743 9.16306C6.56024 9.16306 6.3291 8.93011 6.3291 8.64431Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.19931 1.04546L2.06598 1.19561C2.20556 1.22021 2.31181 1.33616 2.3239 1.47796L2.42181 2.64618L2.78592 2.64633C2.84533 2.64636 2.90412 2.64639 2.96228 2.64641L3.63074 2.64673C3.68403 2.64676 3.73672 2.64678 3.78881 2.64681L4.5269 2.64722C4.57327 2.64724 4.61908 2.64727 4.66434 2.6473L5.18157 2.64763C5.22254 2.64766 5.263 2.64768 5.30293 2.64771L5.75785 2.64805C5.79377 2.64807 5.8292 2.6481 5.86415 2.64813L6.2608 2.64847C6.29199 2.6485 6.32274 2.64853 6.35303 2.64856L6.61373 2.64882C6.64139 2.64885 6.66862 2.64888 6.69543 2.6489L6.99733 2.64926C7.02088 2.64928 7.04403 2.64931 7.06678 2.64934L7.32169 2.6497C7.34145 2.64973 7.36085 2.64976 7.3799 2.64979L7.5419 2.65006C7.55888 2.65009 7.57552 2.65012 7.59184 2.65015L7.7723 2.65052C7.7861 2.65055 7.79959 2.65058 7.8128 2.65061L7.92386 2.65089C7.93536 2.65092 7.94658 2.65095 7.95754 2.65098L8.07661 2.65136C8.08553 2.65139 8.09421 2.65142 8.10266 2.65145L8.17257 2.65174C8.17968 2.65177 8.18657 2.6518 8.19326 2.65183L8.26398 2.65222C8.26912 2.65225 8.27407 2.65228 8.27886 2.65232L8.3174 2.65261C8.3212 2.65264 8.32485 2.65267 8.32836 2.65271L8.3561 2.653C8.35878 2.65304 8.36134 2.65307 8.36378 2.6531L8.38266 2.6534C8.38443 2.65343 8.38611 2.65347 8.3877 2.6535L8.39965 2.6538C8.40073 2.65384 8.40175 2.65387 8.4027 2.65391L8.41136 2.65431L8.41283 2.65442C8.41689 2.6548 8.41809 2.65493 8.41809 2.65493C8.65017 2.68872 8.85434 2.81008 8.9935 2.99693C9.13267 3.18336 9.19101 3.41317 9.15767 3.64339L8.76225 6.37854C8.68767 6.89904 8.236 7.2915 7.711 7.2915H3.16057C2.61181 7.2915 2.14723 6.86276 2.10264 6.31431L1.72098 1.77075L1.09306 1.66231C0.92264 1.63228 0.80889 1.47087 0.838057 1.30029C0.868057 1.12971 1.03264 1.01877 1.19931 1.04546ZM2.70233 3.27192L2.47431 3.27178L2.72556 6.26301C2.7439 6.49323 2.93181 6.6659 3.1614 6.6659H7.71017C7.92725 6.6659 8.11267 6.50408 8.1435 6.28928L8.53934 3.55372C8.5485 3.48866 8.53225 3.4236 8.49267 3.37104C8.4535 3.31808 8.396 3.28388 8.331 3.2747C8.328 3.27482 8.3208 3.27492 8.30962 3.27502L8.2643 3.27528C8.25482 3.27531 8.24439 3.27535 8.23305 3.27539L7.997 3.27574C7.97708 3.27576 7.95638 3.27577 7.9349 3.27578L7.37991 3.27576C7.34895 3.27575 7.31739 3.27573 7.28528 3.27572L6.6519 3.27533C6.61395 3.27531 6.57558 3.27528 6.53684 3.27525L6.17844 3.27496C6.13762 3.27493 6.09649 3.27489 6.05508 3.27486L5.67547 3.27452C5.63259 3.27448 5.58952 3.27445 5.54626 3.27441L5.28476 3.27417C5.24089 3.27412 5.19689 3.27408 5.15278 3.27404L4.75374 3.27367C4.70924 3.27363 4.66472 3.27359 4.6202 3.27354L4.35326 3.2733C4.30884 3.27326 4.26447 3.27321 4.22017 3.27317L3.9555 3.27293C3.91161 3.27289 3.86784 3.27285 3.82423 3.27282L3.43652 3.27248C3.39405 3.27245 3.35181 3.27241 3.30982 3.27238L2.81985 3.272C2.78031 3.27198 2.74113 3.27195 2.70233 3.27192ZM7.04096 4.18779C7.21346 4.18779 7.35346 4.32793 7.35346 4.5006C7.35346 4.67326 7.21346 4.8134 7.04096 4.8134H5.88595C5.71303 4.8134 5.57345 4.67326 5.57345 4.5006C5.57345 4.32793 5.71303 4.18779 5.88595 4.18779H7.04096Z"
        fill={fill}
      />
    </svg>
  );
};

export const TimeSquareIconFill = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5136 5.9605C6.4576 6.0545 6.358 6.1069 6.2556 6.1069C6.2036 6.1069 6.1504 6.0933 6.1024 6.0649L4.746 5.2557C4.6552 5.2017 4.5996 5.1033 4.5996 4.9981V3.2533C4.5996 3.0877 4.734 2.9533 4.8996 2.9533C5.0652 2.9533 5.1996 3.0877 5.1996 3.2533V4.8277L6.4096 5.5493C6.552 5.6345 6.5984 5.8185 6.5136 5.9605ZM4.9 1.1001C2.0204 1.1001 1 2.1205 1 5.0001C1 7.8793 2.0204 8.9001 4.9 8.9001C7.7796 8.9001 8.8 7.8793 8.8 5.0001C8.8 2.1205 7.7796 1.1001 4.9 1.1001Z"
        fill={fill}
      />
    </svg>
  );
};

export const TimeSquareIconOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.89732 1.89732C2.56443 1.23021 3.59596 1 4.99999 1C6.40403 1 7.43559 1.23021 8.10267 1.89732C8.76979 2.56443 8.99999 3.59596 8.99999 5C8.99999 6.40404 8.76979 7.43556 8.10267 8.10268C7.43559 8.7698 6.40403 9 4.99999 9C3.59596 9 2.56443 8.7698 1.89732 8.10268C1.23021 7.43556 1 6.40404 1 5C1 3.59596 1.23021 2.56443 1.89732 1.89732ZM2.32158 2.32158C1.83239 2.81077 1.6 3.62924 1.6 5C1.6 6.37076 1.83239 7.18924 2.32158 7.6784C2.81077 8.1676 3.62924 8.4 4.99999 8.4C6.37075 8.4 7.18923 8.1676 7.67843 7.6784C8.16759 7.18924 8.39999 6.37076 8.39999 5C8.39999 3.62924 8.16759 2.81077 7.67843 2.32158C7.18923 1.83239 6.37075 1.6 4.99999 1.6C3.62924 1.6 2.81077 1.83239 2.32158 2.32158Z"
        fill={fill}
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99971 2.95361C5.16539 2.95361 5.29971 3.08793 5.29971 3.25361V4.82766L6.50979 5.54958C6.65207 5.63446 6.69863 5.81862 6.61375 5.9609C6.52883 6.10322 6.34467 6.14974 6.20239 6.06486L4.84599 5.25566C4.75527 5.20154 4.69971 5.10366 4.69971 4.99802V3.25361C4.69971 3.08793 4.83403 2.95361 4.99971 2.95361Z"
        fill={fill}
      />
    </svg>
  );
};

export const SearchIconOutline = ({
  width,
  height,
  fill,
  className = '',
}: IconType) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 2.5C15.1944 2.5 19 6.30558 19 11C19 12.8588 18.4034 14.5782 17.3912 15.9772L21.682 20.2678L20.2678 21.682L16.0359 17.4503C14.5487 18.7279 12.6145 19.5 10.5 19.5C5.80558 19.5 2 15.6944 2 11C2 6.30558 5.80558 2.5 10.5 2.5ZM10.5 4.5C6.91015 4.5 4 7.41015 4 11C4 14.5899 6.91015 17.5 10.5 17.5C14.0899 17.5 17 14.5899 17 11C17 7.41015 14.0899 4.5 10.5 4.5Z"
        fill={fill}
      />
    </svg>
  );
};

export const ReceiptIconFill = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.65791 8.79083C4.86499 8.87499 5.08166 8.91749 5.29874 8.91749C5.51624 8.91749 5.73291 8.87499 5.93999 8.79083L6.83499 8.42624C6.97458 8.36874 7.13249 8.37416 7.26791 8.43916L7.58166 8.58916C7.80249 8.69624 8.05916 8.68124 8.26624 8.55041C8.47458 8.41958 8.59833 8.19416 8.59791 7.94791L8.59083 2.84333C8.59083 1.68917 7.92999 1 6.82291 1H3.78167C2.685 1 2.00375 1.70625 2.00375 2.84333L2 7.94874C1.99958 8.19499 2.12333 8.41999 2.33125 8.55124C2.53875 8.68124 2.795 8.69583 3.01542 8.58999L3.33167 8.43874C3.4675 8.37332 3.62542 8.36916 3.76458 8.42624L4.65791 8.79083ZM4.12052 3.79317C3.98245 3.79317 3.87052 3.9051 3.87052 4.04317C3.87052 4.18124 3.98245 4.29317 4.12052 4.29317H5.69187C5.82994 4.29317 5.94187 4.18124 5.94187 4.04317C5.94187 3.9051 5.82994 3.79317 5.69187 3.79317H4.12052ZM4.12052 5.6242C3.98245 5.6242 3.87052 5.73613 3.87052 5.8742C3.87052 6.01227 3.98245 6.1242 4.12052 6.1242H6.47753C6.6156 6.1242 6.72753 6.01227 6.72753 5.8742C6.72753 5.73613 6.6156 5.6242 6.47753 5.6242H4.12052Z"
        fill={fill}
      />
    </svg>
  );
};

export const ReceiptIconOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.55328 8.77174L6.41 8.42198C6.51856 8.37782 6.64028 8.38138 6.74488 8.43142L7.04884 8.57698C7.56752 8.82526 8.16792 8.44694 8.16728 7.87174L8.1634 2.96973C8.16336 2.43129 8.01292 1.95706 7.69108 1.61571C7.36676 1.27173 6.90396 1.1001 6.3568 1.1001H3.43706C2.88863 1.1001 2.42735 1.27173 2.10537 1.61685C1.78635 1.95881 1.63986 2.43278 1.63982 2.96951L1.63281 7.87046C1.63218 8.44562 2.23215 8.8251 2.75162 8.57622L3.05368 8.43162C3.15846 8.38126 3.27973 8.37758 3.38767 8.42178L4.24616 8.77162C4.66516 8.9431 5.13488 8.94258 5.55328 8.77174ZM5.32648 8.21626C5.05296 8.32794 4.74648 8.32814 4.47352 8.21638L3.61489 7.86646C3.35011 7.75818 3.05184 7.76686 2.79401 7.8907L2.49255 8.03502C2.37223 8.0927 2.23274 8.00518 2.23281 7.8713L2.23982 2.96973C2.23982 2.53745 2.35701 2.22669 2.5441 2.02615C2.72827 1.82873 3.01562 1.7001 3.43706 1.7001H6.3568C6.7768 1.7001 7.06732 1.82873 7.25452 2.0273C7.44412 2.22843 7.5634 2.53917 7.5634 2.96973L7.56728 7.8723C7.56744 8.00542 7.42836 8.09342 7.308 8.03582L7.004 7.89026C6.74596 7.76678 6.448 7.7587 6.18376 7.86626L5.32648 8.21626Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.46875 4.12104C3.46875 3.95536 3.60306 3.82104 3.76875 3.82104H5.27723C5.44291 3.82104 5.57723 3.95536 5.57723 4.12104C5.57723 4.28672 5.44291 4.42104 5.27723 4.42104H3.76875C3.60306 4.42104 3.46875 4.28672 3.46875 4.12104ZM3.46875 5.87884C3.46875 5.71316 3.60306 5.57884 3.76875 5.57884H6.03147C6.19715 5.57884 6.33147 5.71316 6.33147 5.87884C6.33147 6.04452 6.19715 6.17884 6.03147 6.17884H3.76875C3.60306 6.17884 3.46875 6.04452 3.46875 5.87884Z"
        fill={fill}
      />
    </svg>
  );
};

export const CloseSquareIconOutline = ({
  width,
  height,
  fill,
  stroke,
}: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1517_244)">
        <path
          d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.7142 12.4645L17.1787 16L20.7142 19.5355L19.5357 20.714L16.0002 17.1785L12.4646 20.714L11.2861 19.5355L14.8217 16L11.2861 12.4645L12.4646 11.286L16.0002 14.8215L19.5357 11.286L20.7142 12.4645Z"
          fill={stroke}
        />
      </g>
    </svg>
  );
};

export const CloseIconOutline = ({ width, height, stroke }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66663 4.6665L11.3333 11.3332"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3333 4.6665L4.66663 11.3332"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LeftCircleIconOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.4075 6.5352C4.8379 6.1448 3.8823 5.4132 3.8823 4.9C3.8823 4.3868 4.8379 3.6552 5.4075 3.2648C5.5443 3.1712 5.7311 3.206 5.8243 3.3428C5.9179 3.4788 5.8827 3.6668 5.7467 3.7596C5.1119 4.1948 4.5207 4.7336 4.4819 4.912C4.5207 5.0668 5.1119 5.6056 5.7467 6.0408C5.8827 6.1336 5.9179 6.3204 5.8243 6.4576C5.7311 6.594 5.5443 6.6288 5.4075 6.5352ZM8.8999 4.9C8.8999 2.0208 7.8795 1 4.9999 1C2.1207 1 1.0999 2.0208 1.0999 4.9C1.0999 7.7792 2.1207 8.8 4.9999 8.8C7.8795 8.8 8.8999 7.7792 8.8999 4.9Z"
        fill={fill}
      />
    </svg>
  );
};

export const DownCircleIconOutline = ({
  width,
  height,
  fill,
  className = '',
}: IconType) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_357_31537)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.72401 1.72401C2.43744 1.01057 3.53415 0.770996 5.00015 0.770996C6.46615 0.770996 7.56286 1.01057 8.2763 1.72401C8.98974 2.43745 9.22931 3.53415 9.22931 5.00015C9.22931 6.46616 8.98974 7.56287 8.2763 8.27631C7.56286 8.98975 6.46615 9.22932 5.00015 9.22932C3.53415 9.22932 2.43744 8.98975 1.72401 8.27631C1.01057 7.56287 0.770996 6.46616 0.770996 5.00015C0.770996 3.53415 1.01057 2.43745 1.72401 1.72401ZM2.25434 2.25434C1.7633 2.74537 1.521 3.57575 1.521 5.00015C1.521 6.42456 1.7633 7.25494 2.25434 7.74598C2.74537 8.23702 3.57575 8.47932 5.00015 8.47932C6.42456 8.47932 7.25493 8.23702 7.74597 7.74598C8.23701 7.25494 8.47931 6.42456 8.47931 5.00015C8.47931 3.57575 8.23701 2.74538 7.74597 2.25434C7.25493 1.7633 6.42456 1.521 5.00015 1.521C3.57575 1.521 2.74537 1.7633 2.25434 2.25434Z"
          fill="#B0B0B0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.65831 4.08992C6.82913 4.20703 6.87266 4.44044 6.75555 4.61125L6.44626 4.39921C6.75555 4.61125 6.75558 4.61121 6.75555 4.61125L6.75447 4.61282L6.75196 4.61647L6.74277 4.62972C6.73484 4.64112 6.72335 4.65754 6.70869 4.67825C6.67938 4.71966 6.6373 4.77838 6.58547 4.84868C6.48217 4.98881 6.33853 5.17713 6.17916 5.36674C6.02151 5.55431 5.84037 5.75289 5.66221 5.90776C5.5733 5.98505 5.47639 6.05919 5.37622 6.11579C5.28177 6.16915 5.15024 6.22671 5.00043 6.22671C4.85063 6.22671 4.7191 6.16916 4.62465 6.11581C4.52447 6.05923 4.42753 5.98511 4.33858 5.90782C4.16036 5.75297 3.97912 5.55441 3.82135 5.36684C3.66188 5.17723 3.51814 4.98892 3.41475 4.8488C3.36289 4.7785 3.32077 4.71978 3.29144 4.67837C3.27677 4.65766 3.26527 4.64124 3.25733 4.62984L3.24813 4.61659L3.24562 4.61295L3.2449 4.6119C3.24487 4.61186 3.24454 4.61138 3.55375 4.39921L3.24454 4.61138C3.12736 4.44061 3.1708 4.20718 3.34157 4.09C3.51232 3.97283 3.74572 4.01625 3.86291 4.18697C3.8629 4.18696 3.86292 4.18699 3.86291 4.18697L3.86332 4.18757L3.8651 4.19015L3.87276 4.20119C3.87965 4.21107 3.89 4.22586 3.90346 4.24486C3.9304 4.28289 3.96966 4.33764 4.01826 4.40352C4.11582 4.53574 4.24938 4.71055 4.39532 4.88407C4.54298 5.05963 4.69528 5.22419 4.8305 5.34168C4.89827 5.40057 4.95303 5.43992 4.99349 5.46277C4.99593 5.46415 4.99824 5.46543 5.00041 5.4666C5.00257 5.46543 5.00486 5.46417 5.00729 5.4628C5.04771 5.43996 5.10243 5.40062 5.17016 5.34174C5.30528 5.22427 5.45748 5.05972 5.60503 4.88417C5.75087 4.71066 5.88432 4.53585 5.98179 4.40363C6.03036 4.33776 6.06959 4.28301 6.0965 4.24498C6.10995 4.22598 6.12029 4.21119 6.12717 4.20131L6.13482 4.19028L6.1366 4.18769L6.13697 4.18716C6.13696 4.18718 6.13698 4.18715 6.13697 4.18716M6.65831 4.08992C6.48751 3.97281 6.25409 4.01639 6.13697 4.18716L6.65831 4.08992Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_357_31537">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PlusIconOutline = ({
  width,
  height,
  fill,
  className = '',
}: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.125 5C2.125 4.79289 2.29289 4.625 2.5 4.625H7.5C7.70711 4.625 7.875 4.79289 7.875 5C7.875 5.20711 7.70711 5.375 7.5 5.375H2.5C2.29289 5.375 2.125 5.20711 2.125 5Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 2.125C5.20711 2.125 5.375 2.29289 5.375 2.5V7.5C5.375 7.70711 5.20711 7.875 5 7.875C4.79289 7.875 4.625 7.70711 4.625 7.5V2.5C4.625 2.29289 4.79289 2.125 5 2.125Z"
        fill={fill}
      />
    </svg>
  );
};

export const NewPlusIconOutline = ({
  width,
  height,
  fill,
  className = '',
}: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7143 0C11.7675 0 11 0.767512 11 1.71429V10.2857H2.21429C1.26751 10.2857 0.5 11.0532 0.5 12C0.5 12.9468 1.26751 13.7143 2.21429 13.7143H11V22.2857C11 23.2325 11.7675 24 12.7143 24C13.6611 24 14.4286 23.2325 14.4286 22.2857V13.7143H22.7857C23.7325 13.7143 24.5 12.9468 24.5 12C24.5 11.0532 23.7325 10.2857 22.7857 10.2857H14.4286V1.71429C14.4286 0.767512 13.6611 0 12.7143 0Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7143 0C11.7675 0 11 0.767512 11 1.71429V10.2857H2.21429C1.26751 10.2857 0.5 11.0532 0.5 12C0.5 12.9468 1.26751 13.7143 2.21429 13.7143H11V22.2857C11 23.2325 11.7675 24 12.7143 24C13.6611 24 14.4286 23.2325 14.4286 22.2857V13.7143H22.7857C23.7325 13.7143 24.5 12.9468 24.5 12C24.5 11.0532 23.7325 10.2857 22.7857 10.2857H14.4286V1.71429C14.4286 0.767512 13.6611 0 12.7143 0Z"
        fill={fill}
      />
    </svg>
  );
};

export const MinusIconOutline = ({
  width,
  height,
  fill,
  className,
}: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.125 5C2.125 4.79289 2.29289 4.625 2.5 4.625H7.5C7.70711 4.625 7.875 4.79289 7.875 5C7.875 5.20711 7.70711 5.375 7.5 5.375H2.5C2.29289 5.375 2.125 5.20711 2.125 5Z"
        fill={fill}
      />
    </svg>
  );
};

export const DeleteIconOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.07692 3.63337C8.249 3.64754 8.37733 3.79795 8.36358 3.97004C8.36108 3.99837 8.13525 6.79462 8.00525 7.96754C7.92442 8.69546 7.44358 9.13837 6.71775 9.15171C6.16233 9.16129 5.6265 9.16671 5.10275 9.16671C4.53817 9.16671 3.98775 9.16045 3.44317 9.14921C2.7465 9.13546 2.26442 8.68379 2.18567 7.97045C2.05442 6.78712 1.82983 3.99795 1.82775 3.97004C1.81358 3.79795 1.94192 3.64712 2.114 3.63337C2.28358 3.62879 2.43692 3.74795 2.45067 3.91962C2.452 3.93771 2.54381 5.07672 2.64386 6.20367L2.66395 6.42856C2.71435 6.98871 2.76543 7.52697 2.80692 7.90171C2.8515 8.30712 3.07025 8.51629 3.45608 8.52421C4.49775 8.54629 5.56067 8.54754 6.7065 8.52671C7.1165 8.51879 7.33817 8.31379 7.384 7.89879C7.51317 6.73462 7.73817 3.94795 7.74067 3.91962C7.75442 3.74795 7.9065 3.62795 8.07692 3.63337ZM5.97725 0.833496C6.35975 0.833496 6.696 1.09141 6.79475 1.461L6.90058 1.98641C6.93478 2.15865 7.08594 2.28444 7.26095 2.2872L8.62833 2.28725C8.80083 2.28725 8.94083 2.42725 8.94083 2.59975C8.94083 2.77225 8.80083 2.91225 8.62833 2.91225L7.27316 2.91218C7.27106 2.91223 7.26895 2.91225 7.26683 2.91225L7.25667 2.91183L2.93401 2.9122C2.93065 2.91223 2.92728 2.91225 2.92392 2.91225L2.9175 2.91183L1.5625 2.91225C1.39 2.91225 1.25 2.77225 1.25 2.59975C1.25 2.42725 1.39 2.28725 1.5625 2.28725L2.92958 2.28683L2.97168 2.28417C3.12846 2.26382 3.25876 2.14475 3.29058 1.98641L3.39183 1.47975C3.49475 1.09141 3.831 0.833496 4.2135 0.833496H5.97725ZM5.97725 1.4585H4.2135C4.1135 1.4585 4.02558 1.52558 4.00017 1.62183L3.90308 2.10933C3.89074 2.17108 3.87278 2.23059 3.84979 2.28736H6.34109C6.31807 2.23059 6.30006 2.17108 6.28767 2.10933L6.18642 1.60266C6.16517 1.52558 6.07725 1.4585 5.97725 1.4585Z"
        fill={fill}
      />
    </svg>
  );
};

export const SquircleIconFill = ({ children, ...props }) => {
  return (
    <div className="relative">
      <svg
        width={props.width}
        height={props.height}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.40267e-07 20C7.70444e-07 5.00108 5.00108 0 20 0C34.9989 0 40 5.00108 40 20C40 34.9989 34.9989 40 20 40C5.00108 40 1.10091e-07 34.9989 4.40267e-07 20Z"
          fill={props.fill}
        />
      </svg>
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        {children}
      </div>
    </div>
  );
};

export const SquircleIconOutline = ({ children, ...props }) => {
  return (
    <div className="relative">
      <svg
        width={props.width}
        height={props.height}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 0.599998C12.5338 0.599998 7.74688 1.85246 4.79967 4.79967C1.85246 7.74688 0.600001 12.5338 0.6 20C0.6 27.4662 1.85246 32.2531 4.79967 35.2003C7.74688 38.1475 12.5338 39.4 20 39.4C27.4662 39.4 32.2531 38.1475 35.2003 35.2003C38.1475 32.2531 39.4 27.4662 39.4 20C39.4 12.5338 38.1475 7.74688 35.2003 4.79967C32.2531 1.85246 27.4662 0.599998 20 0.599998Z"
          stroke={props.stroke}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        {children}
      </div>
    </div>
  );
};
export const PlusSquareIcon = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1623_50230)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.02803 3.29834C5.19371 3.29834 5.32803 3.43265 5.32803 3.59834V6.45769C5.32803 6.62341 5.19371 6.75769 5.02803 6.75769C4.86235 6.75769 4.72803 6.62341 4.72803 6.45769V3.59834C4.72803 3.43265 4.86235 3.29834 5.02803 3.29834Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.29688 5.02803C3.29688 4.86235 3.43119 4.72803 3.59688 4.72803H6.45921C6.62489 4.72803 6.75921 4.86235 6.75921 5.02803C6.75921 5.19371 6.62489 5.32803 6.45921 5.32803H3.59688C3.43119 5.32803 3.29688 5.19371 3.29688 5.02803Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.19768 2.19744C1.67806 2.71705 1.4335 3.58421 1.4335 5.02798C1.4335 6.47178 1.67806 7.33894 2.19768 7.85854C2.7173 8.37818 3.58445 8.62274 5.02824 8.62274C6.472 8.62274 7.33916 8.37818 7.8588 7.85854C8.3784 7.33894 8.62296 6.47178 8.62296 5.02798C8.62296 3.58421 8.3784 2.71705 7.8588 2.19744C7.33916 1.67782 6.472 1.43325 5.02824 1.43325C3.58445 1.43325 2.7173 1.67782 2.19768 2.19744ZM1.77342 1.77317C2.47096 1.07563 3.55117 0.833252 5.02824 0.833252C6.50528 0.833252 7.58552 1.07563 8.28304 1.77317C8.9806 2.47071 9.22296 3.55093 9.22296 5.02798C9.22296 6.50506 8.9806 7.58526 8.28304 8.28282C7.58552 8.98034 6.50528 9.22274 5.02824 9.22274C3.55117 9.22274 2.47096 8.98034 1.77342 8.28282C1.07588 7.58526 0.833496 6.50506 0.833496 5.02798C0.833496 3.55093 1.07588 2.47071 1.77342 1.77317Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1623_50230">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LocationIcon = ({ width, height, stroke }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.50515 5.35525C7.50515 4.6646 6.9455 4.10498 6.25485 4.10498C5.56475 4.10498 5.00513 4.6646 5.00513 5.35525C5.00513 6.04535 5.56475 6.605 6.25485 6.605C6.9455 6.605 7.50515 6.04535 7.50515 5.35525Z"
        stroke={stroke}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.24975 10.5C4.80074 10.5 2.5 7.97935 2.5 5.2993C2.5 3.20123 4.17855 1.5 6.24975 1.5C8.32095 1.5 10 3.20123 10 5.2993C10 7.97935 7.69925 10.5 6.24975 10.5Z"
        stroke={stroke}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TickSquareIcon = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.4363 3.6721C6.55346 3.78926 6.55346 3.97918 6.4363 4.09634L4.5379 5.99474C4.42078 6.1119 4.23086 6.1119 4.1137 5.99478L3.16409 5.04558C3.0469 4.92846 3.04686 4.7385 3.16399 4.62134C3.28113 4.50414 3.47108 4.5041 3.58826 4.62126L4.32574 5.35842L6.01206 3.6721C6.12918 3.55494 6.31914 3.55494 6.4363 3.6721Z"
        fill={fill}
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.69712 1.73057C2.36423 1.06346 3.39576 0.833252 4.79982 0.833252C6.20386 0.833252 7.23538 1.06346 7.9025 1.73057C8.56958 2.39768 8.79982 3.42921 8.79982 4.83326C8.79982 6.2373 8.56958 7.26882 7.9025 7.93594C7.23538 8.60306 6.20386 8.83326 4.79982 8.83326C3.39576 8.83326 2.36423 8.60306 1.69712 7.93594C1.03001 7.26882 0.799805 6.2373 0.799805 4.83326C0.799805 3.42921 1.03001 2.39768 1.69712 1.73057ZM2.12138 2.15484C1.6322 2.64402 1.3998 3.46249 1.3998 4.83326C1.3998 6.20402 1.6322 7.0225 2.12138 7.51166C2.61057 8.00086 3.42904 8.23326 4.79982 8.23326C6.17058 8.23326 6.98902 8.00086 7.47822 7.51166C7.96742 7.0225 8.19982 6.20402 8.19982 4.83326C8.19982 3.46249 7.96742 2.64402 7.47822 2.15484C6.98902 1.66564 6.17058 1.43325 4.79982 1.43325C3.42904 1.43325 2.61057 1.66564 2.12138 2.15484Z"
        fill={fill}
      />
    </svg>
  );
};

export const TickFillIcon = ({
  className = '',
  width,
  height,
  fill,
}: IconType) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4583 6.84273L7.41834 9.88017C7.3281 9.97041 7.2065 10.021 7.07914 10.021C6.95178 10.021 6.82954 9.97041 6.7393 9.88017L5.22186 8.36145C5.03434 8.17393 5.03434 7.86993 5.22186 7.68241C5.41002 7.49489 5.71402 7.49617 5.9009 7.68241L7.07914 8.86193L9.7793 6.16367C9.96682 5.97615 10.2708 5.97679 10.4583 6.16367C10.6459 6.35119 10.6459 6.65521 10.4583 6.84273ZM7.8401 1.78223C3.23338 1.78223 1.6001 3.41551 1.6001 8.02225C1.6001 12.629 3.23338 14.2622 7.8401 14.2622C12.4468 14.2622 14.0801 12.629 14.0801 8.02225C14.0801 3.41551 12.4468 1.78223 7.8401 1.78223Z"
        fill={fill}
      />
    </svg>
  );
};

export const MoreSquareIcon = ({
  width,
  height,
  stroke,
  className = '',
}: IconType) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9956 12H16.9966"
        stroke={stroke}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9956 12H11.9966"
        stroke={stroke}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 12H7.001"
        stroke={stroke}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MoreSquareIconOutLine = ({
  width,
  height,
  className = '',
  stroke,
}: IconType) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75 12.0001C2.75 5.06312 5.063 2.75012 12 2.75012C18.937 2.75012 21.25 5.06312 21.25 12.0001C21.25 18.9371 18.937 21.2501 12 21.2501C5.063 21.2501 2.75 18.9371 2.75 12.0001Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9945 12H12.0035"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9935 12H16.0025"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99548 12H8.00448"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditIcon = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.4231 4.63515L6.91398 3.98121C7.15718 3.65721 7.25958 3.25801 7.20238 2.85681C7.14518 2.45561 6.93558 2.10121 6.61158 1.85801C5.94318 1.35641 4.99038 1.49121 4.48838 2.16041L1.78758 5.75839C0.982777 6.83159 1.69878 8.10999 1.72958 8.16399C1.77118 8.23639 1.84118 8.28799 1.92278 8.30679C1.94598 8.31239 2.16998 8.36199 2.48238 8.36199C2.98758 8.36199 3.72278 8.23279 4.21318 7.57919L6.36062 4.71839C6.3731 4.70667 6.38474 4.69367 6.39538 4.67951C6.40606 4.66531 6.4153 4.65047 6.4231 4.63515ZM2.19078 7.74319C2.50318 7.78119 3.29118 7.80799 3.73318 7.21879L5.73162 4.55647L4.26574 3.45589L2.26718 6.11839C1.81638 6.71999 2.06438 7.45639 2.19078 7.74319ZM4.62582 2.97625L6.0919 4.07651L6.43398 3.62081C6.73758 3.21681 6.65558 2.64121 6.25158 2.33761C5.84718 2.03481 5.27118 2.11681 4.96798 2.52041L4.62582 2.97625Z"
        fill={fill}
      />
      <path
        d="M7.89328 8.25723H5.34248C5.17688 8.25723 5.04248 8.12283 5.04248 7.95723C5.04248 7.79163 5.17688 7.65723 5.34248 7.65723H7.89328C8.05888 7.65723 8.19328 7.79163 8.19328 7.95723C8.19328 8.12283 8.05888 8.25723 7.89328 8.25723Z"
        fill={fill}
      />
    </svg>
  );
};

export const DeleteIcon = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.07692 3.63337C8.249 3.64754 8.37733 3.79795 8.36358 3.97004C8.36108 3.99837 8.13525 6.79462 8.00525 7.96754C7.92442 8.69546 7.44358 9.13837 6.71775 9.15171C6.16233 9.16129 5.6265 9.16671 5.10275 9.16671C4.53817 9.16671 3.98775 9.16045 3.44317 9.14921C2.7465 9.13546 2.26442 8.68379 2.18567 7.97045C2.05442 6.78712 1.82983 3.99795 1.82775 3.97004C1.81358 3.79795 1.94192 3.64712 2.114 3.63337C2.28358 3.62879 2.43692 3.74795 2.45067 3.91962C2.452 3.93771 2.54381 5.07672 2.64386 6.20367L2.66395 6.42856C2.71435 6.98871 2.76543 7.52697 2.80692 7.90171C2.8515 8.30712 3.07025 8.51629 3.45608 8.52421C4.49775 8.54629 5.56067 8.54754 6.7065 8.52671C7.1165 8.51879 7.33817 8.31379 7.384 7.89879C7.51317 6.73462 7.73817 3.94795 7.74067 3.91962C7.75442 3.74795 7.9065 3.62795 8.07692 3.63337ZM5.97725 0.833496C6.35975 0.833496 6.696 1.09141 6.79475 1.461L6.90058 1.98641C6.93478 2.15865 7.08594 2.28444 7.26095 2.2872L8.62833 2.28725C8.80083 2.28725 8.94083 2.42725 8.94083 2.59975C8.94083 2.77225 8.80083 2.91225 8.62833 2.91225L7.27316 2.91218C7.27106 2.91223 7.26895 2.91225 7.26683 2.91225L7.25667 2.91183L2.93401 2.9122C2.93065 2.91223 2.92728 2.91225 2.92392 2.91225L2.9175 2.91183L1.5625 2.91225C1.39 2.91225 1.25 2.77225 1.25 2.59975C1.25 2.42725 1.39 2.28725 1.5625 2.28725L2.92958 2.28683L2.97168 2.28417C3.12846 2.26382 3.25876 2.14475 3.29058 1.98641L3.39183 1.47975C3.49475 1.09141 3.831 0.833496 4.2135 0.833496H5.97725ZM5.97725 1.4585H4.2135C4.1135 1.4585 4.02558 1.52558 4.00017 1.62183L3.90308 2.10933C3.89074 2.17108 3.87278 2.23059 3.84979 2.28736H6.34109C6.31807 2.23059 6.30006 2.17108 6.28767 2.10933L6.18642 1.60266C6.16517 1.52558 6.07725 1.4585 5.97725 1.4585Z"
        fill={fill}
      />
    </svg>
  );
};
export const TrushIcon = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 5H10V7H8V5C8 3.94564 8.81588 3.08183 9.85074 3.00549L10 3H14C15.0544 3 15.9182 3.81588 15.9945 4.85074L16 5V7H21V9H19V19C19 20.0544 18.1841 20.9182 17.1493 20.9945L17 21H7C5.94564 21 5.08183 20.1841 5.00549 19.1493L5 19V9H3V7H14V5ZM17 9H7V19H17V9Z"
        fill={fill}
      />
    </svg>
  );
};

export const TickIcon = ({
  width,
  height,
  stroke,
  className = '',
}: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6665 5.13867L3.88936 7.36058L8.33317 2.91675"
        stroke={stroke}
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SwapFill = ({ width, height, stroke, className }: IconType) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.41943 10.0821V3.27319"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4581 8.03418L8.41926 10.0825L6.38037 8.03418"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.45557 1.9165V8.72539"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.4165 3.96459L3.45539 1.91626L5.49428 3.96459"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WorkIcon = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.81758 5.40869C4.98326 5.40869 5.11758 5.54301 5.11758 5.70869V6.75989C5.11758 6.92557 4.98326 7.05989 4.81758 7.05989C4.6519 7.05989 4.51758 6.92557 4.51758 6.75989V5.70869C4.51758 5.54301 4.6519 5.40869 4.81758 5.40869Z"
        fill={fill}
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.920468 4.57233C1.01548 4.43661 1.20254 4.40357 1.33828 4.49861L1.34299 4.50189C2.25836 5.06385 3.47539 5.40997 4.81584 5.40997C6.15544 5.40997 7.3752 5.06429 8.29068 4.50313L8.29308 4.50137C8.42728 4.40421 8.61484 4.43421 8.712 4.56841C8.8092 4.70261 8.7792 4.89017 8.645 4.98733L8.6334 4.99573C8.62736 5.00013 8.62112 5.00429 8.6148 5.00821C7.59368 5.63721 6.25884 6.00997 4.81584 6.00997C3.37268 6.00997 2.04144 5.63713 1.02084 5.00817C1.01587 5.00509 1.01098 5.00189 1.0062 4.99853L0.9942 4.99013C0.858464 4.89513 0.825452 4.70805 0.920468 4.57233Z"
        fill={fill}
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.13902 3.15419C1.66222 3.57881 1.4335 4.28681 1.4335 5.49357C1.4335 6.70033 1.66222 7.40829 2.13902 7.83292C2.62637 8.26692 3.44745 8.47476 4.81788 8.47476C6.18856 8.47476 7.00964 8.26692 7.49692 7.83292C7.97368 7.40833 8.20228 6.70037 8.20228 5.49357C8.20228 4.28677 7.97368 3.57879 7.49692 3.15418C7.00964 2.72018 6.18856 2.51235 4.81788 2.51235C3.44745 2.51235 2.62637 2.72017 2.13902 3.15419ZM1.73998 2.70612C2.40403 2.11474 3.42514 1.91235 4.81788 1.91235C6.21084 1.91235 7.23196 2.11473 7.89596 2.70613C8.57052 3.30692 8.80228 4.23957 8.80228 5.49357C8.80228 6.74757 8.57052 7.6802 7.89596 8.28096C7.23196 8.87236 6.21084 9.07476 4.81788 9.07476C3.42514 9.07476 2.40403 8.87236 1.73998 8.281C1.06538 7.6802 0.833496 6.7476 0.833496 5.49357C0.833496 4.23953 1.06538 3.3069 1.73998 2.70612Z"
        fill={fill}
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.21289 2.04885C3.21289 1.40804 3.68749 0.833252 4.33688 0.833252H5.29888C5.94828 0.833252 6.42288 1.40804 6.42288 2.04885V2.30085C6.42288 2.46654 6.28856 2.60085 6.12288 2.60085C5.9572 2.60085 5.82288 2.46654 5.82288 2.30085V2.04885C5.82288 1.67846 5.55908 1.43325 5.29888 1.43325H4.33688C4.07668 1.43325 3.81289 1.67846 3.81289 2.04885V2.30085C3.81289 2.46654 3.67857 2.60085 3.51289 2.60085C3.34721 2.60085 3.21289 2.46654 3.21289 2.30085V2.04885Z"
        fill={fill}
      />
    </svg>
  );
};

export const WalletIconOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.97732 4.23747C6.5838 4.23747 6.26504 4.55647 6.26504 4.94971C6.26504 5.34343 6.58388 5.66235 6.97732 5.66235H8.50016C8.66588 5.66235 8.80016 5.79667 8.80016 5.96235C8.80016 6.12807 8.66588 6.26235 8.50016 6.26235H6.97732C6.2522 6.26235 5.66504 5.67451 5.66504 4.94971C5.66504 4.22523 6.25228 3.63745 6.97732 3.63745H8.50016C8.66588 3.63745 8.80016 3.77177 8.80016 3.93745C8.80016 4.10314 8.66588 4.23747 8.50016 4.23747H6.97732Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.59717 4.92817C6.59717 4.76249 6.73149 4.62817 6.89717 4.62817H6.89833C7.06401 4.62817 7.19833 4.76249 7.19833 4.92817C7.19833 5.09385 7.06401 5.22817 6.89833 5.22817H6.89717C6.73149 5.22817 6.59717 5.09385 6.59717 4.92817Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.27432 1.975C2.34952 1.975 1.6 2.72452 1.6 3.64932V6.34908C1.6 7.27388 2.34952 8.0234 3.27432 8.0234H6.52556C7.45036 8.0234 8.19988 7.27388 8.19988 6.34908V3.64932C8.19988 2.72452 7.45036 1.975 6.52556 1.975H3.27432ZM1 3.64932C1 2.39315 2.01815 1.375 3.27432 1.375H6.52556C7.78172 1.375 8.79988 2.39315 8.79988 3.64932V6.34908C8.79988 7.60524 7.78172 8.6234 6.52556 8.6234H3.27432C2.01815 8.6234 1 7.60524 1 6.34908V3.64932Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.70654 3.38276C2.70654 3.21708 2.84086 3.08276 3.00654 3.08276H5.03806C5.20374 3.08276 5.33806 3.21708 5.33806 3.38276C5.33806 3.54845 5.20374 3.68276 5.03806 3.68276H3.00654C2.84086 3.68276 2.70654 3.54845 2.70654 3.38276Z"
        fill={fill}
      />
    </svg>
  );
};

export const LocationIconOutlineSmall = ({ width, height, fill }: IconType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 11 11"
      fill={fill}
    >
      <path
        d="M7.50515 5.35525C7.50515 4.6646 6.9455 4.10498 6.25485 4.10498C5.56475 4.10498 5.00513 4.6646 5.00513 5.35525C5.00513 6.04535 5.56475 6.605 6.25485 6.605C6.9455 6.605 7.50515 6.04535 7.50515 5.35525Z"
        stroke="#3D3D3D"
      />
      <path
        d="M6.24975 10.5C4.80074 10.5 2.5 7.97935 2.5 5.2993C2.5 3.20123 4.17855 1.5 6.24975 1.5C8.32095 1.5 10 3.20123 10 5.2993C10 7.97935 7.69925 10.5 6.24975 10.5Z"
        stroke="#3D3D3D"
      />
    </svg>
  );
};

export const DiscountIconOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.15508 2.15484C1.66589 2.64402 1.4335 3.46249 1.4335 4.83326C1.4335 6.20402 1.66589 7.0225 2.15508 7.51166C2.64427 8.00086 3.46274 8.23326 4.83348 8.23326C6.20424 8.23326 7.02272 8.00086 7.51192 7.51166C8.00112 7.0225 8.23348 6.20402 8.23348 4.83326C8.23348 3.46249 8.00112 2.64402 7.51192 2.15484C7.02272 1.66564 6.20424 1.43325 4.83348 1.43325C3.46274 1.43325 2.64427 1.66564 2.15508 2.15484ZM1.73082 1.73057C2.39793 1.06346 3.42946 0.833252 4.83348 0.833252C6.23752 0.833252 7.26908 1.06346 7.93616 1.73057C8.60328 2.39768 8.83348 3.42921 8.83348 4.83326C8.83348 6.2373 8.60328 7.26882 7.93616 7.93594C7.26908 8.60306 6.23752 8.83326 4.83348 8.83326C3.42946 8.83326 2.39793 8.60306 1.73082 7.93594C1.0637 7.26882 0.833496 6.2373 0.833496 4.83326C0.833496 3.42921 1.0637 2.39768 1.73082 1.73057Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.07352 3.59324C6.19068 3.71041 6.19068 3.90033 6.07352 4.01749L4.0175 6.07349C3.90035 6.19065 3.71039 6.19065 3.59324 6.07349C3.47608 5.95633 3.47608 5.76641 3.59324 5.64925L5.64924 3.59324C5.7664 3.47608 5.95636 3.47608 6.07352 3.59324Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.43164 5.83335C5.43164 5.61243 5.61072 5.43335 5.83164 5.43335H5.83524C6.05616 5.43335 6.23524 5.61243 6.23524 5.83335C6.23524 6.05427 6.05616 6.23335 5.83524 6.23335H5.83164C5.61072 6.23335 5.43164 6.05427 5.43164 5.83335Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.43164 3.83335C3.43164 3.61244 3.61072 3.43335 3.83164 3.43335H3.83524C4.05616 3.43335 4.23524 3.61244 4.23524 3.83335C4.23524 4.05427 4.05616 4.23335 3.83524 4.23335H3.83164C3.61072 4.23335 3.43164 4.05427 3.43164 3.83335Z"
        fill={fill}
      />
    </svg>
  );
};

export const HeadsetIconOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.03786 7.76951C6.91374 7.76967 6.7911 7.74211 6.67894 7.68891C6.56678 7.63571 6.4679 7.55815 6.38946 7.46191C6.3045 7.35959 6.24466 7.23875 6.21474 7.10915C6.18482 6.97955 6.18562 6.84475 6.21706 6.71551L6.57986 5.19551C6.61058 5.06523 6.67158 4.94403 6.7579 4.84175C6.84418 4.73943 6.95342 4.65891 7.07666 4.60671C7.19794 4.55383 7.32998 4.53031 7.46202 4.53807C7.5941 4.54587 7.72246 4.58475 7.83666 4.65151C8.15574 4.83507 8.40522 5.11891 8.54626 5.45891C8.68734 5.79891 8.7121 6.17603 8.61666 6.53151C8.5383 6.83147 8.37706 7.10331 8.15138 7.31591C7.92574 7.52847 7.64478 7.67319 7.34066 7.73351C7.2535 7.75091 7.1651 7.76151 7.07626 7.76511C7.06226 7.76951 7.04986 7.76951 7.03786 7.76951ZM7.41306 5.13911C7.37866 5.13955 7.3447 5.14679 7.31306 5.16031C7.27598 5.17595 7.24314 5.20011 7.21714 5.23083C7.19114 5.26155 7.17274 5.29795 7.16346 5.33711L6.80066 6.85711C6.79118 6.89619 6.79098 6.93691 6.79998 6.97607C6.80902 7.01523 6.82706 7.05175 6.85266 7.08271C6.87618 7.11175 6.90614 7.13491 6.94014 7.15031C6.97418 7.16575 7.01134 7.17299 7.04866 7.17151C7.1071 7.16899 7.1653 7.16203 7.22266 7.15071C7.41526 7.11103 7.59306 7.01871 7.7363 6.88395C7.87954 6.74919 7.98254 6.57735 8.03386 6.38751C8.09574 6.15851 8.0803 5.91547 7.98998 5.69611C7.89966 5.47679 7.73946 5.29335 7.53426 5.17431C7.49766 5.15215 7.45586 5.13999 7.41306 5.13911Z"
        fill={fill}
      />
      <path
        d="M5.31514 8.83579C5.21834 8.83579 5.12074 8.83339 5.02234 8.83099C4.92394 8.82859 4.81354 8.82539 4.70234 8.82539C4.62274 8.82539 4.54646 8.79379 4.49022 8.73751C4.43394 8.68127 4.40234 8.60495 4.40234 8.52539C4.40234 8.44583 4.43394 8.36951 4.49022 8.31323C4.54646 8.25699 4.62274 8.22539 4.70234 8.22539C4.81754 8.22539 4.92874 8.22819 5.03634 8.23099C5.78354 8.25099 6.19634 8.26099 6.69434 7.32899C6.7121 7.29291 6.73698 7.26075 6.76746 7.23447C6.7979 7.20819 6.83334 7.18831 6.87166 7.17599C6.90994 7.16371 6.95034 7.15923 6.99042 7.16283C7.03046 7.16647 7.06942 7.17811 7.1049 7.19707C7.14038 7.21603 7.17166 7.24195 7.19694 7.27327C7.22218 7.30459 7.2409 7.34067 7.25194 7.37939C7.26294 7.41807 7.2661 7.45859 7.26114 7.49851C7.25618 7.53843 7.24326 7.57695 7.22314 7.61179C6.63554 8.71299 5.99314 8.83579 5.31514 8.83579Z"
        fill={fill}
      />
      <path
        d="M2.76076 7.77017C2.74836 7.77017 2.73597 7.77017 2.72397 7.77017C2.36261 7.75473 2.01604 7.62233 1.73642 7.39293C1.4568 7.16353 1.25927 6.84949 1.17354 6.49809C1.08782 6.14673 1.11854 5.77701 1.26109 5.44461C1.40364 5.11217 1.65031 4.83505 1.96396 4.65497C2.07822 4.58829 2.20662 4.54957 2.33869 4.54193C2.47076 4.53429 2.60277 4.55793 2.72397 4.61097C2.84705 4.66309 2.95611 4.74349 3.04229 4.84565C3.12847 4.94781 3.18934 5.06885 3.21996 5.19897L3.58356 6.71897C3.61489 6.84825 3.61554 6.98309 3.58547 7.11269C3.5554 7.24229 3.49544 7.36305 3.41037 7.46537C3.33164 7.56133 3.23245 7.63853 3.12006 7.69129C3.00767 7.74401 2.88491 7.77097 2.76076 7.77017ZM2.26396 5.17297C2.05876 5.29201 1.89858 5.47541 1.80825 5.69477C1.71792 5.91413 1.70249 6.15713 1.76436 6.38617C1.81565 6.57589 1.91861 6.74769 2.06176 6.88237C2.20492 7.01705 2.38265 7.10933 2.57516 7.14897C2.63266 7.16053 2.69097 7.16761 2.74957 7.17017C2.78678 7.17081 2.82367 7.16321 2.85758 7.14785C2.89148 7.13249 2.92153 7.10977 2.94556 7.08137C2.97121 7.05049 2.98931 7.01405 2.99841 6.97497C3.0075 6.93585 3.00735 6.89521 2.99797 6.85617L2.63437 5.33617C2.62523 5.29709 2.60698 5.26077 2.58112 5.23013C2.55526 5.19945 2.52252 5.17537 2.48556 5.15977C2.45018 5.14441 2.41169 5.13761 2.37319 5.13989C2.33469 5.14217 2.29726 5.15353 2.26396 5.17297Z"
        fill={fill}
      />
      <path
        d="M7.83963 5.31761C7.80019 5.31769 7.76119 5.30997 7.72475 5.29489C7.68831 5.27985 7.65523 5.25773 7.6274 5.22989C7.59951 5.20201 7.57739 5.16893 7.56235 5.13249C7.54731 5.09609 7.53955 5.05705 7.53963 5.01761V4.27561C7.53963 3.57513 7.26135 2.90333 6.76603 2.40801C6.27071 1.91268 5.59891 1.63442 4.89843 1.63442C4.19795 1.63442 3.52614 1.91268 3.03082 2.40801C2.5355 2.90333 2.25723 3.57513 2.25723 4.27561V5.01641C2.25723 5.09597 2.22562 5.17229 2.16936 5.22857C2.1131 5.28481 2.03679 5.31641 1.95723 5.31641C1.87766 5.31641 1.80135 5.28481 1.74509 5.22857C1.68883 5.17229 1.65723 5.09597 1.65723 5.01641V4.27561C1.65723 3.416 1.99871 2.5916 2.60655 1.98375C3.2144 1.37591 4.03879 1.03442 4.89843 1.03442C5.75803 1.03442 6.58247 1.37591 7.19031 1.98375C7.79815 2.5916 8.13963 3.416 8.13963 4.27561V5.01641C8.13979 5.05593 8.13215 5.09505 8.11715 5.13161C8.10211 5.16813 8.08007 5.20133 8.05219 5.22933C8.02431 5.25733 7.99119 5.27953 7.95471 5.29469C7.91823 5.30985 7.87911 5.31761 7.83963 5.31761Z"
        fill={fill}
      />
    </svg>
  );
};

export const InfoIconOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.51192 7.51169C8.00112 7.02249 8.23348 6.20401 8.23348 4.83325C8.23348 3.46249 8.00112 2.64402 7.51192 2.15483C7.02272 1.66564 6.20424 1.43325 4.83348 1.43325C3.46274 1.43325 2.64427 1.66564 2.15508 2.15483C1.66589 2.64402 1.4335 3.46249 1.4335 4.83325C1.4335 6.20401 1.66589 7.02249 2.15508 7.51169C2.64427 8.00085 3.46274 8.23325 4.83348 8.23325C6.20424 8.23325 7.02272 8.00085 7.51192 7.51169ZM7.93616 7.93593C7.26908 8.60305 6.23752 8.83325 4.83348 8.83325C3.42946 8.83325 2.39793 8.60305 1.73082 7.93593C1.0637 7.26881 0.833496 6.23729 0.833496 4.83325C0.833496 3.42921 1.0637 2.39768 1.73082 1.73057C2.39793 1.06346 3.42946 0.833252 4.83348 0.833252C6.23752 0.833252 7.26908 1.06346 7.93616 1.73057C8.60328 2.39768 8.83348 3.42921 8.83348 4.83325C8.83348 6.23729 8.60328 7.26881 7.93616 7.93593Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.8332 6.69145C4.66752 6.69145 4.5332 6.55713 4.5332 6.39145V4.83345C4.5332 4.66777 4.66752 4.53345 4.8332 4.53345C4.99892 4.53345 5.1332 4.66777 5.1332 4.83345V6.39145C5.1332 6.55713 4.99892 6.69145 4.8332 6.69145Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.13485 3.4333C5.13485 3.59898 5.00057 3.7333 4.83485 3.7333H4.83125C4.66557 3.7333 4.53125 3.59898 4.53125 3.4333C4.53125 3.26762 4.66557 3.1333 4.83125 3.1333H4.83485C5.00057 3.1333 5.13485 3.26762 5.13485 3.4333Z"
        fill={fill}
      />
    </svg>
  );
};

export const LogoutIconOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 4.88154C6.25 4.71586 6.11568 4.58154 5.95 4.58154H1.1336C0.96792 4.58154 0.8336 4.71586 0.8336 4.88154C0.8336 5.04722 0.96792 5.18154 1.1336 5.18154H5.95C6.11568 5.18154 6.25 5.04722 6.25 4.88154Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.51706 3.50359C2.40014 3.38619 2.21018 3.3858 2.09278 3.50271L0.921581 4.66912C0.865061 4.7254 0.833262 4.80192 0.833262 4.88168C0.833262 4.96148 0.865061 5.03796 0.921581 5.09424L2.09278 6.26064C2.21018 6.37756 2.40014 6.37716 2.51706 6.2598C2.63398 6.1424 2.63358 5.95244 2.51618 5.83552L1.55842 4.88168L2.51618 3.92785C2.63358 3.81093 2.63398 3.62099 2.51706 3.50359Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.13527 1.81329C3.82459 2.04351 3.66927 2.41987 3.60539 3.11279C3.59019 3.27778 3.44411 3.39919 3.27911 3.38398C3.11415 3.36878 2.99271 3.2227 3.00795 3.05772C3.07607 2.31863 3.25475 1.719 3.77807 1.33122C4.27979 0.959432 5.03571 0.833252 6.10667 0.833252C7.5266 0.833252 8.39962 1.05587 8.84764 1.78523C9.06118 2.13285 9.15554 2.56337 9.2014 3.05621C9.24707 3.54711 9.24707 4.13685 9.24707 4.82061V4.84589C9.24707 5.52965 9.24707 6.11941 9.2014 6.61029C9.15554 7.10313 9.06118 7.53365 8.84764 7.88129C8.39962 8.61065 7.5266 8.83325 6.10667 8.83325C5.03571 8.83325 4.27979 8.70709 3.77807 8.33529C3.25475 7.94753 3.07607 7.34789 3.00795 6.60881C2.99271 6.44381 3.11415 6.29773 3.27911 6.28253C3.44411 6.26733 3.59019 6.38873 3.60539 6.55373C3.66927 7.24665 3.82459 7.62301 4.13527 7.85321C4.46755 8.09945 5.04563 8.23325 6.10667 8.23325C7.52714 8.23325 8.07432 7.99389 8.33639 7.56725C8.47791 7.33685 8.56107 7.01589 8.60398 6.55473C8.64678 6.09465 8.64707 5.53213 8.64707 4.83325C8.64707 4.13437 8.64678 3.57187 8.60398 3.1118C8.56107 2.65063 8.47791 2.32965 8.33639 2.09928C8.07432 1.67264 7.52714 1.43325 6.10667 1.43325C5.04563 1.43325 4.46755 1.56707 4.13527 1.81329Z"
        fill={fill}
      />
    </svg>
  );
};

export const StarIconFill = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icons/Star">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.97053 5.04395C9.80761 4.35086 9.08436 4.31507 8.50297 4.28601C8.13714 4.26749 7.75867 4.24896 7.60038 4.08516C7.43914 3.91842 7.31326 3.59882 7.19076 3.28975C6.95206 2.68509 6.68136 2 5.99978 2C5.31863 2 5.04837 2.68509 4.80924 3.28975C4.68716 3.59882 4.56086 3.91842 4.40004 4.08516C4.24133 4.24896 3.86287 4.26749 3.49703 4.28601C2.91564 4.31507 2.19239 4.35086 2.02947 5.04395C1.87496 5.70167 2.35784 6.09959 2.78388 6.45076C3.0752 6.69077 3.35052 6.91816 3.41157 7.19606C3.47093 7.46597 3.38168 7.81462 3.29537 8.15232C3.14719 8.73299 2.97879 9.39071 3.54081 9.81473C3.71636 9.94737 3.89444 10 4.07041 10C4.45141 10 4.82272 9.75409 5.14055 9.54356C5.43482 9.34902 5.73919 9.14732 5.99978 9.14732C6.26037 9.14732 6.56517 9.34902 6.85902 9.54356C7.32421 9.85136 7.90265 10.2337 8.45961 9.81473C9.02163 9.39071 8.85323 8.73257 8.70463 8.15148C8.61832 7.8142 8.5295 7.46555 8.58843 7.19606C8.64948 6.91816 8.9248 6.6912 9.21612 6.45076C9.64216 6.09959 10.125 5.70167 9.97053 5.04395Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export const WarningIconOutline = ({
  className = '',
  width,
  height,
  stroke,
}: IconType) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Type=Round , Style=Linear">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.2502 11.9999C21.2502 18.9369 18.9372 21.2499 12.0002 21.2499C5.06324 21.2499 2.75024 18.9369 2.75024 11.9999C2.75024 5.06288 5.06324 2.74988 12.0002 2.74988C18.9372 2.74988 21.2502 5.06288 21.2502 11.9999Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M12.0002 15.895V12"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M12.0045 8.5H11.9955"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const RefreshIcon = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.0102 2.65405C5.48765 1.73725 7.37021 1.93645 8.63453 3.01933L8.36669 3.28861C8.26973 3.38653 8.23709 3.53101 8.28221 3.66109C8.32781 3.79117 8.44349 3.88429 8.58029 3.90013L9.74861 4.03597C9.76253 4.03741 9.77693 4.03837 9.79037 4.03837C9.88301 4.03837 9.97373 4.00237 10.0409 3.93661C10.1187 3.86173 10.1585 3.75517 10.1489 3.64765L10.0457 2.43901C10.0342 2.29933 9.94157 2.17933 9.81005 2.13133C9.67949 2.08333 9.53069 2.11645 9.43181 2.21581L9.14141 2.50861C7.64477 1.19869 5.39549 0.948615 3.63052 2.04253C2.335 2.84605 1.5166 4.23614 1.44172 5.76013C1.43212 5.95885 1.58524 6.1278 1.78348 6.1374C1.78972 6.1374 1.79596 6.13789 1.80172 6.13789C1.99228 6.13789 2.15164 5.98813 2.16076 5.79517C2.22412 4.50781 2.9158 3.33325 4.0102 2.65405Z"
        fill={fill}
      />
      <path
        id="Vector_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4565 5.86119C10.2625 5.84919 10.0883 6.00423 10.0792 6.20295C10.0158 7.49079 9.32462 8.66487 8.22974 9.34407C6.75278 10.2604 4.87022 10.0617 3.60543 8.97927L3.87327 8.70951C3.97023 8.61159 4.00335 8.46711 3.95775 8.33703C3.91215 8.20695 3.79647 8.11431 3.65967 8.09847L2.49135 7.96215C2.38143 7.95015 2.27631 7.98663 2.19903 8.06151C2.12175 8.13687 2.08191 8.24295 2.09103 8.35095L2.19423 9.55959C2.20623 9.69927 2.29839 9.81927 2.42991 9.86727C2.46975 9.88167 2.51151 9.88887 2.55279 9.88887C2.64687 9.88887 2.73951 9.85191 2.80815 9.78231L3.09903 9.48999C3.95679 10.2407 5.0603 10.6458 6.18062 10.6458C7.01486 10.6458 7.85678 10.4231 8.60942 9.95607C9.90542 9.15207 10.7238 7.76247 10.7982 6.23847C10.8078 6.03975 10.6547 5.87079 10.4565 5.86119Z"
        fill={fill}
      />
    </svg>
  );
};

export const CategoryIconFill = ({
  className = '',
  width,
  height,
  fill,
}: IconType) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12C0 20.9993 3.00065 24 12 24C20.9993 24 24 20.9993 24 12C24 3.00065 20.9993 0 12 0C3.00065 0 0 3.00065 0 12Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9762 15.2917H10.9344C10.7026 15.2917 10.5145 15.1036 10.5145 14.8717C10.5145 14.6399 10.7026 14.4517 10.9344 14.4517H12.9762C13.208 14.4517 13.3962 14.6399 13.3962 14.8717C13.3962 15.1036 13.208 15.2917 12.9762 15.2917ZM13.7746 12.6593C13.7125 12.6161 13.6299 12.6162 13.5679 12.6594C13.1163 12.9738 12.5732 13.1648 11.9822 13.1648C11.3907 13.1648 10.848 12.9738 10.396 12.6593C10.334 12.6162 10.2514 12.6161 10.1894 12.6593C9.73861 12.9729 9.20131 13.1648 8.62446 13.1648C8.25987 13.1648 7.91582 13.0883 7.59804 12.9585C7.48151 12.9109 7.34766 12.9929 7.34766 13.1187V14.3128C7.34766 15.9374 8.39038 17.0288 9.94158 17.0288H14.0217C15.574 17.0288 16.6167 15.9374 16.6167 14.3128V13.1113C16.6167 12.9847 16.4815 12.9028 16.3647 12.9518C16.0458 13.0856 15.7019 13.1648 15.3405 13.1648C14.7632 13.1648 14.2254 12.9729 13.7746 12.6593Z"
        fill="#F6F6F6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7872 7.88541C16.5593 7.20501 15.9242 6.74805 15.2074 6.74805H8.75174C8.03158 6.74805 7.39542 7.20781 7.16974 7.89269C6.97094 8.50085 6.66406 9.83645 6.66406 10.3656C6.66406 11.4459 7.54382 12.3257 8.62574 12.3257C9.23027 12.3257 9.77721 12.0323 10.139 11.5857C10.2189 11.487 10.3802 11.4878 10.4595 11.5869C10.8182 12.0356 11.3654 12.3257 11.9835 12.3257C12.6016 12.3257 13.1488 12.0351 13.5075 11.5863C13.5868 11.4872 13.7481 11.4864 13.828 11.5851C14.1898 12.0319 14.7368 12.3257 15.3418 12.3257C16.4053 12.3257 17.3041 11.428 17.3041 10.3656C17.3041 9.83477 16.9905 8.49525 16.7872 7.88541Z"
        fill="#F6F6F6"
      />
    </svg>
  );
};

export const DeliveryIconFill = ({
  className = '',
  width,
  height,
  fill,
}: IconType) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 12C0.5 20.9993 3.50065 24 12.5 24C21.4993 24 24.5 20.9993 24.5 12C24.5 3.00065 21.4993 0 12.5 0C3.50065 0 0.5 3.00065 0.5 12Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6191 13.3446C14.5407 13.4762 14.4012 13.5496 14.2579 13.5496C14.1851 13.5496 14.1106 13.5305 14.0434 13.4908L12.1444 12.3579C12.0173 12.2823 11.9395 12.1445 11.9395 11.9972V9.55452C11.9395 9.32268 12.1276 9.13452 12.3595 9.13452C12.5913 9.13452 12.7795 9.32268 12.7795 9.55452V11.7587L14.4735 12.7689C14.6728 12.8882 14.7378 13.1458 14.6191 13.3446ZM12.36 6.54004C8.32858 6.54004 6.90002 7.9686 6.90002 12C6.90002 16.0309 8.32858 17.46 12.36 17.46C16.3915 17.46 17.82 16.0309 17.82 12C17.82 7.9686 16.3915 6.54004 12.36 6.54004Z"
        fill="#F6F6F6"
      />
    </svg>
  );
};

export const CostIconFill = ({
  className = '',
  width,
  height,
  fill,
}: IconType) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12C0 20.9993 3.00065 24 12 24C20.9993 24 24 20.9993 24 12C24 3.00065 20.9993 0 12 0C3.00065 0 0 3.00065 0 12Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6811 13.3351C10.9377 13.271 11.1769 13.1485 11.3811 12.9793C11.5794 12.8043 11.7369 12.5885 11.8419 12.3376L12.2677 11.346C12.3144 11.2351 12.3377 11.1126 12.3261 10.996C12.3144 10.8735 12.2736 10.7568 12.2036 10.6576C12.1336 10.5584 12.0402 10.4768 11.9352 10.4184C11.8302 10.3659 11.7077 10.3368 11.5852 10.3426L7.65857 10.4227C7.61284 10.4237 7.57177 10.4511 7.55433 10.4934C7.31668 11.0689 7.19249 11.6866 7.18689 12.326C7.18689 12.899 7.2962 13.4773 7.50002 14.0165C7.52061 14.0709 7.57883 14.1006 7.63524 14.0866L10.6811 13.3351ZM6.63272 10.4476C6.68522 10.2959 6.74355 10.1501 6.81355 10.0043C6.87772 9.85259 6.95355 9.70092 7.03522 9.56092C7.27439 9.12925 7.56605 8.72675 7.91605 8.36509C8.94855 7.29175 10.3311 6.67342 11.8186 6.60925C12.9211 6.56842 13.9769 6.84842 14.916 7.40842C15.8494 7.96842 16.6019 8.77925 17.086 9.74759C17.576 10.7218 17.7685 11.8068 17.6577 12.8918C17.541 13.9768 17.121 14.9976 16.4444 15.8493C16.1819 16.176 15.8085 16.3976 15.3944 16.4735L10.2144 17.3718C10.1152 17.3893 10.0102 17.3951 9.91105 17.3951C9.59605 17.3951 9.28689 17.3076 9.01272 17.1443C8.20772 16.6426 7.53689 15.9485 7.06439 15.1259C7.05855 15.1143 7.04689 15.0968 7.04105 15.0851C6.97689 14.9685 6.91272 14.8518 6.85439 14.7293C6.79605 14.5951 6.73772 14.461 6.68522 14.321C6.44022 13.6851 6.31772 13.0085 6.31189 12.326V12.3201C6.31772 11.6726 6.42272 11.0426 6.63272 10.4476Z"
        fill="#F6F6F6"
      />
    </svg>
  );
};

export const BasketIconOutline = ({
  className = '',
  width,
  height,
  fill,
}: IconType) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 22.5C6.45 22.5 5.97917 22.3042 5.5875 21.9125C5.19583 21.5208 5 21.05 5 20.5C5 19.95 5.19583 19.4792 5.5875 19.0875C5.97917 18.6958 6.45 18.5 7 18.5C7.55 18.5 8.02083 18.6958 8.4125 19.0875C8.80417 19.4792 9 19.95 9 20.5C9 21.05 8.80417 21.5208 8.4125 21.9125C8.02083 22.3042 7.55 22.5 7 22.5ZM17 22.5C16.45 22.5 15.9792 22.3042 15.5875 21.9125C15.1958 21.5208 15 21.05 15 20.5C15 19.95 15.1958 19.4792 15.5875 19.0875C15.9792 18.6958 16.45 18.5 17 18.5C17.55 18.5 18.0208 18.6958 18.4125 19.0875C18.8042 19.4792 19 19.95 19 20.5C19 21.05 18.8042 21.5208 18.4125 21.9125C18.0208 22.3042 17.55 22.5 17 22.5ZM6.15 6.5L8.55 11.5H15.55L18.3 6.5H6.15ZM5.2 4.5H19.95C20.3333 4.5 20.625 4.67083 20.825 5.0125C21.025 5.35417 21.0333 5.7 20.85 6.05L17.3 12.45C17.1167 12.7833 16.8708 13.0417 16.5625 13.225C16.2542 13.4083 15.9167 13.5 15.55 13.5H8.1L7 15.5H19V17.5H7C6.25 17.5 5.68333 17.1708 5.3 16.5125C4.91667 15.8542 4.9 15.2 5.25 14.55L6.6 12.1L3 4.5H1V2.5H4.25L5.2 4.5Z"
        fill={fill}
      />
    </svg>
  );
};

export const DownloadOutline = ({
  className = '',
  width,
  height,
  stroke,
}: IconType) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icons/Download">
        <path
          id="Vector"
          d="M10.1493 12.3257V2.2915"
          stroke={stroke}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M12.5792 9.88672L10.1492 12.3267L7.71927 9.88672"
          stroke={stroke}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M13.8918 6.04883C16.8743 6.32383 17.9585 7.4405 17.9585 11.8822C17.9585 17.7989 16.0327 17.7989 10.2502 17.7989C4.46604 17.7989 2.54187 17.7989 2.54187 11.8822C2.54187 7.4405 3.6252 6.32383 6.60854 6.04883"
          stroke={stroke}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const ReportOutline = ({
  className = '',
  width,
  height,
  stroke,
}: IconType) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.98592 8.55078V14.1289"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7807 5.88135V14.1296"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5131 11.4985V14.1293"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.6667 10.0305C2.6667 3.94545 4.69565 1.9165 10.7807 1.9165C16.8658 1.9165 18.8947 3.94545 18.8947 10.0305C18.8947 16.1156 16.8658 18.1445 10.7807 18.1445C4.69565 18.1445 2.6667 16.1156 2.6667 10.0305Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const OpenEyeIconFill = ({ width, height, fill }: IconType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.80112 4.01455C4.26836 4.01455 3.83633 4.44631 3.83633 4.97935C3.83633 5.51207 4.2684 5.94415 4.80112 5.94415C5.33384 5.94415 5.76592 5.51207 5.76592 4.97935C5.76592 4.44631 5.33392 4.01455 4.80112 4.01455ZM3.23633 4.97935C3.23633 4.11479 3.9371 3.41455 4.80112 3.41455C5.66516 3.41455 6.36592 4.11479 6.36592 4.97935C6.36592 5.84343 5.6652 6.54415 4.80112 6.54415C3.93704 6.54415 3.23633 5.84343 3.23633 4.97935Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.9905 2.79785C2.70826 2.19102 3.70059 1.75854 4.80108 1.75854C5.90136 1.75854 6.89368 2.19068 7.61148 2.79736C8.32152 3.39745 8.80188 4.20415 8.80188 4.97935C8.80188 5.75455 8.32152 6.56123 7.61148 7.16131C6.89368 7.76803 5.90136 8.20015 4.80108 8.20015C3.70059 8.20015 2.70826 7.76767 1.9905 7.16083C1.28059 6.56063 0.800293 5.75395 0.800293 4.97935C0.800293 4.20475 1.28059 3.39805 1.9905 2.79785ZM2.37788 3.25604C1.7484 3.78824 1.40029 4.44195 1.40029 4.97935C1.40029 5.51675 1.7484 6.17043 2.37788 6.70267C2.99952 7.22823 3.8576 7.60015 4.80108 7.60015C5.74444 7.60015 6.60252 7.22847 7.2242 6.70307C7.85368 6.17103 8.20188 5.51735 8.20188 4.97935C8.20188 4.44135 7.85368 3.78764 7.2242 3.25562C6.60252 2.73021 5.74444 2.35854 4.80108 2.35854C3.8576 2.35854 2.99952 2.73047 2.37788 3.25604Z"
        fill={fill}
      />
    </svg>
  );
};

export const CloseEyeIconFill = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.43312 8.32533C1.49152 8.38413 1.56832 8.41333 1.64512 8.41333C1.72192 8.41333 1.79872 8.38413 1.85712 8.32533L2.74772 7.43469C2.76883 7.41869 2.7881 7.39961 2.8048 7.37761L8.16672 2.01572C8.28392 1.89852 8.28392 1.70852 8.16672 1.59132C8.04952 1.47412 7.85992 1.47412 7.74272 1.59132L6.99148 2.34261C6.32144 1.94725 5.56808 1.73935 4.79832 1.73935C2.58234 1.73935 0.79834 3.50095 0.79834 4.95933C0.79834 5.73925 1.30071 6.60185 2.10255 7.23185L1.43312 7.90133C1.31592 8.01853 1.31592 8.20813 1.43312 8.32533ZM2.53048 6.80389C1.8452 6.28589 1.39834 5.56717 1.39834 4.95933C1.39834 3.78015 2.96714 2.33935 4.79832 2.33935C5.409 2.33935 6.00824 2.49191 6.55104 2.78308L5.67368 3.66047C5.41692 3.48755 5.11064 3.39199 4.79908 3.39199H4.79548C4.37748 3.39279 3.98509 3.55639 3.68989 3.85239C3.39509 4.14837 3.23309 4.54157 3.23429 4.95757C3.23308 5.26965 3.32834 5.57621 3.50174 5.83257L2.53048 6.80389ZM3.93893 5.39533L5.23628 4.09789C5.1016 4.02913 4.95116 3.99199 4.79868 3.99199H4.79668C4.53868 3.99239 4.29668 4.09317 4.11508 4.27557C3.93349 4.45837 3.83349 4.70037 3.83429 4.95797C3.83357 5.11097 3.87045 5.26117 3.93893 5.39533Z"
        fill={fill}
      />
      <path
        d="M4.79787 8.1798C4.41907 8.1798 4.03867 8.1278 3.66587 8.0246C3.50627 7.9806 3.41267 7.8154 3.45667 7.6558C3.50067 7.4958 3.66707 7.4026 3.82587 7.4466C4.14627 7.535 4.47307 7.5798 4.79787 7.5798C6.63107 7.5798 8.20187 6.139 8.20187 4.9594C8.20187 4.5774 8.02427 4.1418 7.70227 3.73381C7.59987 3.60381 7.62227 3.41501 7.75227 3.31221C7.88227 3.20981 8.07107 3.23181 8.17347 3.36181C8.57867 3.87581 8.80187 4.443 8.80187 4.9594C8.80187 6.4182 7.01587 8.1798 4.79787 8.1798Z"
        fill={fill}
      />
      <path
        d="M5.02637 6.49997C4.88437 6.49997 4.75837 6.39877 4.73157 6.25437C4.70157 6.09157 4.80957 5.93477 4.97277 5.90517C5.36437 5.83277 5.67557 5.52157 5.74637 5.12957C5.77597 4.96637 5.93157 4.85917 6.09517 4.88797C6.25797 4.91757 6.36637 5.07357 6.33677 5.23677C6.22157 5.87277 5.71717 6.37797 5.08077 6.49477C5.06277 6.49837 5.04437 6.49997 5.02637 6.49997Z"
        fill={fill}
      />
    </svg>
  );
};

export const MapPinIcon = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.6709 4.63419C3.6709 3.91607 4.25284 3.33398 4.97068 3.33398C5.68888 3.33398 6.27092 3.91599 6.27092 4.63419C6.27092 5.35207 5.6888 5.93399 4.97068 5.93399C4.25292 5.93399 3.6709 5.35199 3.6709 4.63419ZM4.97068 3.93398C4.58436 3.93398 4.27092 4.24728 4.27092 4.63419C4.27092 5.02059 4.58428 5.33399 4.97068 5.33399C5.3576 5.33399 5.67092 5.02051 5.67092 4.63419C5.67092 4.24736 5.35752 3.93398 4.97068 3.93398Z"
        fill={fill}
      />

      <path
        id="Vector_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.9663 1.85C3.47876 1.85 2.2665 3.07292 2.2665 4.58944C2.2665 5.57904 2.6936 6.55588 3.26784 7.28868C3.55384 7.65368 3.86967 7.94932 4.17434 8.1514C4.48362 8.35648 4.75794 8.45 4.9663 8.45C5.17478 8.45 5.44922 8.35648 5.7585 8.1514C6.06326 7.94932 6.3791 7.65368 6.66514 7.28868C7.23942 6.55588 7.6665 5.57904 7.6665 4.58944C7.6665 3.07297 6.4539 1.85 4.9663 1.85ZM1.6665 4.58944C1.6665 2.74905 3.13993 1.25 4.9663 1.25C6.79262 1.25 8.2665 2.749 8.2665 4.58944C8.2665 5.74388 7.7733 6.84732 7.13738 7.65876C6.8183 8.06592 6.45658 8.4084 6.0901 8.65144C5.72814 8.89144 5.33762 9.05 4.9663 9.05C4.59506 9.05 4.20462 8.89144 3.84274 8.65144C3.47629 8.4084 3.11461 8.06592 2.79556 7.65876C2.15971 6.84732 1.6665 5.74388 1.6665 4.58944Z"
        fill={fill}
      />
    </svg>
  );
};

export const LeftCircleIconFill = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.4075 6.5352C4.8379 6.1448 3.8823 5.4132 3.8823 4.9C3.8823 4.3868 4.8379 3.6552 5.4075 3.2648C5.5443 3.1712 5.7311 3.206 5.8243 3.3428C5.9179 3.4788 5.8827 3.6668 5.7467 3.7596C5.1119 4.1948 4.5207 4.7336 4.4819 4.912C4.5207 5.0668 5.1119 5.6056 5.7467 6.0408C5.8827 6.1336 5.9179 6.3204 5.8243 6.4576C5.7311 6.594 5.5443 6.6288 5.4075 6.5352ZM8.8999 4.9C8.8999 2.0208 7.8795 1 4.9999 1C2.1207 1 1.0999 2.0208 1.0999 4.9C1.0999 7.7792 2.1207 8.8 4.9999 8.8C7.8795 8.8 8.8999 7.7792 8.8999 4.9Z"
        fill={fill}
      />
    </svg>
  );
};

export const ClockIconOutline = ({ width, height, stroke }: IconType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
    >
      <g>
        <path
          d="M1.37506 5.99999C1.37506 9.46849 2.53156 10.625 6.00005 10.625C9.46855 10.625 10.6251 9.46849 10.6251 5.99999C10.6251 2.5315 9.46855 1.375 6.00005 1.375C2.53156 1.375 1.37506 2.5315 1.37506 5.99999Z"
          stroke={stroke}
        />
        <path d="M7.69515 7.00891L5.99965 5.99741V3.81689" stroke={stroke} />
      </g>
      <defs>
        <clipPath id="clip0_518_22311">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const OrderStatus_1 = ({ width, height, fill }: IconType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M9.11667 12.2617H6.78323C6.51827 12.2617 6.30327 12.0467 6.30327 11.7817C6.30327 11.5168 6.51827 11.3017 6.78323 11.3017H9.11667C9.38163 11.3017 9.59667 11.5168 9.59667 11.7817C9.59667 12.0467 9.38163 12.2617 9.11667 12.2617ZM10.0291 9.25324C9.95821 9.20396 9.86375 9.20402 9.7929 9.25336C9.2768 9.61272 8.65607 9.83103 7.98067 9.83103C7.30471 9.83103 6.68442 9.61266 6.16786 9.2533C6.09703 9.20402 6.00258 9.20396 5.93174 9.25324C5.41659 9.61164 4.80252 9.83103 4.14327 9.83103C3.7266 9.83103 3.33339 9.74354 2.97022 9.59525C2.83705 9.54085 2.68407 9.63448 2.68407 9.77836V11.143C2.68407 12.9997 3.87575 14.247 5.64855 14.247H10.3116C12.0856 14.247 13.2773 12.9997 13.2773 11.143V9.76984C13.2773 9.62514 13.1227 9.53151 12.9893 9.58751C12.6248 9.74047 12.2317 9.83103 11.8188 9.83103C11.159 9.83103 10.5443 9.61164 10.0291 9.25324Z"
        fill={fill}
      />
      <path
        d="M13.4705 3.7974C13.21 3.0198 12.4843 2.49756 11.6651 2.49756H4.28716C3.46413 2.49756 2.73709 3.023 2.47917 3.80572C2.25197 4.50076 1.90125 6.02716 1.90125 6.63196C1.90125 7.86652 2.90669 8.87197 4.14317 8.87197C4.83406 8.87197 5.45913 8.53667 5.87255 8.02627C5.96387 7.9135 6.1483 7.9144 6.23891 8.02768C6.64883 8.54044 7.27424 8.87197 7.9806 8.87197C8.68697 8.87197 9.31238 8.53993 9.7223 8.02704C9.81292 7.91376 9.99731 7.91286 10.0886 8.02563C10.5021 8.53622 11.1272 8.87197 11.8187 8.87197C13.034 8.87197 14.0612 7.84605 14.0612 6.63196C14.0612 6.02524 13.7028 4.49436 13.4705 3.7974Z"
        fill={fill}
      />
    </svg>
  );
};

export const OrderStatus_2 = ({ width, height, stroke }: IconType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M13.0511 3.96484L13.0524 5.39402L11.6312 5.39526"
        stroke={stroke}
      />
      <path
        d="M12.8849 5.35959C11.1986 2.7628 7.73619 1.98065 5.09207 3.62092C3.43623 4.64781 2.48905 6.38461 2.4 8.19364"
        stroke={stroke}
      />
      <path
        d="M3.26749 13.0354L3.26625 11.6062L4.68733 11.605"
        stroke={stroke}
      />
      <path
        d="M3.43501 11.6392C5.12137 14.236 8.58375 15.0182 11.2279 13.3778C12.8837 12.351 13.8309 10.6142 13.9199 8.80518"
        stroke={stroke}
      />
    </svg>
  );
};

export const OrderStatus_3 = ({ width, height, fill }: IconType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M6.49267 9.52564C6.786 9.45231 7.05933 9.31231 7.29267 9.11897C7.51933 8.91897 7.69933 8.67231 7.81933 8.38564L8.306 7.25231C8.35933 7.12564 8.386 6.98564 8.37267 6.85231C8.35933 6.71231 8.31267 6.57894 8.23267 6.46561C8.15267 6.35227 8.046 6.25894 7.926 6.19227C7.806 6.13227 7.666 6.09894 7.526 6.10561L3.0384 6.19719C2.98613 6.19826 2.9392 6.22967 2.91927 6.27795C2.64767 6.93564 2.50573 7.64164 2.49933 8.37231C2.49933 9.02724 2.62427 9.68811 2.8572 10.3044C2.88073 10.3665 2.94727 10.4004 3.01173 10.3845L6.49267 9.52564ZM1.866 6.22561C1.926 6.05227 1.99267 5.88561 2.07267 5.71894C2.146 5.54561 2.23267 5.37227 2.326 5.21227C2.59933 4.71894 2.93267 4.25894 3.33267 3.84561C4.51267 2.61894 6.09267 1.91227 7.79267 1.83894C9.05267 1.79227 10.2593 2.11227 11.3326 2.75227C12.3993 3.39227 13.2593 4.31894 13.8126 5.42561C14.3726 6.53894 14.5926 7.77897 14.466 9.01897C14.3326 10.259 13.8526 11.4256 13.0793 12.399C12.7793 12.7723 12.3526 13.0256 11.8793 13.1123L5.95933 14.139C5.846 14.159 5.726 14.1656 5.61267 14.1656C5.25267 14.1656 4.89933 14.0656 4.586 13.879C3.666 13.3056 2.89933 12.5123 2.35933 11.5723C2.35267 11.559 2.33933 11.539 2.33267 11.5256C2.25933 11.3923 2.186 11.259 2.11933 11.119C2.05267 10.9656 1.986 10.8123 1.926 10.6523C1.646 9.92564 1.506 9.15231 1.49933 8.37231V8.36564C1.506 7.62564 1.626 6.90564 1.866 6.22561Z"
        fill={fill}
      />
    </svg>
  );
};

export const OrderStatus_4 = ({ width, height, fill }: IconType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M10.4582 6.84273L7.41822 9.88017C7.32798 9.97041 7.20638 10.021 7.07902 10.021C6.95166 10.021 6.82942 9.97041 6.73918 9.88017L5.22174 8.36145C5.03422 8.17393 5.03422 7.86993 5.22174 7.68241C5.4099 7.49489 5.7139 7.49617 5.90078 7.68241L7.07902 8.86193L9.77917 6.16367C9.96669 5.97615 10.2707 5.97679 10.4582 6.16367C10.6457 6.35119 10.6457 6.65521 10.4582 6.84273ZM7.83998 1.78223C3.23326 1.78223 1.59998 3.41551 1.59998 8.02225C1.59998 12.629 3.23326 14.2622 7.83998 14.2622C12.4467 14.2622 14.08 12.629 14.08 8.02225C14.08 3.41551 12.4467 1.78223 7.83998 1.78223Z"
        fill={fill}
      />
    </svg>
  );
};

export const GrayCircleIcon = ({ width, height, fill }: IconType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M8.00002 3.1665C4.0003 3.1665 2.66668 4.50012 2.66668 8.49985C2.66668 12.4996 4.0003 13.8332 8.00002 13.8332C11.9997 13.8332 13.3333 12.4996 13.3333 8.49985C13.3333 4.50012 11.9997 3.1665 8.00002 3.1665Z"
        fill={fill}
      />
    </svg>
  );
};

export const LocationIconOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.50391 4.48429C3.50391 3.76617 4.08585 3.18408 4.80369 3.18408C5.52189 3.18408 6.10393 3.76609 6.10393 4.48429C6.10393 5.20217 5.52181 5.78409 4.80369 5.78409C4.08593 5.78409 3.50391 5.20209 3.50391 4.48429ZM4.80369 3.78408C4.41737 3.78408 4.10393 4.09738 4.10393 4.48429C4.10393 4.87069 4.41729 5.18409 4.80369 5.18409C5.19061 5.18409 5.50393 4.87061 5.50393 4.48429C5.50393 4.09746 5.19053 3.78408 4.80369 3.78408Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.7998 1.7001C3.31225 1.7001 2.1 2.92302 2.1 4.43954C2.1 5.42914 2.52709 6.40598 3.10134 7.13878C3.38734 7.50378 3.70316 7.79942 4.00784 8.0015C4.31712 8.20658 4.59144 8.3001 4.7998 8.3001C5.00828 8.3001 5.28272 8.20658 5.592 8.0015C5.89676 7.79942 6.2126 7.50378 6.49864 7.13878C7.07292 6.40598 7.5 5.42914 7.5 4.43954C7.5 2.92307 6.2874 1.7001 4.7998 1.7001ZM1.5 4.43954C1.5 2.59915 2.97343 1.1001 4.7998 1.1001C6.62612 1.1001 8.1 2.5991 8.1 4.43954C8.1 5.59398 7.6068 6.69742 6.97088 7.50886C6.6518 7.91602 6.29008 8.2585 5.9236 8.50154C5.56164 8.74154 5.17112 8.9001 4.7998 8.9001C4.42856 8.9001 4.03812 8.74154 3.67623 8.50154C3.30978 8.2585 2.94811 7.91602 2.62906 7.50886C1.9932 6.69742 1.5 5.59398 1.5 4.43954Z"
        fill={fill}
      />
    </svg>
  );
};

export const CancelOrderIcon = ({ width, height, stroke }: IconType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.9741 12.5772L19.9563 8.1687C19.9498 5.34443 18.1854 3.35242 15.3584 3.35988L7.26995 3.37855C4.45129 3.38507 2.68879 5.38455 2.69533 8.20976L2.71305 15.8307C2.71959 18.655 4.483 20.646 7.31101 20.6395L11.114 20.6209"
        stroke={stroke}
      />
      <path
        d="M14.0496 3.35986L14.0654 9.76229L11.3466 8.87684L8.61196 9.77814L8.60352 3.38412"
        stroke={stroke}
      />
      <path
        d="M19.9754 20.64L16.248 16.9126M19.9754 16.9126L16.248 20.64"
        stroke={stroke}
      />
    </svg>
  );
};

export const RefundOrderIcon = ({ width, height, stroke }: IconType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M2.74854 12.9609C2.74854 6.02394 5.06154 3.71094 11.9986 3.71094C18.9356 3.71094 21.2486 6.02394 21.2486 12.9609C21.2486 19.8979 18.9356 22.2109 11.9986 22.2109C5.06154 22.2109 2.74854 19.8979 2.74854 12.9609Z"
        stroke={stroke}
      />
      <path
        d="M11.9985 9.06592V12.9609"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9941 16.4609H12.0031"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TickSelectIcon = ({ width, height, stroke }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 9 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.666992 3.75525L2.92319 6.01049L7.43366 1.5"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PaperIcon = ({ width, height, stroke }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.53752 10.2998H5.9375"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.17482 7.62549H5.9375"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4403 5.5335L9.66027 1.9335C9.17361 1.86683 8.62694 1.8335 8.02694 1.8335C3.83359 1.8335 2.43359 3.38016 2.43359 8.00018C2.43359 12.6268 3.83359 14.1668 8.02694 14.1668C12.2269 14.1668 13.6269 12.6268 13.6269 8.00018C13.6269 7.05351 13.5669 6.2335 13.4403 5.5335Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.28906 1.88818V3.66218C9.28906 4.90085 10.2931 5.90418 11.5317 5.90418H13.4991"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChatIcon = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.72115 8.26451C9.72115 7.91104 10.0077 7.62451 10.3612 7.62451H10.3669C10.7204 7.62451 11.0069 7.91104 11.0069 8.26451C11.0069 8.61798 10.7204 8.90451 10.3669 8.90451H10.3612C10.0077 8.90451 9.72115 8.61798 9.72115 8.26451Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.15546 8.26451C7.15546 7.91104 7.44198 7.62451 7.79546 7.62451H7.80122C8.15469 7.62451 8.44122 7.91104 8.44122 8.26451C8.44122 8.61798 8.15469 8.90451 7.80122 8.90451H7.79546C7.44198 8.90451 7.15546 8.61798 7.15546 8.26451Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.58969 8.26451C4.58969 7.91104 4.87623 7.62451 5.22969 7.62451H5.23545C5.58891 7.62451 5.87545 7.91104 5.87545 8.26451C5.87545 8.61798 5.58891 8.90451 5.23545 8.90451H5.22969C4.87623 8.90451 4.58969 8.61798 4.58969 8.26451Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.026 3.81281C9.71661 1.50256 5.96414 1.50256 3.6548 3.81281C1.84623 5.62103 1.45337 8.30149 2.46845 10.4951C2.47185 10.5025 2.47508 10.5099 2.4781 10.5174C2.53709 10.664 2.53577 10.8301 2.53311 10.924C2.52978 11.042 2.51673 11.1778 2.50063 11.3161C2.4854 11.4468 2.46606 11.5908 2.4464 11.7371L2.44232 11.7676C2.42103 11.9262 2.39935 12.089 2.38043 12.2521C2.34205 12.5828 2.31796 12.8916 2.32868 13.1387C2.33402 13.2618 2.34748 13.353 2.36466 13.4155C2.37046 13.4366 2.37576 13.4511 2.37967 13.4605C2.38902 13.4644 2.40352 13.4697 2.42459 13.4754C2.48713 13.4926 2.57838 13.506 2.70149 13.5114C2.94855 13.5221 3.25737 13.498 3.58806 13.4596C3.7511 13.4408 3.91391 13.4191 4.07251 13.3978L4.10274 13.3938C4.24916 13.3741 4.39321 13.3548 4.52395 13.3396C4.66217 13.3235 4.79805 13.3105 4.91598 13.3072C5.00992 13.3045 5.17599 13.3032 5.3225 13.3622C5.32998 13.3652 5.33739 13.3684 5.34471 13.3718C7.53875 14.3865 10.2181 13.9942 12.026 12.1855C14.3356 9.87545 14.3402 6.12673 12.026 3.81281ZM12.7048 3.13403C10.0205 0.448784 5.66009 0.448813 2.97584 3.13411C0.886853 5.22278 0.425254 8.31039 1.57363 10.8468C1.57398 10.858 1.57414 10.8744 1.5735 10.8969C1.57138 10.9717 1.56233 11.074 1.54708 11.205C1.53287 11.327 1.5146 11.463 1.49457 11.6121L1.49085 11.6399C1.46961 11.7981 1.44686 11.9688 1.42683 12.1414C1.38729 12.4821 1.3554 12.8536 1.36958 13.1803C1.37669 13.3441 1.3959 13.5132 1.43899 13.6699C1.4811 13.8232 1.55559 14.0001 1.69789 14.1424C1.84024 14.2846 2.01732 14.3592 2.17044 14.4012C2.32717 14.4442 2.4962 14.4634 2.65996 14.4705C2.98665 14.4847 3.35798 14.4528 3.69862 14.4132C3.87123 14.3933 4.04187 14.3705 4.2001 14.3493L4.22757 14.3457C4.37681 14.3256 4.51288 14.3074 4.63489 14.2932C4.76586 14.2779 4.86815 14.2689 4.94296 14.2668C4.9655 14.2662 4.98193 14.2663 4.99314 14.2667C7.52973 15.4145 10.6164 14.9537 12.7049 12.8642C15.3889 10.1799 15.3946 5.82341 12.7048 3.13403Z"
        fill={fill}
      />
    </svg>
  );
};

export const ArrowUpIconOutline = ({ width, height, stroke }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.91671 9.0415C2.91671 9.0415 5.33404 4.95817 7.00004 4.95817C8.66546 4.95817 11.0834 9.0415 11.0834 9.0415"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CameraIcon = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_2550_3747" fill={fill}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.37439 8.31865C5.37439 6.94201 6.4907 5.82568 7.86734 5.82568C9.24405 5.82568 10.3603 6.94201 10.3603 8.31865C10.3603 9.69535 9.24405 10.8116 7.86734 10.8116C6.4907 10.8116 5.37439 9.69535 5.37439 8.31865ZM7.86734 6.78566C7.02088 6.78566 6.33439 7.47219 6.33439 8.31865C6.33439 9.16511 7.02088 9.85164 7.86734 9.85164C8.71387 9.85164 9.40034 9.16511 9.40034 8.31865C9.40034 7.47219 8.71387 6.78566 7.86734 6.78566Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.37439 8.31865C5.37439 6.94201 6.4907 5.82568 7.86734 5.82568C9.24405 5.82568 10.3603 6.94201 10.3603 8.31865C10.3603 9.69535 9.24405 10.8116 7.86734 10.8116C6.4907 10.8116 5.37439 9.69535 5.37439 8.31865ZM7.86734 6.78566C7.02088 6.78566 6.33439 7.47219 6.33439 8.31865C6.33439 9.16511 7.02088 9.85164 7.86734 9.85164C8.71387 9.85164 9.40034 9.16511 9.40034 8.31865C9.40034 7.47219 8.71387 6.78566 7.86734 6.78566Z"
        fill={fill}
      />
      <path
        d="M6.33439 8.31865C6.33439 7.4722 7.0209 6.78568 7.86734 6.78568V4.86568C5.9605 4.86568 4.41439 6.41182 4.41439 8.31865H6.33439ZM7.86734 6.78568C8.71385 6.78568 9.40034 7.4722 9.40034 8.31865H11.3203C11.3203 6.41182 9.77424 4.86568 7.86734 4.86568V6.78568ZM9.40034 8.31865C9.40034 9.16516 8.71385 9.85164 7.86734 9.85164V11.7716C9.77424 11.7716 11.3203 10.2255 11.3203 8.31865H9.40034ZM7.86734 9.85164C7.0209 9.85164 6.33439 9.16516 6.33439 8.31865H4.41439C4.41439 10.2255 5.96051 11.7716 7.86734 11.7716V9.85164ZM7.86734 5.82566C6.49065 5.82566 5.37439 6.94202 5.37439 8.31865H7.29439C7.29439 8.00235 7.5511 7.74566 7.86734 7.74566V5.82566ZM5.37439 8.31865C5.37439 9.69528 6.49065 10.8116 7.86734 10.8116V8.89164C7.5511 8.89164 7.29439 8.63495 7.29439 8.31865H5.37439ZM7.86734 10.8116C9.24409 10.8116 10.3603 9.69528 10.3603 8.31865H8.44034C8.44034 8.63495 8.18365 8.89164 7.86734 8.89164V10.8116ZM10.3603 8.31865C10.3603 6.94202 9.24409 5.82566 7.86734 5.82566V7.74566C8.18365 7.74566 8.44034 8.00235 8.44034 8.31865H10.3603Z"
        fill={fill}
        mask="url(#path-1-inside-1_2550_3747)"
      />
      <mask id="path-3-inside-2_2550_3747" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.02998 1.83551C9.36521 1.86766 9.70601 1.9206 9.93692 2.01771C10.408 2.21636 10.6792 2.62699 10.8481 2.93328C10.9077 3.04138 10.9654 3.15793 11.0134 3.25487C11.033 3.29442 11.0509 3.33073 11.0668 3.36185C11.1331 3.49236 11.1678 3.54455 11.1833 3.56146L11.184 3.56219C11.2763 3.66385 11.3941 3.73031 11.505 3.76655C12.5744 4.06381 13.2693 4.5849 13.6635 5.41119C14.0366 6.19298 14.1092 7.19232 14.1092 8.3623C14.1092 10.0191 13.9713 11.4373 13.0199 12.3967C12.0737 13.3507 10.4492 13.7279 7.86722 13.7279C5.28517 13.7279 3.66071 13.3507 2.71451 12.3967C1.7631 11.4373 1.62518 10.0191 1.62518 8.3623C1.62518 7.19232 1.69786 6.19298 2.07087 5.41119C2.46515 4.58483 3.16011 4.06372 4.22962 3.76648C4.34047 3.73043 4.45776 3.6642 4.55046 3.56219L4.55112 3.56146C4.56688 3.5442 4.60229 3.49094 4.66965 3.35918C4.68585 3.32749 4.70424 3.29057 4.72427 3.25037C4.7728 3.15293 4.83092 3.03626 4.89069 2.92817C5.0591 2.62365 5.33119 2.20858 5.80173 2.01595C6.02748 1.92387 6.36442 1.87149 6.69801 1.83899C7.04943 1.80477 7.45775 1.78743 7.86249 1.78665C8.26716 1.78587 8.67657 1.80162 9.02998 1.83551ZM6.16511 2.90452C6.01868 2.96461 5.88193 3.11946 5.73078 3.39276C5.68104 3.48271 5.63956 3.56608 5.59569 3.6543C5.57306 3.69978 5.54979 3.74655 5.52441 3.79618C5.46178 3.9187 5.37471 4.08298 5.26062 4.20815C5.03329 4.45818 4.75755 4.60681 4.51079 4.68444C4.50539 4.68614 4.49996 4.68774 4.49451 4.68925C3.61765 4.93139 3.18474 5.306 2.9373 5.82459C2.66745 6.39018 2.58518 7.18925 2.58518 8.3623C2.58518 10.0483 2.75378 11.073 3.39615 11.7206C4.04371 12.3736 5.30026 12.7679 7.86722 12.7679C10.4341 12.7679 11.6907 12.3736 12.3383 11.7206C12.9806 11.073 13.1492 10.0483 13.1492 8.3623C13.1492 7.18925 13.067 6.39018 12.7971 5.82459C12.5497 5.306 12.1168 4.93139 11.2399 4.68925C11.2343 4.6877 11.2287 4.68604 11.2231 4.68429C10.9779 4.60684 10.7014 4.45849 10.4738 4.20819C10.3594 4.08267 10.273 3.9188 10.211 3.79693C10.186 3.74776 10.1632 3.70149 10.1409 3.65654C10.0976 3.56885 10.0567 3.48618 10.0073 3.39674C9.85929 3.12813 9.72118 2.96867 9.5645 2.90252C9.4813 2.8676 9.27158 2.82308 8.93833 2.79113C8.62306 2.7609 8.24578 2.74591 7.86434 2.74665C7.48297 2.74738 7.10582 2.76381 6.79106 2.79448C6.45884 2.82683 6.24841 2.87062 6.16511 2.90452Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.02998 1.83551C9.36521 1.86766 9.70601 1.9206 9.93692 2.01771C10.408 2.21636 10.6792 2.62699 10.8481 2.93328C10.9077 3.04138 10.9654 3.15793 11.0134 3.25487C11.033 3.29442 11.0509 3.33073 11.0668 3.36185C11.1331 3.49236 11.1678 3.54455 11.1833 3.56146L11.184 3.56219C11.2763 3.66385 11.3941 3.73031 11.505 3.76655C12.5744 4.06381 13.2693 4.5849 13.6635 5.41119C14.0366 6.19298 14.1092 7.19232 14.1092 8.3623C14.1092 10.0191 13.9713 11.4373 13.0199 12.3967C12.0737 13.3507 10.4492 13.7279 7.86722 13.7279C5.28517 13.7279 3.66071 13.3507 2.71451 12.3967C1.7631 11.4373 1.62518 10.0191 1.62518 8.3623C1.62518 7.19232 1.69786 6.19298 2.07087 5.41119C2.46515 4.58483 3.16011 4.06372 4.22962 3.76648C4.34047 3.73043 4.45776 3.6642 4.55046 3.56219L4.55112 3.56146C4.56688 3.5442 4.60229 3.49094 4.66965 3.35918C4.68585 3.32749 4.70424 3.29057 4.72427 3.25037C4.7728 3.15293 4.83092 3.03626 4.89069 2.92817C5.0591 2.62365 5.33119 2.20858 5.80173 2.01595C6.02748 1.92387 6.36442 1.87149 6.69801 1.83899C7.04943 1.80477 7.45775 1.78743 7.86249 1.78665C8.26716 1.78587 8.67657 1.80162 9.02998 1.83551ZM6.16511 2.90452C6.01868 2.96461 5.88193 3.11946 5.73078 3.39276C5.68104 3.48271 5.63956 3.56608 5.59569 3.6543C5.57306 3.69978 5.54979 3.74655 5.52441 3.79618C5.46178 3.9187 5.37471 4.08298 5.26062 4.20815C5.03329 4.45818 4.75755 4.60681 4.51079 4.68444C4.50539 4.68614 4.49996 4.68774 4.49451 4.68925C3.61765 4.93139 3.18474 5.306 2.9373 5.82459C2.66745 6.39018 2.58518 7.18925 2.58518 8.3623C2.58518 10.0483 2.75378 11.073 3.39615 11.7206C4.04371 12.3736 5.30026 12.7679 7.86722 12.7679C10.4341 12.7679 11.6907 12.3736 12.3383 11.7206C12.9806 11.073 13.1492 10.0483 13.1492 8.3623C13.1492 7.18925 13.067 6.39018 12.7971 5.82459C12.5497 5.306 12.1168 4.93139 11.2399 4.68925C11.2343 4.6877 11.2287 4.68604 11.2231 4.68429C10.9779 4.60684 10.7014 4.45849 10.4738 4.20819C10.3594 4.08267 10.273 3.9188 10.211 3.79693C10.186 3.74776 10.1632 3.70149 10.1409 3.65654C10.0976 3.56885 10.0567 3.48618 10.0073 3.39674C9.85929 3.12813 9.72118 2.96867 9.5645 2.90252C9.4813 2.8676 9.27158 2.82308 8.93833 2.79113C8.62306 2.7609 8.24578 2.74591 7.86434 2.74665C7.48297 2.74738 7.10582 2.76381 6.79106 2.79448C6.45884 2.82683 6.24841 2.87062 6.16511 2.90452Z"
        fill={fill}
      />
      <path
        d="M9.02998 1.83551L9.12162 0.879897L9.12161 0.879896L9.02998 1.83551ZM9.93692 2.01771L10.3099 1.13313L10.3091 1.13278L9.93692 2.01771ZM10.8481 2.93328L11.6888 2.46985L11.6887 2.46971L10.8481 2.93328ZM11.0134 3.25487L11.8737 2.82894L11.8737 2.82888L11.0134 3.25487ZM11.0668 3.36185L11.9225 2.92671L11.922 2.92571L11.0668 3.36185ZM11.1833 3.56146L10.474 4.20843L10.4815 4.21665L10.4892 4.22471L11.1833 3.56146ZM11.184 3.56219L11.8945 2.91665L11.8864 2.9077L11.878 2.89895L11.184 3.56219ZM11.505 3.76655L11.207 4.67912L11.2273 4.68576L11.2479 4.69148L11.505 3.76655ZM13.6635 5.41119L12.7971 5.82458L12.7971 5.82463L13.6635 5.41119ZM13.0199 12.3967L13.7015 13.0727L13.7015 13.0727L13.0199 12.3967ZM2.71451 12.3967L2.03287 13.0727L2.03289 13.0727L2.71451 12.3967ZM2.07087 5.41119L2.9373 5.82459L2.9373 5.82459L2.07087 5.41119ZM4.22962 3.76648L4.48668 4.69142L4.50671 4.68585L4.52647 4.67943L4.22962 3.76648ZM4.55046 3.56219L5.26091 4.20784L5.26239 4.20621L4.55046 3.56219ZM4.55112 3.56146L3.84211 2.91422L3.83919 2.91744L4.55112 3.56146ZM4.66965 3.35918L3.8149 2.92214L3.81488 2.92218L4.66965 3.35918ZM4.72427 3.25037L5.58355 3.67843L5.58357 3.67838L4.72427 3.25037ZM4.89069 2.92817L4.05061 2.46357L4.0506 2.46358L4.89069 2.92817ZM5.80173 2.01595L5.43917 1.12704L5.43801 1.12752L5.80173 2.01595ZM6.69801 1.83899L6.60495 0.883515L6.60494 0.883516L6.69801 1.83899ZM7.86249 1.78665L7.86434 2.74665H7.86434L7.86249 1.78665ZM6.16511 2.90452L5.80332 2.01529L5.80061 2.01641L6.16511 2.90452ZM5.73078 3.39276L6.57086 3.85739L6.57087 3.85736L5.73078 3.39276ZM5.59569 3.6543L6.45518 4.08193L6.45523 4.08183L5.59569 3.6543ZM5.52441 3.79618L4.66966 3.35916L4.66963 3.35921L5.52441 3.79618ZM5.26062 4.20815L4.55111 3.56147L4.55033 3.56233L5.26062 4.20815ZM4.51079 4.68444L4.79837 5.60035L4.79889 5.60019L4.51079 4.68444ZM4.49451 4.68925L4.23925 3.7638L4.23897 3.76388L4.49451 4.68925ZM2.9373 5.82459L3.80374 6.23798L3.80374 6.23798L2.9373 5.82459ZM3.39615 11.7206L4.0778 11.0447L4.07776 11.0446L3.39615 11.7206ZM12.3383 11.7206L11.6567 11.0446L11.6566 11.0447L12.3383 11.7206ZM12.7971 5.82459L11.9306 6.23797L11.9307 6.23802L12.7971 5.82459ZM11.2399 4.68925L11.4954 3.76388L11.4944 3.76361L11.2399 4.68925ZM11.2231 4.68429L10.934 5.59973L10.9347 5.59995L11.2231 4.68429ZM10.4738 4.20819L11.1841 3.56236L11.1833 3.56144L10.4738 4.20819ZM10.211 3.79693L11.0668 3.3619L11.0666 3.36151L10.211 3.79693ZM10.1409 3.65654L9.28021 4.08179L9.2807 4.08278L10.1409 3.65654ZM10.0073 3.39674L9.16655 3.86009L9.16676 3.86047L10.0073 3.39674ZM9.5645 2.90252L9.93792 2.01812L9.93602 2.01732L9.5645 2.90252ZM8.93833 2.79113L8.84669 3.74674L8.84669 3.74675L8.93833 2.79113ZM7.86434 2.74665L7.86249 1.78665L7.86249 1.78665L7.86434 2.74665ZM6.79106 2.79448L6.88413 3.74995L6.88414 3.74995L6.79106 2.79448ZM8.93834 2.79113C9.27058 2.82299 9.48115 2.86747 9.56477 2.90264L10.3091 1.13278C9.93087 0.973727 9.45984 0.912331 9.12162 0.879897L8.93834 2.79113ZM9.56392 2.90228C9.72119 2.9686 9.8597 3.12895 10.0074 3.39685L11.6887 2.46971C11.4987 2.12504 11.0949 1.46412 10.3099 1.13313L9.56392 2.90228ZM10.0074 3.3967C10.0551 3.48327 10.1036 3.58094 10.1531 3.68085L11.8737 2.82888C11.8272 2.73491 11.7603 2.59948 11.6888 2.46985L10.0074 3.3967ZM10.1531 3.68079C10.1714 3.71776 10.1924 3.76046 10.2116 3.79798L11.922 2.92571C11.9094 2.90099 11.8946 2.87109 11.8737 2.82894L10.1531 3.68079ZM10.2111 3.79699C10.27 3.91284 10.3578 4.08107 10.474 4.20843L11.8925 2.91449C11.9026 2.92559 11.9112 2.93552 11.918 2.94379C11.925 2.95212 11.9309 2.95954 11.9357 2.96579C11.9452 2.97805 11.9522 2.98791 11.9567 2.9943C11.9652 3.00665 11.9689 3.013 11.9672 3.01012C11.9658 3.00782 11.9614 3.00027 11.9536 2.98596C11.9458 2.97182 11.9356 2.95241 11.9225 2.92671L10.2111 3.79699ZM10.4892 4.22471L10.4899 4.22544L11.878 2.89895L11.8773 2.89821L10.4892 4.22471ZM10.4734 4.20774C10.6962 4.45295 10.966 4.60039 11.207 4.67912L11.8031 2.85399C11.8157 2.85812 11.8283 2.86368 11.8417 2.87194C11.8554 2.88039 11.8743 2.8944 11.8945 2.91665L10.4734 4.20774ZM11.2479 4.69148C12.1199 4.93387 12.5505 5.30787 12.7971 5.82458L14.5299 4.9978C13.988 3.86193 13.0289 3.19376 11.7622 2.84162L11.2479 4.69148ZM12.7971 5.82463C13.0671 6.39051 13.1492 7.19002 13.1492 8.3623H15.0692C15.0692 7.19462 15.006 5.99545 14.5299 4.99775L12.7971 5.82463ZM13.1492 8.3623C13.1492 10.0471 12.981 11.0726 12.3382 11.7207L13.7015 13.0727C14.9616 11.8021 15.0692 9.99119 15.0692 8.3623H13.1492ZM12.3382 11.7207C11.6906 12.3737 10.4338 12.7679 7.86722 12.7679V14.6879C10.4647 14.6879 12.4568 14.3277 13.7015 13.0727L12.3382 11.7207ZM7.86722 12.7679C5.3006 12.7679 4.04381 12.3737 3.39613 11.7207L2.03289 13.0727C3.27761 14.3277 5.26974 14.6879 7.86722 14.6879V12.7679ZM3.39615 11.7207C2.75341 11.0726 2.58518 10.0471 2.58518 8.3623H0.665183C0.665183 9.99119 0.772798 11.8021 2.03287 13.0727L3.39615 11.7207ZM2.58518 8.3623C2.58518 7.19006 2.66729 6.3905 2.9373 5.82459L1.20444 4.99779C0.72843 5.99546 0.665183 7.19458 0.665183 8.3623H2.58518ZM2.9373 5.82459C3.18386 5.30784 3.61457 4.9338 4.48668 4.69142L3.97255 2.84153C2.70566 3.19363 1.74644 3.86182 1.20444 4.9978L2.9373 5.82459ZM4.52647 4.67943C4.76911 4.60053 5.03828 4.45281 5.26091 4.20784L3.84 2.91655C3.85957 2.89502 3.87826 2.88102 3.8925 2.87223C3.90639 2.86365 3.91955 2.85782 3.93277 2.85352L4.52647 4.67943ZM5.26239 4.20621L5.26305 4.20547L3.83919 2.91744L3.83853 2.91818L5.26239 4.20621ZM5.26013 4.20869C5.37609 4.08166 5.46467 3.91305 5.52442 3.79618L3.81488 2.92218C3.80155 2.94826 3.79102 2.96805 3.78306 2.98257C3.77501 2.99726 3.77033 3.0052 3.76872 3.00788C3.76797 3.00913 3.76833 3.00848 3.76976 3.00627C3.77113 3.00412 3.77408 2.9996 3.77851 2.99322C3.78282 2.98702 3.78974 2.97732 3.79912 2.96522C3.8039 2.95906 3.80975 2.9517 3.81664 2.94343C3.82348 2.93521 3.832 2.92531 3.84211 2.91423L5.26013 4.20869ZM5.5244 3.79622C5.54338 3.7591 5.56424 3.71718 5.58355 3.67843L3.86499 2.8223C3.84424 2.86395 3.82833 2.89588 3.8149 2.92214L5.5244 3.79622ZM5.58357 3.67838C5.63362 3.57791 5.68267 3.47977 5.73079 3.39276L4.0506 2.46358C3.97917 2.59274 3.91198 2.72796 3.86496 2.82235L5.58357 3.67838ZM5.73078 3.39276C5.88158 3.12009 6.01844 2.96456 6.16544 2.90438L5.43801 1.12752C4.64393 1.4526 4.23663 2.12721 4.05061 2.46357L5.73078 3.39276ZM6.16428 2.90485C6.24803 2.8707 6.46005 2.82672 6.79108 2.79447L6.60494 0.883516C6.26879 0.916258 5.80693 0.977046 5.43917 1.12704L6.16428 2.90485ZM6.79107 2.79447C7.10587 2.76381 7.48299 2.74738 7.86434 2.74665L7.86064 0.826651C7.43252 0.827476 6.99299 0.845721 6.60495 0.883515L6.79107 2.79447ZM7.86434 2.74665C8.24578 2.74591 8.62305 2.7609 8.93834 2.79113L9.12161 0.879896C8.73008 0.842353 8.28854 0.825825 7.86064 0.826651L7.86434 2.74665ZM5.80061 2.01641C5.32989 2.2096 5.05806 2.62553 4.89069 2.92817L6.57087 3.85736C6.59789 3.8085 6.62012 3.7725 6.63759 3.7466C6.65519 3.72052 6.66536 3.70858 6.66754 3.70613C6.67333 3.6996 6.62972 3.75154 6.5296 3.79263L5.80061 2.01641ZM4.89071 2.92813C4.82935 3.03908 4.77904 3.14053 4.73614 3.22677L6.45523 4.08183C6.50009 3.99163 6.53272 3.92633 6.57086 3.85739L4.89071 2.92813ZM4.73619 3.22667C4.71326 3.27276 4.69227 3.31493 4.66966 3.35916L6.37917 4.23321C6.40731 4.17817 6.43285 4.12681 6.45518 4.08193L4.73619 3.22667ZM4.66963 3.35921C4.64033 3.41653 4.61624 3.46186 4.59185 3.50191C4.58019 3.52106 4.5704 3.53575 4.56256 3.54662C4.55461 3.55765 4.55063 3.562 4.55111 3.56147L5.97013 4.85483C6.18172 4.62269 6.3199 4.34915 6.3792 4.23316L4.66963 3.35921ZM4.55033 3.56233C4.45584 3.66625 4.33571 3.73313 4.22269 3.76869L4.79889 5.60019C5.17939 5.48048 5.61073 5.25011 5.97091 4.85397L4.55033 3.56233ZM4.22321 3.76853C4.22783 3.76708 4.23319 3.76548 4.23925 3.7638L4.74976 5.61469C4.76673 5.61001 4.78295 5.6052 4.79837 5.60035L4.22321 3.76853ZM4.23897 3.76388C3.16311 4.06098 2.46591 4.58323 2.07087 5.4112L3.80374 6.23798C3.90356 6.02877 4.0722 5.8018 4.75005 5.61461L4.23897 3.76388ZM2.07087 5.41119C1.69768 6.19336 1.62518 7.19338 1.62518 8.3623H3.54518C3.54518 7.18511 3.63722 6.58699 3.80374 6.23798L2.07087 5.41119ZM1.62518 8.3623C1.62518 10.0174 1.76262 11.4369 2.71453 12.3967L4.07776 11.0446C3.74494 10.709 3.54518 10.0792 3.54518 8.3623H1.62518ZM2.7145 12.3966C3.66083 13.3509 5.28556 13.7279 7.86722 13.7279V11.8079C5.31496 11.8079 4.42659 11.3964 4.0778 11.0447L2.7145 12.3966ZM7.86722 13.7279C10.4488 13.7279 12.0736 13.3509 13.0199 12.3966L11.6566 11.0447C11.3078 11.3964 10.4194 11.8079 7.86722 11.8079V13.7279ZM13.0199 12.3967C13.9718 11.4369 14.1092 10.0174 14.1092 8.3623H12.1892C12.1892 10.0792 11.9895 10.7091 11.6567 11.0446L13.0199 12.3967ZM14.1092 8.3623C14.1092 7.19342 14.0367 6.19335 13.6635 5.41115L11.9307 6.23802C12.0972 6.587 12.1892 7.18508 12.1892 8.3623H14.1092ZM13.6635 5.4112C13.2685 4.58324 12.5713 4.06098 11.4954 3.76388L10.9844 5.61461C11.6622 5.8018 11.8308 6.02876 11.9306 6.23797L13.6635 5.4112ZM11.4944 3.76361C11.5017 3.76561 11.5075 3.76737 11.5115 3.76863L10.9347 5.59995C10.9499 5.60471 10.9668 5.60979 10.9853 5.61488L11.4944 3.76361ZM11.5122 3.76885C11.399 3.7331 11.2783 3.66595 11.1841 3.56236L9.76353 4.85402C10.1245 5.25102 10.5568 5.48058 10.934 5.59973L11.5122 3.76885ZM11.1833 3.56144C11.1837 3.56196 11.1799 3.55771 11.1721 3.54691C11.1644 3.53626 11.1548 3.52184 11.1433 3.50298C11.1194 3.46352 11.0957 3.41883 11.0668 3.3619L9.35526 4.23196C9.41413 4.34776 9.55171 4.62167 9.76437 4.85495L11.1833 3.56144ZM11.0666 3.36151C11.0444 3.31794 11.0242 3.27692 11.0011 3.23031L9.2807 4.08278C9.30215 4.12606 9.32758 4.17757 9.35546 4.23234L11.0666 3.36151ZM11.0016 3.23129C10.9591 3.14527 10.9092 3.04408 10.8479 2.933L9.16676 3.86047C9.20416 3.92827 9.23606 3.99243 9.28021 4.08179L11.0016 3.23129ZM10.8481 2.93338C10.68 2.62832 10.4093 2.21715 9.93792 2.01812L9.19109 3.78692C9.10415 3.75021 9.06622 3.7054 9.07158 3.71143C9.07415 3.71432 9.08431 3.7263 9.10152 3.75186C9.11865 3.77729 9.1403 3.81246 9.16655 3.86009L10.8481 2.93338ZM9.93602 2.01732C9.70466 1.92022 9.36323 1.86747 9.02996 1.83551L8.84669 3.74675C8.99175 3.76065 9.09855 3.77627 9.16916 3.78944C9.20447 3.79602 9.22572 3.80107 9.23507 3.80352C9.24889 3.80714 9.22991 3.80321 9.19299 3.78772L9.93602 2.01732ZM9.02997 1.83551C8.67657 1.80162 8.26715 1.78587 7.86249 1.78665L7.8662 3.70665C8.22442 3.70596 8.56956 3.72017 8.84669 3.74674L9.02997 1.83551ZM7.86249 1.78665C7.45775 1.78743 7.04938 1.80477 6.69798 1.839L6.88414 3.74995C7.16225 3.72286 7.50819 3.70734 7.8662 3.70665L7.86249 1.78665ZM6.698 1.839C6.36631 1.8713 6.02948 1.92329 5.80332 2.0153L6.52689 3.79374C6.49172 3.80805 6.47441 3.81143 6.4894 3.80759C6.49995 3.80489 6.52228 3.79973 6.5584 3.79308C6.63062 3.7798 6.73865 3.76412 6.88413 3.74995L6.698 1.839Z"
        fill={fill}
        mask="url(#path-3-inside-2_2550_3747)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5308 6.0801C10.5308 5.815 10.7457 5.6001 11.0108 5.6001H11.0165C11.2817 5.6001 11.4965 5.815 11.4965 6.0801C11.4965 6.34519 11.2817 6.5601 11.0165 6.5601H11.0108C10.7457 6.5601 10.5308 6.34519 10.5308 6.0801Z"
        fill={fill}
      />
    </svg>
  );
};

export const BarcodeIcon = ({ width, height, stroke }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.85164 1.59351H7.14846C8.26063 1.59351 8.95817 2.38132 8.95817 3.49564V6.50354C8.95817 7.61787 8.26409 8.40571 7.14846 8.40571H2.85207C1.73603 8.40571 1.0415 7.61787 1.0415 6.50354V3.49564C1.0415 2.38132 1.73603 1.59351 2.85164 1.59351Z"
        stroke={stroke}
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M2.82324 3.34473V6.65304"
        stroke={stroke}
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M5.7251 3.34473V6.65304"
        stroke={stroke}
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M7.17676 3.34473V4.92421"
        stroke={stroke}
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M7.17676 6.19727V6.61364"
        stroke={stroke}
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M4.27393 6.61539V5.03589"
        stroke={stroke}
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M4.27393 3.76208V3.3457"
        stroke={stroke}
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CardIcon = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 10 10`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.50881 2.27805C1.8459 1.91642 2.32484 1.71558 2.88637 1.71558H6.91444C7.47732 1.71558 7.95652 1.91628 8.29348 2.27817C8.6282 2.63764 8.80024 3.13178 8.80024 3.68191V6.31683C8.80024 6.86715 8.6282 7.36131 8.2934 7.72075C7.95632 8.08263 7.47704 8.28315 6.91404 8.28315H2.88637C2.32354 8.28315 1.84442 8.08259 1.50752 7.72071C1.17288 7.36123 1.00098 6.86707 1.00098 6.31683V3.68191C1.00098 3.13143 1.17391 2.63734 1.50881 2.27805ZM1.94771 2.68716C1.73353 2.91694 1.60098 3.25602 1.60098 3.68191V6.31683C1.60098 6.74335 1.733 7.08235 1.94667 7.31187C2.15808 7.53895 2.47166 7.68315 2.88637 7.68315H6.91404C7.329 7.68315 7.6428 7.53891 7.85432 7.31179C8.06812 7.08227 8.20024 6.74327 8.20024 6.31683V3.68191C8.20024 3.25567 8.06816 2.91664 7.85436 2.68704C7.6428 2.45986 7.32912 2.31558 6.91444 2.31558H2.88637C2.47347 2.31558 2.15971 2.45972 1.94771 2.68716Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 4.13447C1 3.96878 1.13432 3.83447 1.3 3.83447H8.49924C8.66492 3.83447 8.79924 3.96878 8.79924 4.13447C8.79924 4.30018 8.66492 4.43446 8.49924 4.43446H1.3C1.13432 4.43446 1 4.30018 1 4.13447Z"
        fill={fill}
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.55957 6.26875C2.55957 6.10307 2.69389 5.96875 2.85957 5.96875H3.43084C3.59653 5.96875 3.73084 6.10307 3.73084 6.26875C3.73084 6.43443 3.59653 6.56875 3.43084 6.56875H2.85957C2.69389 6.56875 2.55957 6.43443 2.55957 6.26875Z"
        fill={fill}
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.11328 6.26875C4.11328 6.10307 4.2476 5.96875 4.41328 5.96875H4.98456C5.15024 5.96875 5.28456 6.10307 5.28456 6.26875C5.28456 6.43443 5.15024 6.56875 4.98456 6.56875H4.41328C4.2476 6.56875 4.11328 6.43443 4.11328 6.26875Z"
        fill={fill}
      />
    </svg>
  );
};

export const WalletIcon = ({ width, height, stroke }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 32 32`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 16C0 27.9991 4.00087 32 16 32C27.9991 32 32 27.9991 32 16C32 4.00087 27.9991 0 16 0C4.00087 0 0 4.00087 0 16Z"
        fill="none"
      />
      <path
        d="M14 23.458H10.9654C8.52158 23.458 7.00195 21.7341 7.00195 19.2922V12.7049C7.00195 10.264 8.52936 8.53906 10.9654 8.53906H21.0356C23.4795 8.53906 25.0001 10.264 25.0001 12.7049V16.2922"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 13.834H24.9981"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.625 17C23.179 17 25.25 19.0705 25.25 21.625C25.25 24.179 23.179 26.25 20.625 26.25C18.0705 26.25 16 24.179 16 21.625C16 19.071 18.071 17 20.625 17Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5946 21.6313H22.5991"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5901 21.6313H20.5946"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5856 21.6313H18.5901"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LeftIconFill = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.36922 10.869C7.42572 10.811 7.63906 10.563 7.8378 10.359C9.00292 9.076 12.0424 6.976 13.6332 6.335C13.8748 6.232 14.4856 6.014 14.812 6C15.1247 6 15.4228 6.072 15.7073 6.218C16.0619 6.422 16.3463 6.743 16.5022 7.122C16.6025 7.385 16.7584 8.172 16.7584 8.186C16.9143 9.047 17 10.446 17 11.992C17 13.465 16.9143 14.807 16.7867 15.681C16.772 15.695 16.6162 16.673 16.4457 17.008C16.133 17.62 15.5222 18 14.8685 18L14.812 18C14.3863 17.985 13.491 17.605 13.491 17.591C11.9859 16.949 9.01656 14.952 7.82319 13.625C7.82319 13.625 7.48709 13.284 7.34096 13.071C7.11301 12.765 7 12.386 7 12.007C7 11.584 7.12762 11.19 7.36922 10.869Z"
        fill={fill}
      />
    </svg>
  );
};

export const CalenderIconOutline = ({ width, height, fill, onClick }) => {
  return (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2098_51457)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.31537 2.6126C1.8247 3.10323 1.5917 3.92409 1.5917 5.29865C1.5917 6.67325 1.8247 7.49409 2.31537 7.98473C2.80605 8.47537 3.62691 8.70825 5.00132 8.70825C6.37587 8.70825 7.19684 8.47537 7.68759 7.98469C8.17832 7.49409 8.41131 6.67325 8.41131 5.29865C8.41131 3.92409 8.17832 3.10324 7.68759 2.61261C7.19684 2.12197 6.37587 1.88906 5.00132 1.88906C3.62691 1.88906 2.80605 2.12196 2.31537 2.6126ZM1.89112 2.18832C2.55974 1.51976 3.59368 1.28906 5.00132 1.28906C6.40911 1.28906 7.44315 1.51975 8.11179 2.18831C8.78051 2.85688 9.01131 3.89085 9.01131 5.29865C9.01131 6.70649 8.78051 7.74045 8.11179 8.40901C7.44315 9.07757 6.40911 9.30825 5.00132 9.30825C3.59368 9.30825 2.55974 9.07757 1.89112 8.40901C1.2225 7.74045 0.991699 6.70649 0.991699 5.29865C0.991699 3.89085 1.2225 2.85689 1.89112 2.18832Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.10156 3.91792C1.10156 3.75223 1.23587 3.61792 1.40156 3.61792H8.60474C8.77046 3.61792 8.90474 3.75223 8.90474 3.91792C8.90474 4.0836 8.77046 4.21792 8.60474 4.21792H1.40156C1.23587 4.21792 1.10156 4.0836 1.10156 3.91792Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.46289 5.49263C6.46289 5.32695 6.59721 5.19263 6.76289 5.19263H6.76649C6.93217 5.19263 7.06649 5.32695 7.06649 5.49263C7.06649 5.65831 6.93217 5.79263 6.76649 5.79263H6.76289C6.59721 5.79263 6.46289 5.65831 6.46289 5.49263Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.70312 5.49263C4.70312 5.32695 4.83741 5.19263 5.00313 5.19263H5.00672C5.17241 5.19263 5.30673 5.32695 5.30673 5.49263C5.30673 5.65831 5.17241 5.79263 5.00672 5.79263H5.00313C4.83741 5.79263 4.70312 5.65831 4.70312 5.49263Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.94043 5.49263C2.94043 5.32695 3.07474 5.19263 3.24043 5.19263H3.24403C3.40971 5.19263 3.54403 5.32695 3.54403 5.49263C3.54403 5.65831 3.40971 5.79263 3.24403 5.79263H3.24043C3.07474 5.79263 2.94043 5.65831 2.94043 5.49263Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.46289 7.0334C6.46289 6.86772 6.59721 6.7334 6.76289 6.7334H6.76649C6.93217 6.7334 7.06649 6.86772 7.06649 7.0334C7.06649 7.19908 6.93217 7.3334 6.76649 7.3334H6.76289C6.59721 7.3334 6.46289 7.19908 6.46289 7.0334Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.70312 7.0334C4.70312 6.86772 4.83741 6.7334 5.00313 6.7334H5.00672C5.17241 6.7334 5.30673 6.86772 5.30673 7.0334C5.30673 7.19908 5.17241 7.3334 5.00672 7.3334H5.00313C4.83741 7.3334 4.70312 7.19908 4.70312 7.0334Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.94043 7.0334C2.94043 6.86772 3.07474 6.7334 3.24043 6.7334H3.24403C3.40971 6.7334 3.54403 6.86772 3.54403 7.0334C3.54403 7.19908 3.40971 7.3334 3.24403 7.3334H3.24043C3.07474 7.3334 2.94043 7.19908 2.94043 7.0334Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.60469 0.708252C6.77037 0.708252 6.90469 0.842568 6.90469 1.00825V2.31305C6.90469 2.47874 6.77037 2.61305 6.60469 2.61305C6.43897 2.61305 6.30469 2.47874 6.30469 2.31305V1.00825C6.30469 0.842568 6.43897 0.708252 6.60469 0.708252Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.40156 0.708252C3.56725 0.708252 3.70156 0.842568 3.70156 1.00825V2.31305C3.70156 2.47874 3.56725 2.61305 3.40156 2.61305C3.23587 2.61305 3.10156 2.47874 3.10156 2.31305V1.00825C3.10156 0.842568 3.23587 0.708252 3.40156 0.708252Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export const ArrowIconFill = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.684608 2.4345C0.71286 2.4055 0.819533 2.2815 0.918899 2.1795C1.50146 1.538 3.02119 0.488 3.81661 0.1675C3.93741 0.116 4.24282 0.00699995 4.40599 -4.78206e-08C4.56235 -4.09861e-08 4.7114 0.036 4.85363 0.109C5.03093 0.211 5.17316 0.3715 5.2511 0.561C5.30127 0.6925 5.3792 1.086 5.3792 1.093C5.45714 1.5235 5.5 2.223 5.5 2.996C5.5 3.7325 5.45714 4.4035 5.39333 4.8405C5.38602 4.8475 5.30809 5.3365 5.22284 5.504C5.06649 5.81 4.76108 6 4.43424 6L4.40599 6C4.19313 5.9925 3.74549 5.8025 3.74549 5.7955C2.99294 5.4745 1.50828 4.476 0.911593 3.8125C0.911593 3.8125 0.743546 3.642 0.670482 3.5355C0.556503 3.3825 0.5 3.193 0.5 3.0035C0.5 2.792 0.56381 2.595 0.684608 2.4345Z"
        fill={fill}
      />
    </svg>
  );
};

export const DangerIcon = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.93911 5.31485C4.73715 5.31485 4.57324 5.15095 4.57324 4.94899V3.04891C4.57324 2.84695 4.73715 2.68304 4.93911 2.68304C5.14107 2.68304 5.30498 2.84695 5.30498 3.04891V4.94899C5.30498 5.15095 5.14107 5.31485 4.93911 5.31485Z"
        fill={fill}
      />
      <path
        d="M4.57324 6.65633C4.57324 6.85829 4.73959 7.0222 4.94155 7.0222C5.14351 7.0222 5.30742 6.85829 5.30742 6.65633C5.30742 6.45438 5.14351 6.29047 4.94155 6.29047H4.93716C4.7352 6.29047 4.57324 6.45438 4.57324 6.65633Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00025 9.51257C2.17378 9.51257 0.300541 9.39646 0.0268722 7.84616C-0.158013 6.8027 0.642994 5.21289 1.45181 3.79478L1.55376 3.61526C3.03577 0.980038 3.96995 0 5.00025 0C6.03102 0 6.96472 0.980038 8.44624 3.61526L8.54819 3.79478C9.35701 5.21289 10.158 6.8027 9.97313 7.84616C9.69995 9.39646 7.8267 9.51257 5.00025 9.51257ZM5.00025 0.731736C4.30949 0.731736 3.46896 1.70153 2.19086 3.97381L2.08695 4.15724L2.08548 4.15982C1.6736 4.88282 0.583674 6.79602 0.7469 7.71884C0.89276 8.54277 1.84694 8.78083 5.00025 8.78083C8.15354 8.78083 9.10773 8.54277 9.2531 7.71884C9.41633 6.79602 8.32638 4.88282 7.91451 4.15982L7.91305 4.15724L7.80914 3.97381C6.53153 1.70153 5.6915 0.731736 5.00025 0.731736Z"
        fill={fill}
      />
    </svg>
  );
};

export const RefundFromWalletOutline = ({
  width,
  height,
  stroke,
  fill,
}: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0356 4.53906H6.96543C4.52936 4.53906 3.00195 6.26396 3.00195 8.70489V15.2922C3.00195 17.7341 4.52158 19.458 6.96543 19.458H17.0346C19.4795 19.458 21.0001 17.7341 21.0001 15.2922V8.70489C21.0001 6.26396 19.4795 4.53906 17.0356 4.53906Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 9.83398H20.9981"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.89941 15.1699H8.32759"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7832 15.1699H12.2114"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 9.00002C11 4.50033 12.5003 3 17 3C21.4997 3 23 4.50033 23 9.00002C23 13.4997 21.4997 15 17 15C12.5003 15 11 13.4997 11 9.00002Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6919 8.95935C13.9737 8.67874 14.4295 8.6797 14.7101 8.96146L16.9993 11.2601L19.2885 8.96146C19.5691 8.6797 20.025 8.67874 20.3068 8.95935C20.5886 9.23995 20.5894 9.69576 20.3089 9.97752L17.5095 12.7884C17.3744 12.9241 17.1908 13.0004 16.9993 13.0004C16.8079 13.0004 16.6243 12.9241 16.4892 12.7884L13.6898 9.97752C13.4092 9.69576 13.4102 9.23995 13.6919 8.95935Z"
        fill={fill}
      />
      <rect x="16.28" y="4" width="1.44" height="9" rx="0.72" fill={fill} />
    </svg>
  );
};

export const EditSquareOutline = ({ width, height, stroke }: IconType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_3374_970)">
        <path
          d="M6.0001 1.375C2.53162 1.375 1.37512 2.5315 1.37512 5.99999C1.37512 9.46849 2.53162 10.625 6.0001 10.625C9.4686 10.625 10.6251 9.46849 10.6251 5.99999"
          stroke={stroke}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.76425 2.15182C9.26775 1.71232 8.50925 1.75832 8.06975 2.25482C8.06975 2.25482 5.88525 4.72232 5.12775 5.57883C4.36927 6.43483 4.92527 7.61733 4.92527 7.61733C4.92527 7.61733 6.17725 8.01383 6.92425 7.16983C7.67175 6.32583 9.86725 3.84632 9.86725 3.84632C10.3068 3.34982 10.2603 2.59132 9.76425 2.15182Z"
          stroke={stroke}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.50452 2.90039L9.30202 4.49189"
          stroke={stroke}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const ExitIcon = ({ width, height, fill }: IconType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_3374_970)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.87744 4.88154C8.87744 4.71586 8.74313 4.58154 8.57744 4.58154H3.76104C3.59536 4.58154 3.46104 4.71586 3.46104 4.88154C3.46104 5.04722 3.59536 5.18154 3.76104 5.18154H8.57744C8.74313 5.18154 8.87744 5.04722 8.87744 4.88154Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.1445 3.50359C5.02758 3.38619 4.83762 3.3858 4.72022 3.50271L3.54902 4.66912C3.4925 4.7254 3.4607 4.80192 3.4607 4.88168C3.4607 4.96148 3.4925 5.03796 3.54902 5.09424L4.72022 6.26064C4.83762 6.37756 5.02758 6.37716 5.1445 6.2598C5.26142 6.1424 5.26102 5.95244 5.14362 5.83552L4.18586 4.88168L5.14362 3.92785C5.26102 3.81093 5.26142 3.62099 5.1445 3.50359Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.9451 1.81329C6.25578 2.04351 6.4111 2.41987 6.47498 3.11279C6.49018 3.27778 6.63626 3.39919 6.80124 3.38398C6.96623 3.36878 7.08765 3.2227 7.07244 3.05772C7.00432 2.31863 6.82563 1.719 6.30232 1.33122C5.8006 0.959432 5.04468 0.833252 3.97372 0.833252C2.55376 0.833252 1.68076 1.05587 1.23272 1.78523C1.0192 2.13285 0.924844 2.56337 0.878964 3.05621C0.833324 3.54711 0.833324 4.13685 0.833324 4.82061V4.84589C0.833324 5.52965 0.833324 6.11941 0.878964 6.61029C0.924844 7.10313 1.0192 7.53365 1.23272 7.88129C1.68076 8.61065 2.55376 8.83325 3.97372 8.83325C5.04468 8.83325 5.8006 8.70709 6.30232 8.33529C6.82563 7.94753 7.00432 7.34789 7.07244 6.60881C7.08765 6.44381 6.96623 6.29773 6.80124 6.28253C6.63626 6.26733 6.49018 6.38873 6.47498 6.55373C6.4111 7.24665 6.25578 7.62301 5.9451 7.85321C5.6128 8.09945 5.03472 8.23325 3.97372 8.23325C2.55324 8.23325 2.00604 7.99389 1.74396 7.56725C1.60248 7.33685 1.51932 7.01589 1.4764 6.55473C1.4336 6.09465 1.43332 5.53213 1.43332 4.83325C1.43332 4.13437 1.4336 3.57187 1.4764 3.1118C1.51932 2.65063 1.60248 2.32965 1.74396 2.09928C2.00604 1.67264 2.55324 1.43325 3.97372 1.43325C5.03472 1.43325 5.6128 1.56707 5.9451 1.81329Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export const OIcon = ({ width, height, fill, className = '' }: IconType) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.2679 9.81515C21.5079 8.02013 19.125 7.04279 16.6014 7.00216C16.5909 7.00216 16.5809 7 16.5694 7C16.5694 7 16.5567 7 16.5503 7H16.5445H16.5355C16.5261 7 16.5197 7 16.5197 7C16.5027 7 16.492 7.00143 16.492 7.00143C13.9571 6.99637 11.5862 7.95989 9.79559 9.723C8.00159 11.4897 7.00123 13.8558 6.97996 16.3865C6.95654 19.1008 7.84792 21.5814 9.4658 23.4273C8.5823 23.7995 8.15429 23.9918 7.15488 24.3893C5.40318 25.0859 4.54669 27.0767 5.24116 28.8356C5.76858 30.1705 7.03754 30.9882 8.38394 30.9999C8.81195 31.0035 9.25119 30.9347 9.66988 30.7583C14.3813 28.7745 19.7263 26.6459 21.8455 24.9959C21.9961 24.8791 22.4356 24.5512 22.6934 24.3124C25.1425 22.0415 25.9669 20.073 25.9997 16.3001C26.0202 13.7694 25.0309 11.6138 23.2679 9.81515ZM16.5305 19.9758C14.6891 19.9591 13.2099 18.4471 13.2256 16.5991C13.2412 14.7504 14.7467 13.2659 16.588 13.2818C18.4291 13.2985 19.9084 14.8106 19.8926 16.6586C19.8771 18.5065 18.3708 19.9925 16.5305 19.9758Z"
        fill={fill}
      />
    </svg>
  );
};

export const CategoryVarietyIcon = ({
  width,
  height,
  fill,
  className = '',
}: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.30016 5.61254C3.88766 5.61254 4.3585 6.08795 4.3585 6.67962V8.10004C4.3585 8.68754 3.88766 9.16671 3.30016 9.16671H1.89183C1.3085 9.16671 0.833496 8.68754 0.833496 8.10004V6.67962C0.833496 6.08795 1.3085 5.61254 1.89183 5.61254H3.30016ZM8.10854 5.61254C8.69187 5.61254 9.16687 6.08795 9.16687 6.67962V8.10004C9.16687 8.68754 8.69187 9.16671 8.10854 9.16671H6.7002C6.1127 9.16671 5.64187 8.68754 5.64187 8.10004V6.67962C5.64187 6.08795 6.1127 5.61254 6.7002 5.61254H8.10854ZM3.30016 0.833496C3.88766 0.833496 4.3585 1.31266 4.3585 1.90058V3.321C4.3585 3.91266 3.88766 4.38766 3.30016 4.38766H1.89183C1.3085 4.38766 0.833496 3.91266 0.833496 3.321V1.90058C0.833496 1.31266 1.3085 0.833496 1.89183 0.833496H3.30016ZM8.10854 0.833496C8.69187 0.833496 9.16687 1.31266 9.16687 1.90058V3.321C9.16687 3.91266 8.69187 4.38766 8.10854 4.38766H6.7002C6.1127 4.38766 5.64187 3.91266 5.64187 3.321V1.90058C5.64187 1.31266 6.1127 0.833496 6.7002 0.833496H8.10854Z"
        fill={fill}
      />
    </svg>
  );
};

export const ArrowRightBoxIcon = ({
  width,
  height,
  stroke,
  className,
}: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M23.4 12C23.4 7.5336 22.6477 4.74667 20.9505 3.04951C19.2533 1.35235 16.4664 0.599999 12 0.6C7.5336 0.6 4.74667 1.35235 3.04951 3.04951C1.35235 4.74667 0.6 7.5336 0.600001 12C0.600001 16.4664 1.35235 19.2533 3.04951 20.9505C4.74667 22.6476 7.5336 23.4 12 23.4C16.4664 23.4 19.2533 22.6476 20.9505 20.9505C22.6477 19.2533 23.4 16.4664 23.4 12Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.95833 7.91665C9.95833 7.91665 14.0417 10.334 14.0417 12C14.0417 13.6654 9.95833 16.0833 9.95833 16.0833"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AboutUs_1 = ({ width, height, fill, className }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 -5.45107e-07C27.9991 -9.53907e-07 32 4.00086 32 16C32 27.9991 27.9991 32 16 32C4.00087 32 1.57026e-06 27.9991 8.9732e-07 16C2.24379e-07 4.00086 4.00086 -1.36306e-07 16 -5.45107e-07Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6643 15.3037L20.5859 15.537C20.5409 15.5462 20.4968 15.5512 20.4526 15.5512C20.1651 15.5512 19.9059 15.3512 19.8418 15.0587C19.7701 14.7212 19.9834 14.3878 20.3209 14.3145L21.3993 14.0811C21.7376 14.0136 22.0693 14.2228 22.1426 14.5595C22.2151 14.8978 22.0009 15.2303 21.6643 15.3037ZM19.9026 19.1003C19.8934 19.1012 19.8843 19.1012 19.8751 19.1012C19.5418 19.1012 19.2651 18.8378 19.2509 18.5028C19.2059 17.4562 18.5784 17.0695 18.0593 16.9303C17.3201 16.732 16.5643 16.972 16.3468 17.3128C16.1609 17.6028 15.7776 17.6887 15.4834 17.5028C15.1926 17.317 15.1076 16.9303 15.2934 16.6403C15.7684 15.897 16.8451 15.5053 17.9184 15.6337C18.2026 14.7028 17.7351 14.1945 17.5659 14.0486C17.3059 13.8228 17.2768 13.4278 17.5026 13.167C17.7293 12.9053 18.1251 12.8795 18.3843 13.1028C19.0109 13.6461 19.5151 14.702 19.1034 16.027C19.9418 16.5087 20.4534 17.3662 20.5001 18.4487C20.5143 18.7937 20.2476 19.0853 19.9026 19.1003ZM13.8726 14.0103C13.836 14.0228 13.8026 14.0395 13.7643 14.0503C13.5518 14.1095 13.3318 14.1386 13.1176 14.1386C12.4535 14.1386 11.831 13.8661 11.5526 13.4103C11.3718 13.1153 11.466 12.7311 11.7601 12.5511C12.0535 12.3703 12.4326 12.4636 12.6151 12.7511C12.7043 12.8445 13.1251 12.967 13.5093 12.8195C13.8635 12.6836 14.0351 12.372 14.0351 11.8678C14.0351 11.5228 14.3151 11.2428 14.6601 11.2428C15.0051 11.2428 15.2851 11.5228 15.2851 11.8678C15.2851 12.4145 15.1434 12.8903 14.8851 13.2636C15.0434 13.4486 15.3018 13.6411 15.6668 13.5445C15.9959 13.4611 16.3409 13.662 16.4259 13.9978C16.5093 14.3328 16.3068 14.672 15.9726 14.757C15.7984 14.8003 15.6309 14.8203 15.4684 14.8203C14.7976 14.8203 14.241 14.4703 13.8726 14.0103ZM24.5418 15.3487C24.5543 14.5062 24.1784 13.6561 23.4509 12.8853C23.0368 11.8053 22.3409 11.0803 21.4443 10.7295C21.4176 10.6461 21.4076 10.562 21.3709 10.4803C20.9584 9.55114 20.0043 8.89114 18.9393 8.79947C18.4626 8.75781 17.9984 8.84031 17.5634 9.02364C14.8268 8.15947 12.6851 9.38531 11.6151 10.022C10.8968 10.0253 10.2176 10.2403 9.63429 10.6795C8.74179 11.3536 8.20595 12.4628 8.21179 13.5245C8.19179 13.5461 8.16679 13.5611 8.14929 13.5861C7.53595 14.5028 7.32095 15.5628 7.54345 16.5728C7.72595 17.4028 8.20095 18.1045 8.87262 18.6003C9.72929 18.942 10.7885 18.8237 11.316 18.452C12.016 17.9512 12.341 17.1145 12.2893 16.5828C12.256 16.2395 12.5076 15.9337 12.851 15.9012C13.191 15.857 13.4993 16.1187 13.5326 16.4628C13.6343 17.5053 13.0485 18.7053 12.1076 19.4162C12.3626 19.8537 12.7468 20.2028 13.2485 20.4028C14.011 20.7078 14.8801 20.6462 15.5793 20.2737C16.0684 20.7645 16.7368 20.9695 17.3243 20.9362L18.1301 22.8412C18.2251 23.0787 18.5134 23.2753 18.7684 23.2753H20.1751C20.5551 23.2753 20.8643 22.9653 20.8643 22.5837V21.7195C23.4901 21.377 24.0859 19.9353 24.2209 19.3003C24.3743 18.5787 24.1926 17.8062 23.7943 17.272C24.2809 16.6653 24.5318 16.0203 24.5418 15.3487Z"
        fill="white"
      />
    </svg>
  );
};

export const AboutUs_2 = ({ width, height, fill, className }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 -5.45107e-07C27.9991 -9.53907e-07 32 4.00086 32 16C32 27.9991 27.9991 32 16 32C4.00087 32 1.57026e-06 27.9991 8.9732e-07 16C2.24379e-07 4.00086 4.00086 -1.36306e-07 16 -5.45107e-07Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7444 16.0267C19.3124 16.3705 19.9613 16.5578 20.6252 16.5699C21.073 16.5668 21.515 16.4684 21.9217 16.2812C22.3285 16.094 22.6907 15.8223 22.9843 15.4843C23.7784 14.5578 24.1773 13.3569 24.0955 12.1395C24.048 10.9693 23.7909 9.8172 23.3363 8.73787C23.2842 8.63283 23.2022 8.54556 23.1005 8.48706C22.9989 8.42855 22.8822 8.40142 22.7652 8.40907C21.6037 8.55453 20.4777 8.90675 19.4404 9.44907C18.346 9.98802 17.5056 10.9334 17.0988 12.0835C16.8482 12.8285 16.877 13.6393 17.1797 14.3647C17.4824 15.0901 18.0385 15.6808 18.7444 16.0267ZM11.1821 18.8977C11.6575 19.1506 12.1868 19.2856 12.7253 19.2913C13.2357 19.277 13.7363 19.1484 14.1903 18.9148C14.6443 18.6812 15.0402 18.3486 15.3485 17.9417C15.8911 17.3726 16.2083 16.6256 16.241 15.8399C16.2737 15.0542 16.0196 14.2835 15.5261 13.6713C14.7466 12.7329 13.6307 12.1371 12.4173 12.0113C11.2568 11.8607 10.0788 11.9189 8.93885 12.1833C8.82634 12.2175 8.72636 12.2839 8.65115 12.3743C8.57595 12.4648 8.52883 12.5752 8.51565 12.6921C8.4645 13.8616 8.62245 15.0309 8.98206 16.1449C9.32742 17.3147 10.1171 18.3029 11.1821 18.8977ZM16.773 23.4418C16.8823 23.5384 17.0232 23.5918 17.1692 23.592C17.1957 23.5921 17.2221 23.5905 17.2484 23.5872C17.3266 23.5772 17.4019 23.5519 17.4703 23.5128C17.5387 23.4737 17.5988 23.4214 17.647 23.3591C17.6952 23.2968 17.7306 23.2256 17.7514 23.1496C17.7721 23.0735 17.7775 22.9942 17.7676 22.916C17.0372 17.1632 20.2204 14.348 20.3564 14.2312C20.4736 14.127 20.5454 13.9809 20.5562 13.8244C20.5671 13.6679 20.5162 13.5134 20.4146 13.3939C20.3129 13.2745 20.1685 13.1996 20.0122 13.1853C19.856 13.171 19.7004 13.2185 19.5787 13.3176C19.4643 13.4126 17.5593 15.0706 16.7822 18.3596C15.6249 16.5732 13.7403 15.8081 13.6324 15.7653C13.5588 15.7363 13.4803 15.7222 13.4013 15.7235C13.3223 15.725 13.2443 15.7419 13.1718 15.7734C13.0994 15.805 13.0338 15.8505 12.979 15.9074C12.9241 15.9642 12.881 16.0313 12.852 16.1049C12.8231 16.1784 12.8089 16.2569 12.8103 16.3359C12.8117 16.415 12.8286 16.4929 12.8602 16.5654C12.8917 16.6378 12.9372 16.7034 12.994 16.7582C13.0509 16.8131 13.1181 16.8563 13.1916 16.8853C13.2204 16.8965 16.1244 18.0717 16.4444 20.8717C16.4475 20.8988 16.4525 20.9255 16.4592 20.9518C16.4454 21.6131 16.4797 22.3182 16.5747 23.0672C16.593 23.212 16.6635 23.3452 16.773 23.4418Z"
        fill="white"
      />
    </svg>
  );
};

export const AboutUs_3 = ({ width, height, fill, className }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 -5.45107e-07C27.9991 -9.53907e-07 32 4.00086 32 16C32 27.9991 27.9991 32 16 32C4.00087 32 1.57026e-06 27.9991 8.9732e-07 16C2.24379e-07 4.00086 4.00086 -1.36306e-07 16 -5.45107e-07Z"
        fill={fill}
      />
      <path
        d="M14.465 18.4183C14.8886 18.6195 15.347 18.7339 15.8178 18.7326C16.2802 18.7326 16.7418 18.6278 17.1714 18.4182C17.7531 18.1346 18.3358 17.8524 18.9183 17.5702C20.0078 17.0425 21.0974 16.5149 22.1817 15.9769C22.2885 15.9238 22.4138 16.002 22.413 16.1213L22.4002 18.2351C22.3978 18.5663 22.665 18.8367 22.9962 18.8391H23.0002C23.3298 18.8391 23.5978 18.5727 23.6002 18.2431L23.6266 13.9151C23.6269 13.8731 23.6228 13.832 23.6149 13.7924C23.5698 13.0118 23.115 12.3224 22.4042 11.9719L17.1706 9.41346C16.3114 8.99106 15.3266 8.99186 14.469 9.41266L9.24257 11.9711C8.49137 12.3351 8.02577 13.0807 8.02657 13.9159C8.02657 14.751 8.49297 15.495 9.24097 15.8574L11.0714 16.7542C11.093 16.7686 11.1162 16.7822 11.141 16.7934L14.465 18.4183Z"
        fill="white"
      />
      <path
        d="M17.6094 19.3169C17.0406 19.5953 16.4302 19.7337 15.8182 19.7337C15.1946 19.7337 14.5824 19.5942 14.0262 19.3161L11.2349 17.9526C11.1286 17.9007 11.0046 17.9782 11.0046 18.0964V20.2312C11.0046 21.0928 11.5094 21.8592 12.2918 22.1856C13.4566 22.6632 14.623 22.9032 15.7814 22.9032C16.9406 22.9032 18.0942 22.6632 19.231 22.184C20.0062 21.8584 20.507 21.0984 20.507 20.2472V18.1602C20.507 18.0419 20.3832 17.9646 20.277 18.0163L17.6094 19.3169Z"
        fill="white"
      />
    </svg>
  );
};

export const AboutUs_4 = ({ width, height, fill, className }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 -5.45107e-07C27.9991 -9.53907e-07 32 4.00086 32 16C32 27.9991 27.9991 32 16 32C4.00087 32 1.57026e-06 27.9991 8.9732e-07 16C2.24379e-07 4.00086 4.00086 -1.36306e-07 16 -5.45107e-07Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5975 8.56931C16.5044 8.34568 16.2859 8.20001 16.0437 8.20001C15.8014 8.20001 15.5829 8.34568 15.4897 8.56931C15.0478 9.63036 13.7212 9.98582 12.808 9.2879C12.6155 9.1408 12.3534 9.12389 12.1437 9.24501C11.9339 9.36614 11.8175 9.60153 11.8486 9.84177C11.9964 10.9817 11.0253 11.9528 9.88541 11.805C9.64517 11.7738 9.40977 11.8902 9.28865 12.1C9.16753 12.3098 9.18444 12.5719 9.33153 12.7643C10.0295 13.6776 9.674 15.0042 8.61295 15.4462C8.38932 15.5393 8.24365 15.7578 8.24365 16C8.24365 16.2423 8.38932 16.4607 8.61295 16.5539C9.674 16.9959 10.0295 18.3224 9.33153 19.2357C9.18444 19.4282 9.16753 19.6903 9.28865 19.9C9.40977 20.1098 9.64517 20.2262 9.88541 20.1951C11.0253 20.0472 11.9964 21.0183 11.8486 22.1583C11.8175 22.3985 11.9339 22.6339 12.1437 22.755C12.3534 22.8762 12.6155 22.8592 12.808 22.7121C13.7212 22.0142 15.0478 22.3697 15.4897 23.4307C15.5829 23.6543 15.8014 23.8 16.0437 23.8C16.2859 23.8 16.5044 23.6543 16.5975 23.4307C17.0395 22.3697 18.3661 22.0142 19.2793 22.7121C19.4718 22.8592 19.7338 22.8762 19.9437 22.755C20.1534 22.6339 20.2698 22.3985 20.2387 22.1583C20.0909 21.0183 21.062 20.0472 22.2019 20.1951C22.4421 20.2262 22.6775 20.1098 22.7986 19.9C22.9197 19.6903 22.9029 19.4282 22.7557 19.2357C22.0578 18.3224 22.4133 16.9959 23.4744 16.5539C23.698 16.4607 23.8437 16.2423 23.8437 16C23.8437 15.7578 23.698 15.5393 23.4744 15.4462C22.4133 15.0042 22.0578 13.6776 22.7557 12.7643C22.9029 12.5719 22.9197 12.3098 22.7986 12.1C22.6775 11.8902 22.4421 11.7738 22.2019 11.805C21.062 11.9528 20.0909 10.9817 20.2387 9.84177C20.2698 9.60153 20.1534 9.36614 19.9437 9.24501C19.7338 9.12389 19.4718 9.1408 19.2793 9.2879C18.3661 9.98582 17.0395 9.63036 16.5975 8.56931ZM14.3577 16.9482C14.1784 16.6694 13.8072 16.5889 13.5285 16.7681C13.2498 16.9474 13.1692 17.3186 13.3485 17.5974C13.7171 18.1703 14.5496 18.7382 15.5104 18.9018C16.525 19.0746 17.6976 18.8007 18.6724 17.6631C18.888 17.4115 18.8588 17.0327 18.6072 16.8171C18.3555 16.6015 17.9768 16.6307 17.7612 16.8823C17.0736 17.6846 16.3305 17.8242 15.7119 17.7189C15.0393 17.6043 14.5212 17.2022 14.3577 16.9482ZM18.182 14.2504C17.961 14.2504 17.7819 14.4296 17.7819 14.6503C17.7819 14.9817 17.5133 15.2503 17.1819 15.2503C16.8505 15.2503 16.5819 14.9817 16.5819 14.6503C16.5819 13.7667 17.2983 13.0504 18.182 13.0504C19.0658 13.0504 19.7819 13.7668 19.7819 14.6503C19.7819 14.9817 19.5133 15.2503 19.1819 15.2503C18.8505 15.2503 18.5819 14.9817 18.5819 14.6503C18.5819 14.4294 18.4029 14.2504 18.182 14.2504ZM13.5053 14.6503C13.5053 14.4296 13.6844 14.2504 13.9054 14.2504C14.1263 14.2504 14.3053 14.4294 14.3053 14.6503C14.3053 14.9817 14.5739 15.2503 14.9053 15.2503C15.2367 15.2503 15.5053 14.9817 15.5053 14.6503C15.5053 13.7668 14.7892 13.0504 13.9054 13.0504C13.0218 13.0504 12.3053 13.7667 12.3053 14.6503C12.3053 14.9817 12.574 15.2503 12.9053 15.2503C13.2367 15.2503 13.5053 14.9817 13.5053 14.6503Z"
        fill="white"
      />
    </svg>
  );
};

export const AboutUs_5 = ({ width, height, fill, className }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 -5.45107e-07C27.9991 -9.53907e-07 32 4.00086 32 16C32 27.9991 27.9991 32 16 32C4.00087 32 1.57026e-06 27.9991 8.9732e-07 16C2.24379e-07 4.00086 4.00086 -1.36306e-07 16 -5.45107e-07Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6921 24.5253C10.3505 24.492 10.1004 24.1836 10.1338 23.842C10.2421 22.7753 10.4255 19.7503 9.90879 18.5086L9.67546 17.9503C8.82546 15.9503 7.95878 13.892 9.01712 11.442C10.0838 8.97531 12.4921 7.52533 15.6088 7.45033C17.5671 7.417 19.0421 7.85031 20.2255 8.84198C21.9338 10.2836 22.1588 12.167 22.3505 13.8337C22.4005 14.2837 22.4505 14.7253 22.5338 15.142C22.6088 15.5086 22.8088 15.9336 23.0171 16.3753L23.0402 16.4239L23.0402 16.424L23.0402 16.424C23.2579 16.8833 23.4797 17.3513 23.6005 17.8503C23.7838 19.0086 22.8588 19.267 22.4671 19.3753C22.3505 19.4086 22.1255 19.4753 22.0838 19.517L21.9755 21.4836C21.8421 22.2003 21.2338 22.7253 20.5088 22.7586L18.4171 22.8586V23.892C18.4171 24.2336 18.1338 24.517 17.7921 24.517L10.6921 24.5253ZM11.6417 12.9094C11.6417 14.0594 12.5834 15.0011 13.7334 15.0011C14.0954 15.0011 14.4368 14.9077 14.7346 14.744L15.5652 15.5745C15.4018 15.8721 15.3087 16.2131 15.3087 16.5747C15.3087 17.7247 16.2503 18.6664 17.4003 18.6664C18.5503 18.6664 19.492 17.7247 19.492 16.5747C19.492 15.4247 18.5503 14.4831 17.4003 14.4831C17.0642 14.4831 16.7458 14.5635 16.4635 14.7061L15.6025 13.8451C15.7448 13.5631 15.8251 13.2451 15.8251 12.9094C15.8251 11.7594 14.8834 10.8177 13.7334 10.8177C12.5834 10.8177 11.6417 11.7594 11.6417 12.9094ZM12.8917 12.9094C12.8917 12.4427 13.2667 12.0677 13.7334 12.0677C14.2 12.0677 14.5751 12.4427 14.5751 12.9094C14.5751 13.376 14.2 13.751 13.7334 13.751C13.2667 13.751 12.8917 13.376 12.8917 12.9094ZM17.4003 15.7331C16.9337 15.7331 16.5587 16.1081 16.5587 16.5747C16.5587 17.0414 16.9337 17.4164 17.4003 17.4164C17.867 17.4164 18.242 17.0414 18.242 16.5747C18.242 16.1081 17.867 15.7331 17.4003 15.7331Z"
        fill="white"
      />
    </svg>
  );
};
export const Discovery = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Iconly/Light-Outline/Discovery">
        <g id="Discovery">
          <path
            id="Fill 1"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.2113 11.2119L10.1643 14.5589L13.5103 13.5109L14.5583 10.1639L11.2113 11.2119ZM9.02033 16.4519C8.82433 16.4519 8.63233 16.3749 8.48933 16.2329C8.29233 16.0349 8.22033 15.7439 8.30433 15.4789L9.89733 10.3899C9.97033 10.1539 10.1543 9.9709 10.3883 9.8979L15.4773 8.3049C15.7443 8.2199 16.0343 8.2929 16.2323 8.4899C16.4293 8.6879 16.5013 8.9789 16.4173 9.2439L14.8253 14.3329C14.7523 14.5679 14.5673 14.7519 14.3333 14.8249L9.24433 16.4179C9.17033 16.4409 9.09433 16.4519 9.02033 16.4519Z"
            fill={fill}
          />
          <g id="Group 5">
            <mask
              id="mask0"
              mask-type="alpha"
              maskUnits="userSpaceOnUse"
              x="2"
              y="2"
              width="21"
              height="21"
            >
              <path
                id="Clip 4"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 2H22.7218V22.7217H2V2Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0)">
              <path
                id="Fill 3"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.3608 3.5C7.47476 3.5 3.49976 7.476 3.49976 12.361C3.49976 17.247 7.47476 21.222 12.3608 21.222C17.2468 21.222 21.2218 17.247 21.2218 12.361C21.2218 7.476 17.2468 3.5 12.3608 3.5ZM12.3608 22.722C6.64776 22.722 1.99976 18.074 1.99976 12.361C1.99976 6.648 6.64776 2 12.3608 2C18.0738 2 22.7218 6.648 22.7218 12.361C22.7218 18.074 18.0738 22.722 12.3608 22.722Z"
                fill={fill}
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
export const HouseOutline = ({ width, height, fill = '#FF6136' }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00008 7C8.46143 5.53865 10.0936 4.41899 11.1976 3.74088C12.0022 3.24665 12.998 3.24665 13.8026 3.74088C14.9065 4.41899 16.5387 5.53865 18.0001 7C21.1685 10.1684 21.0001 12 21.0001 15C21.0001 16.4098 20.8897 17.5988 20.7726 18.4632C20.6494 19.3726 19.8563 20 18.9385 20H17.5001C16.3955 20 15.5001 19.1046 15.5001 18V16C15.5001 15.2043 15.184 14.4413 14.6214 13.8787C14.0588 13.3161 13.2957 13 12.5001 13C11.7044 13 10.9414 13.3161 10.3788 13.8787C9.81616 14.4413 9.50009 15.2043 9.50009 16V18C9.50009 19.1046 8.60466 20 7.50009 20H6.06164C5.14391 20 4.35074 19.3726 4.22757 18.4631C4.11051 17.5988 4.00009 16.4098 4.00009 15C4.00009 12 3.83169 10.1684 7.00008 7Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const OrderOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.55328 8.77174L6.41 8.42198C6.51856 8.37782 6.64028 8.38138 6.74488 8.43142L7.04884 8.57698C7.56752 8.82526 8.16792 8.44694 8.16728 7.87174L8.1634 2.96973C8.16336 2.43129 8.01292 1.95706 7.69108 1.61571C7.36676 1.27173 6.90396 1.1001 6.3568 1.1001H3.43706C2.88863 1.1001 2.42735 1.27173 2.10537 1.61685C1.78635 1.95881 1.63986 2.43278 1.63982 2.96951L1.63281 7.87046C1.63218 8.44562 2.23215 8.8251 2.75162 8.57622L3.05368 8.43162C3.15846 8.38126 3.27973 8.37758 3.38767 8.42178L4.24616 8.77162C4.66516 8.9431 5.13488 8.94258 5.55328 8.77174ZM5.32648 8.21626C5.05296 8.32794 4.74648 8.32814 4.47352 8.21638L3.61489 7.86646C3.35011 7.75818 3.05184 7.76686 2.79401 7.8907L2.49255 8.03502C2.37223 8.0927 2.23274 8.00518 2.23281 7.8713L2.23982 2.96973C2.23982 2.53745 2.35701 2.22669 2.5441 2.02615C2.72827 1.82873 3.01562 1.7001 3.43706 1.7001H6.3568C6.7768 1.7001 7.06732 1.82873 7.25452 2.0273C7.44412 2.22843 7.5634 2.53917 7.5634 2.96973L7.56728 7.8723C7.56744 8.00542 7.42836 8.09342 7.308 8.03582L7.004 7.89026C6.74596 7.76678 6.448 7.7587 6.18376 7.86626L5.32648 8.21626Z"
        fill={fill}
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.46875 4.12104C3.46875 3.95536 3.60306 3.82104 3.76875 3.82104H5.27723C5.44291 3.82104 5.57723 3.95536 5.57723 4.12104C5.57723 4.28672 5.44291 4.42104 5.27723 4.42104H3.76875C3.60306 4.42104 3.46875 4.28672 3.46875 4.12104ZM3.46875 5.87884C3.46875 5.71316 3.60306 5.57884 3.76875 5.57884H6.03147C6.19715 5.57884 6.33147 5.71316 6.33147 5.87884C6.33147 6.04452 6.19715 6.17884 6.03147 6.17884H3.76875C3.60306 6.17884 3.46875 6.04452 3.46875 5.87884Z"
        fill={fill}
      ></path>
    </svg>
  );
};

export const UserOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.2665 7.5805C8.2665 8.95383 6.38317 9.11259 4.96692 9.11259L4.86557 9.1125C3.96326 9.11031 1.6665 9.05334 1.6665 7.57217C1.6665 6.22686 3.47415 6.04707 4.87962 6.04029L5.06827 6.04017C5.97052 6.04236 8.2665 6.09933 8.2665 7.5805ZM4.96692 6.66509C3.1915 6.66509 2.2915 6.97008 2.2915 7.57217C2.2915 8.17967 3.1915 8.48759 4.96692 8.48759C6.74192 8.48759 7.6415 8.18258 7.6415 7.5805C7.6415 6.973 6.74192 6.66509 4.96692 6.66509ZM4.96692 0.833252C6.18692 0.833252 7.179 1.82575 7.179 3.04575C7.179 4.26575 6.18692 5.25784 4.96692 5.25784H4.95359C3.73609 5.25409 2.74984 4.26117 2.75399 3.0445C2.75399 1.82575 3.7465 0.833252 4.96692 0.833252ZM4.96692 1.42825C4.07484 1.42825 3.349 2.15367 3.349 3.04575C3.34609 3.93492 4.0665 4.65992 4.95484 4.66325L4.96692 4.96075V4.66325C5.85859 4.66325 6.584 3.93742 6.584 3.04575C6.584 2.15367 5.85859 1.42825 4.96692 1.42825Z"
        fill={fill}
      ></path>
    </svg>
  );
};

export const HamburgerMenu = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 17H20M4 12H20M4 7H20"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PharmacyOutline = ({
  width = 24,
  height = 24,
  fill = '#9A9A9A',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.7854 5.69408H14.429C14.429 4.39538 13.39 3.35642 12.0913 3.35642C10.7926 3.35642 9.75364 4.39538 9.75364 5.69408H8.39722C8.39722 3.64502 10.0711 2 12.0913 2C14.1115 2 15.7854 3.64502 15.7854 5.69408Z"
      fill={fill}
    />
    <path
      d="M12.0335 17.3824C10.6482 17.3824 9.34951 16.7186 8.62801 15.6796C8.48371 15.4776 8.54143 15.189 8.74345 15.0447C8.94547 14.9004 9.23407 14.9581 9.37837 15.1602C9.92671 15.9682 10.9368 16.4589 12.0335 16.4589C13.1302 16.4589 14.1403 15.9682 14.6886 15.1602C14.8329 14.9581 15.1215 14.9004 15.3235 15.0447C15.5256 15.189 15.5833 15.4776 15.439 15.6796C14.7463 16.7186 13.4476 17.3824 12.0335 17.3824Z"
      fill={fill}
    />
    <path
      d="M9.81147 11.1486C9.81147 11.5815 9.43629 11.9567 9.00339 11.9567C8.57049 11.9567 8.19531 11.5815 8.19531 11.1486C8.19531 10.7157 8.57049 10.3405 9.00339 10.3405C9.46515 10.3405 9.81147 10.7157 9.81147 11.1486Z"
      fill={fill}
    />
    <path
      d="M15.872 11.1486C15.872 11.5815 15.4968 11.9567 15.0639 11.9567C14.631 11.9567 14.2559 11.5815 14.2559 11.1486C14.2559 10.7157 14.631 10.3405 15.0639 10.3405C15.5257 10.3405 15.872 10.7157 15.872 11.1486Z"
      fill={fill}
    />
    <path
      d="M8.59919 16.2857C8.48375 16.2857 8.36831 16.228 8.28173 16.1414C8.10857 15.9682 8.10857 15.6796 8.28173 15.5065L9.11867 14.6695C9.29183 14.4964 9.58043 14.4964 9.75359 14.6695C9.92675 14.8427 9.92675 15.1313 9.75359 15.3045L8.91665 16.1414C8.83007 16.228 8.71463 16.2857 8.59919 16.2857Z"
      fill={fill}
    />
    <path
      d="M15.4969 16.2857C15.3815 16.2857 15.266 16.228 15.1795 16.1414L14.3425 15.3045C14.1694 15.1313 14.1694 14.8427 14.3425 14.6695C14.5157 14.4964 14.8043 14.4964 14.9774 14.6695L15.8144 15.5065C15.9875 15.6796 15.9875 15.9682 15.8144 16.1414C15.7278 16.228 15.6124 16.2857 15.4969 16.2857Z"
      fill={fill}
    />
    <path
      d="M16.8821 22H7.50257C6.11729 22 4.81859 21.4517 3.86621 20.4416C2.91383 19.4315 2.42321 18.1039 2.50979 16.7186L3.08699 6.58875C3.11585 5.98269 3.63533 5.49207 4.24139 5.49207H20.2298C20.8359 5.49207 21.3265 5.95383 21.3842 6.55989L21.8749 16.632C21.9903 17.9885 21.4997 19.3737 20.5473 20.3838C19.5949 21.3939 18.2674 22 16.8821 22ZM4.50113 6.93507L3.92393 16.8052C3.86621 17.7864 4.21253 18.7388 4.87631 19.4603C5.56895 20.1818 6.46361 20.5859 7.47371 20.5859H16.8532C17.8633 20.5859 18.7868 20.1818 19.4506 19.4603C20.1433 18.7388 20.4607 17.7576 20.3741 16.7763L19.9124 6.99279H4.50113V6.93507Z"
      fill={fill}
    />
  </svg>
);

export const MyOrderOutline = ({
  width = 24,
  height = 24,
  fill = '#9A9A9A',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.8344 16.8918L16.2759 15.4488L15.9585 15.1602C15.6987 14.9293 15.2947 14.9293 15.0349 15.189C14.8041 15.4488 14.8041 15.8528 15.0638 16.1125L16.6222 17.5555L16.9397 17.8441C17.1994 18.075 17.6035 18.075 17.8632 17.8153C18.123 17.5555 18.0941 17.1515 17.8344 16.8918Z"
      fill={fill}
    />
    <path
      d="M12.553 17.2381C10.3308 17.2381 8.5415 15.4488 8.5415 13.2265C8.5415 11.0043 10.3308 9.215 12.553 9.215C14.7753 9.215 16.5646 11.0043 16.5646 13.2265C16.5646 15.4488 14.7753 17.2381 12.553 17.2381ZM12.553 10.4848C11.0523 10.4848 9.84021 11.697 9.84021 13.1977C9.84021 14.6984 11.0523 15.9105 12.553 15.9105C14.0538 15.9105 15.2659 14.6984 15.2659 13.1977C15.2659 11.7258 14.0538 10.4848 12.553 10.4848Z"
      fill={fill}
    />
    <path
      d="M14.4866 13.6594C14.2558 13.6594 14.0537 13.4574 14.0537 13.2265C14.0537 12.4185 13.39 11.7258 12.553 11.7258C12.3221 11.7258 12.1201 11.5238 12.1201 11.2929C12.1201 11.062 12.3221 10.86 12.553 10.86C13.8517 10.86 14.8907 11.9278 14.8907 13.1977C14.9195 13.4574 14.7175 13.6594 14.4866 13.6594Z"
      fill={fill}
    />
    <path
      d="M16.8821 22H7.50257C6.11729 22 4.81859 21.4517 3.86621 20.4416C2.91383 19.4315 2.42321 18.1039 2.50979 16.7186L3.08699 6.58875C3.11585 5.98269 3.63533 5.49207 4.24139 5.49207H20.2298C20.8359 5.49207 21.3265 5.95383 21.3842 6.55989L21.8749 16.632C21.9903 17.9885 21.4997 19.3737 20.5473 20.3838C19.5949 21.3939 18.2674 22 16.8821 22ZM4.50113 6.93507L3.92393 16.8052C3.86621 17.7864 4.21253 18.7388 4.87631 19.4603C5.56895 20.1818 6.46361 20.5859 7.47371 20.5859H16.8532C17.8633 20.5859 18.7868 20.1818 19.4506 19.4603C20.1433 18.7388 20.4607 17.7576 20.3741 16.7763L19.9124 6.99279H4.50113V6.93507Z"
      fill={fill}
    />
    <path
      d="M13.3323 22H9.84022C8.45494 22 7.15624 21.4517 6.20386 20.4416C5.25148 19.4315 4.76086 18.1039 4.84744 16.7186L5.42464 6.58875C5.4535 5.98269 5.97298 5.49207 6.57904 5.49207H13.3323V6.93507H6.86764L6.29044 16.8052C6.23272 17.7864 6.57904 18.7388 7.24282 19.4603C7.93546 20.1818 8.83012 20.5859 9.84022 20.5859H13.3323V22Z"
      fill={fill}
    />
    <path
      d="M15.7854 5.69408H14.429C14.429 4.39538 13.39 3.35642 12.0913 3.35642C10.7926 3.35642 9.75364 4.39538 9.75364 5.69408H8.39722C8.39722 3.64502 10.0711 2 12.0913 2C14.1115 2 15.7854 3.64502 15.7854 5.69408Z"
      fill={fill}
    />
  </svg>
);

export const ProfileCircleOutline = ({
  width = 24,
  height = 24,
  stroke = '#9A9A9A',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.5 18.7023C18.5 15.6706 15 15 12.5 15C10 15 6.5 15.6706 6.5 18.7023M21.5 12C21.5 16.9706 17.4706 21 12.5 21C7.52944 21 3.5 16.9706 3.5 12C3.5 7.02944 7.52944 3 12.5 3C17.4706 3 21.5 7.02944 21.5 12ZM15.5 9C15.5 10.6569 14.1569 12 12.5 12C10.8431 12 9.5 10.6569 9.5 9C9.5 7.34315 10.8431 6 12.5 6C14.1569 6 15.5 7.34315 15.5 9Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TimerOutlineIcon = ({
  width = 10,
  height = 11,
  fill = '#747575',
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5.5h-3v1h3v-1zM4.5 7h1V4h-1v3zm4.015-3.305.71-.71a5.524 5.524 0 0 0-.705-.705l-.71.71A4.481 4.481 0 0 0 5 2a4.5 4.5 0 1 0 4.47 3.996 4.497 4.497 0 0 0-.955-2.301zM5 10a3.497 3.497 0 0 1-3.5-3.5C1.5 4.565 3.065 3 5 3s3.5 1.565 3.5 3.5S6.935 10 5 10z"
      fill={fill}
    />
  </svg>
);

export const HeadsetOutlineIcon = ({
  width = 24,
  height = 24,
  fill = '#000',
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2a8 8 0 0 1 7.996 7.75l.005.421a2.997 2.997 0 0 1 1.963 2.38l.027.222L22 13v2a2.993 2.993 0 0 1-2.551 2.964l-.222.027L19 18h-1.126a4.002 4.002 0 0 1-3.674 2.995L14 21h-.667l-.333.5h-1.5a1.5 1.5 0 0 1 0-3H13l.333.5H14a2 2 0 0 0 1.995-1.85L16 17v-7h2a6 6 0 0 0-11.996-.225L6 10h2v8H5a2.993 2.993 0 0 1-2.964-2.551l-.027-.222L2 15v-2a2.993 2.993 0 0 1 2-2.825V10a8 8 0 0 1 8-8z"
      fill={fill}
    />
  </svg>
);

export const PhoneOutlineIcon = ({
  width = 24,
  height = 24,
  fill = '#000',
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.99 15.38c1.23 0 2.42-.2 3.53-.56.35-.12.74-.03 1.01.24l1.57 1.97c2.83-1.35 5.48-3.9 6.89-6.83l-1.95-1.66a1.02 1.02 0 0 1-.24-1.02c.37-1.11.56-2.3.56-3.53 0-.54.45-.99.99-.99h3.46c.54 0 1.19.24 1.19.99C21 13.28 13.27 21 3.99 21c-.71 0-.99-.63-.99-1.18v-3.45c0-.54.45-.99.99-.99z"
      fill={fill}
    />
  </svg>
);

export const NoteOutlineIcon = ({
  width = 16,
  height = 21,
  fill = '#FF7140',
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.82 2C10.4.84 9.3 0 8 0 6.7 0 5.6.84 5.18 2H2C.9 2 0 2.9 0 4v15c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V4c0-1.1-.9-2-2-2h-3.18zM14 19V4h-3v3H5V4H2v15h12zM7 3c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1z"
      fill={fill}
    />
  </svg>
);

export const ShopOutlinefillIcon = ({
  width = 24,
  height = 24,
  fill = 'black',
}: IconType) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_888_15710)">
      <path
        d="M20.958 11.05V19C20.958 19.55 20.763 20.0208 20.3732 20.4125C19.9834 20.8042 19.5147 21 18.9673 21H5.0327C4.48527 21 4.01664 20.8042 3.6268 20.4125C3.23697 20.0208 3.04205 19.55 3.04205 19V11.05C2.66051 10.7 2.36605 10.25 2.15869 9.7C1.95133 9.15 1.94719 8.55 2.14625 7.9L3.19135 4.5C3.32406 4.06667 3.56045 3.70833 3.90052 3.425C4.24059 3.14167 4.63457 3 5.08247 3H18.9175C19.3654 3 19.7553 3.1375 20.087 3.4125C20.4188 3.6875 20.6594 4.05 20.8087 4.5L21.8537 7.9C22.0528 8.55 22.0487 9.14167 21.8413 9.675C21.6339 10.2083 21.3395 10.6667 20.958 11.05ZM14.1897 10C14.6376 10 14.9777 9.84583 15.2099 9.5375C15.4422 9.22917 15.5334 8.88333 15.4836 8.5L14.9362 5H12.9953V8.7C12.9953 9.05 13.1115 9.35417 13.3437 9.6125C13.5759 9.87083 13.8579 10 14.1897 10ZM9.71075 10C10.0923 10 10.4033 9.87083 10.6439 9.6125C10.8844 9.35417 11.0047 9.05 11.0047 8.7V5H9.06378L8.51635 8.5C8.45 8.9 8.53709 9.25 8.77763 9.55C9.01816 9.85 9.3292 10 9.71075 10ZM5.28154 10C5.58013 10 5.84141 9.89167 6.06536 9.675C6.28931 9.45833 6.42616 9.18333 6.47593 8.85L7.02336 5H5.08247L4.08714 8.35C3.98761 8.68333 4.04152 9.04167 4.24888 9.425C4.45624 9.80833 4.80046 10 5.28154 10ZM18.7185 10C19.1995 10 19.5479 9.80833 19.7636 9.425C19.9792 9.04167 20.029 8.68333 19.9129 8.35L18.8678 5H16.9766L17.5241 8.85C17.5738 9.18333 17.7107 9.45833 17.9346 9.675C18.1586 9.89167 18.4199 10 18.7185 10Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_888_15710">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ShopOutlineIcon = ({
  width = 20,
  height = 18,
  fill = '#FF7140',
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.958 8.05V16c0 .55-.195 1.02-.585 1.413-.39.391-.858.587-1.406.587H3.033a1.912 1.912 0 0 1-1.406-.587A1.93 1.93 0 0 1 1.042 16V8.05C.661 7.7.366 7.25.159 6.7-.05 6.15-.053 5.55.146 4.9l1.045-3.4a2.21 2.21 0 0 1 .71-1.075C2.24.142 2.635 0 3.082 0h13.835c.448 0 .838.138 1.17.412.332.276.572.638.722 1.088l1.045 3.4c.199.65.195 1.242-.013 1.775a3.954 3.954 0 0 1-.883 1.375zM12.19 7c.448 0 .788-.154 1.02-.463a1.37 1.37 0 0 0 .274-1.037L12.936 2h-1.94v3.7c0 .35.115.654.348.912.232.259.514.388.846.388zM7.71 7c.382 0 .693-.13.934-.388.24-.258.36-.562.36-.912V2h-1.94l-.548 3.5c-.066.4.021.75.262 1.05.24.3.551.45.933.45zM3.283 7c.298 0 .56-.108.783-.325a1.4 1.4 0 0 0 .41-.825L5.024 2h-1.94l-.996 3.35c-.1.333-.045.692.162 1.075.207.383.551.575 1.033.575zm13.436 0c.482 0 .83-.192 1.046-.575.215-.383.265-.742.149-1.075L16.868 2h-1.891l.547 3.85a1.4 1.4 0 0 0 .41.825c.225.217.486.325.784.325zM3.033 16h13.934V8.95a.6.6 0 0 1-.161.05h-.088c-.447 0-.841-.075-1.181-.225-.34-.15-.677-.392-1.008-.725-.299.3-.639.533-1.02.7-.382.167-.788.25-1.22.25-.448 0-.867-.083-1.256-.25-.39-.167-.734-.4-1.033-.7-.282.3-.61.533-.983.7-.373.167-.775.25-1.207.25-.48 0-.916-.083-1.306-.25-.39-.167-.734-.4-1.033-.7-.348.35-.692.596-1.032.737-.34.142-.726.213-1.157.213H3.17a.252.252 0 0 1-.137-.05V16z"
      fill={fill}
    />
  </svg>
);

export const PaymentOutlineIcon = ({
  width = 22,
  height = 14,
  fill = '#FF7140',
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 0v11h-4v3H0V4l3-.001V0h19zm-6 6H2v6h14V6zm-7 .75a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zM13.5 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-9 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm4.5.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5zM20 2H5v1.999L18 4v5h2V2z"
      fill={fill}
    />
  </svg>
);

export const BagOutlineIcon = ({
  width = 18,
  height = 21,
  fill = '#FF7140',
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 5h-2c0-2.76-2.24-5-5-5S4 2.24 4 5H2C.9 5 0 5.9 0 7v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM9 2c1.66 0 3 1.34 3 3H6c0-1.66 1.34-3 3-3zm7 17H2V7h14v12zm-7-8c-1.66 0-3-1.34-3-3H4c0 2.76 2.24 5 5 5s5-2.24 5-5h-2c0 1.66-1.34 3-3 3z"
      fill={fill}
    />
  </svg>
);

export const BikerOutlineIcon = ({
  width = 20,
  height = 16,
  fill = '#FF7140',
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.002 12c0-6.627 5.373-12 12-12a8 8 0 1 1 0 16h-10a2 2 0 0 1-2-2v-2zm12 2h-10v-2c0-.338.017-.671.05-1h6.404a3.544 3.544 0 0 0 1.638-6.687L7.606 3.016A9.96 9.96 0 0 1 12.002 2a6 6 0 0 1 0 12zM2.46 9h5.996a1.544 1.544 0 0 0 .713-2.914l-3.5-1.825A10.013 10.013 0 0 0 2.46 9z"
      fill={fill}
    />
  </svg>
);

export const BikerFillIcon = ({
  width = 24,
  height = 24,
  fill = '#000',
  gradient = false,
}: IconType) => {
  if (gradient) {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.00256 16C2.00256 9.37258 7.37515 4 14.0026 4C18.4208 4 22.0026 7.58172 22.0026 12C22.0026 16.4183 18.4208 20 14.0026 20H4.00256C2.89799 20 2.00256 19.1046 2.00256 18V16ZM10.5469 13.7129L4.46021 13.0004C5.05141 11.1178 6.18434 9.47511 7.6763 8.255L11.4558 9.43189C12.3743 9.71791 13 10.5681 13 11.5301C13 12.8451 11.8529 13.8657 10.5469 13.7129Z"
          fill="url(#paint0_linear_1404_24174)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1404_24174"
            x1="2.00256"
            y1="4"
            x2="22.4684"
            y2="4.61989"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF7733" />
            <stop offset="0.50153" stop-color="#FF5722" />
            <stop offset="1" stop-color="#E64917" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.00256 16C2.00256 9.37258 7.37515 4 14.0026 4C18.4208 4 22.0026 7.58172 22.0026 12C22.0026 16.4183 18.4208 20 14.0026 20H4.00256C2.89799 20 2.00256 19.1046 2.00256 18V16ZM10.5469 13.7129L4.46021 13.0004C5.05141 11.1178 6.18434 9.47511 7.6763 8.255L11.4558 9.43189C12.3743 9.71791 13 10.5681 13 11.5301C13 12.8451 11.8529 13.8657 10.5469 13.7129Z"
        fill={fill}
      />
    </svg>
  );
};

export const HomeFillIcon = ({ width = 24, height = 24, fill = '#747575' }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m22.515 9.143-10.507-6.31-10.522 6.31 1.028 1.715.486-.292V18l.006.15A2 2 0 0 0 5 20h4.5v-6a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v6H19l.15-.006A2 2 0 0 0 21 18v-7.434l.485.291 1.03-1.714z"
      fill={fill}
    />
  </svg>
);

export const ThreeDots = ({ width = 18, height = 6, fill = '#B1B2B2' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.25 0.75C1.0125 0.75 0 1.7625 0 3C0 4.2375 1.0125 5.25 2.25 5.25C3.4875 5.25 4.5 4.2375 4.5 3C4.5 1.7625 3.4875 0.75 2.25 0.75ZM15.75 0.75C14.5125 0.75 13.5 1.7625 13.5 3C13.5 4.2375 14.5125 5.25 15.75 5.25C16.9875 5.25 18 4.2375 18 3C18 1.7625 16.9875 0.75 15.75 0.75ZM9 0.75C7.7625 0.75 6.75 1.7625 6.75 3C6.75 4.2375 7.7625 5.25 9 5.25C10.2375 5.25 11.25 4.2375 11.25 3C11.25 1.7625 10.2375 0.75 9 0.75Z"
      fill={fill}
    />
  </svg>
);

export const OrderNotesOutlineIcon = ({
  width = 24,
  height = 24,
  fill = '#747575',
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 5v9h-5v5H5V5h14zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10l6-6V5c0-1.1-.9-2-2-2zm-7 11H7v-2h5v2zm5-4H7V8h10v2z"
      fill={fill}
    />
  </svg>
);

export const ProfileOutlineIcon = ({
  width = 24,
  height = 24,
  fill = '#747575',
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 7a3 3 0 1 0 6 0 3 3 0 0 0-6 0zm3-5a5 5 0 1 0 0 10 5 5 0 0 0 0-10zM16.5 16h-9a2 2 0 1 0 0 4h9a2 2 0 1 0 0-4zm-9-2a4 4 0 0 0 0 8h9a4 4 0 0 0 0-8h-9z"
      fill={fill}
    />
  </svg>
);

export const Shop = ({ width = 20, height = 18, fill = '#FF7140' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.958 8.05V16C18.958 16.55 18.763 17.0208 18.3732 17.4125C17.9834 17.8042 17.5147 18 16.9673 18H3.0327C2.48527 18 2.01664 17.8042 1.6268 17.4125C1.23697 17.0208 1.04205 16.55 1.04205 16V8.05C0.660505 7.7 0.366054 7.25 0.158694 6.7C-0.0486661 6.15 -0.0528133 5.55 0.146252 4.9L1.19135 1.5C1.32406 1.06667 1.56045 0.708333 1.90052 0.425C2.24059 0.141667 2.63457 0 3.08247 0H16.9175C17.3654 0 17.7553 0.1375 18.087 0.4125C18.4188 0.6875 18.6594 1.05 18.8087 1.5L19.8537 4.9C20.0528 5.55 20.0487 6.14167 19.8413 6.675C19.6339 7.20833 19.3395 7.66667 18.958 8.05ZM12.1897 7C12.6376 7 12.9777 6.84583 13.2099 6.5375C13.4422 6.22917 13.5334 5.88333 13.4836 5.5L12.9362 2H10.9953V5.7C10.9953 6.05 11.1115 6.35417 11.3437 6.6125C11.5759 6.87083 11.8579 7 12.1897 7ZM7.71075 7C8.09229 7 8.40333 6.87083 8.64387 6.6125C8.8844 6.35417 9.00467 6.05 9.00467 5.7V2H7.06378L6.51635 5.5C6.45 5.9 6.53709 6.25 6.77763 6.55C7.01816 6.85 7.3292 7 7.71075 7ZM3.28154 7C3.58013 7 3.84141 6.89167 4.06536 6.675C4.28931 6.45833 4.42616 6.18333 4.47593 5.85L5.02336 2H3.08247L2.08714 5.35C1.98761 5.68333 2.04152 6.04167 2.24888 6.425C2.45624 6.80833 2.80046 7 3.28154 7ZM16.7185 7C17.1995 7 17.5479 6.80833 17.7636 6.425C17.9792 6.04167 18.029 5.68333 17.9129 5.35L16.8678 2H14.9766L15.5241 5.85C15.5738 6.18333 15.7107 6.45833 15.9346 6.675C16.1586 6.89167 16.4199 7 16.7185 7ZM3.0327 16H16.9673V8.95C16.8844 8.98333 16.8304 9 16.8056 9H16.7185C16.2706 9 15.8766 8.925 15.5365 8.775C15.1964 8.625 14.8605 8.38333 14.5287 8.05C14.2301 8.35 13.8901 8.58333 13.5085 8.75C13.127 8.91667 12.7206 9 12.2893 9C11.8414 9 11.4225 8.91667 11.0327 8.75C10.6428 8.58333 10.2986 8.35 10 8.05C9.71799 8.35 9.39036 8.58333 9.01711 8.75C8.64387 8.91667 8.24159 9 7.81028 9C7.3292 9 6.89375 8.91667 6.50391 8.75C6.11407 8.58333 5.76986 8.35 5.47126 8.05C5.12289 8.4 4.77868 8.64583 4.4386 8.7875C4.09853 8.92917 3.71284 9 3.28154 9H3.16956C3.12809 9 3.08247 8.98333 3.0327 8.95V16Z"
      fill={fill}
    />
  </svg>
);

export const CategoryOutlineIcon = ({
  width = 20,
  height = 20,
  fill = '#FF7140',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.2231 10.3234C14.1242 10.3234 14.0262 10.305 13.9292 10.2682C13.8322 10.2314 13.7483 10.1701 13.6775 10.0842L9.91571 6.32246C9.82985 6.25162 9.76853 6.16633 9.73173 6.06658C9.69496 5.96682 9.67657 5.86715 9.67657 5.76756C9.67657 5.66459 9.69497 5.56575 9.73177 5.47104C9.76859 5.37635 9.82991 5.2844 9.91571 5.19521L13.6775 1.4384C13.7483 1.3631 13.8333 1.3036 13.9324 1.25987C14.0315 1.21615 14.1305 1.19429 14.2293 1.19429C14.3316 1.19429 14.4305 1.21623 14.5262 1.2601C14.6219 1.30398 14.7147 1.36341 14.8047 1.4384L18.5615 5.19521C18.6365 5.28524 18.696 5.37901 18.7398 5.47652C18.7837 5.57405 18.8057 5.67394 18.8057 5.77619C18.8057 5.87502 18.7838 5.97307 18.7401 6.07033C18.6963 6.16758 18.6368 6.25162 18.5615 6.32246L14.8047 10.0842C14.7146 10.17 14.6207 10.2313 14.5231 10.2682C14.4255 10.305 14.3255 10.3234 14.2231 10.3234ZM2.57286 9.0231C2.34043 9.0231 2.14818 8.94674 1.99613 8.79402C1.84407 8.6413 1.76805 8.45271 1.76807 8.22827V2.91894C1.76807 2.69448 1.84409 2.50589 1.99615 2.35317C2.14821 2.20046 2.34045 2.1241 2.57288 2.1241H7.87223C8.10134 2.1241 8.29193 2.20046 8.44398 2.35317C8.59604 2.50589 8.67207 2.69448 8.67207 2.91894V8.22827C8.67207 8.45271 8.59604 8.6413 8.44398 8.79402C8.29193 8.94674 8.10134 9.0231 7.87223 9.0231H2.57286ZM11.7875 18.2319C11.5631 18.2319 11.3745 18.1559 11.2218 18.0038C11.0691 17.8518 10.9927 17.6595 10.9927 17.4271V12.1436C10.9927 11.9145 11.0691 11.7239 11.2218 11.5718C11.3745 11.4198 11.5631 11.3437 11.7875 11.3437H17.081C17.3055 11.3437 17.4941 11.4198 17.6468 11.5718C17.7995 11.7239 17.8758 11.9145 17.8758 12.1436V17.4271C17.8758 17.6595 17.7995 17.8518 17.6468 18.0038C17.4941 18.1559 17.3055 18.2319 17.081 18.2319H11.7875ZM2.57286 18.2319C2.34043 18.2319 2.14818 18.1559 1.99613 18.0038C1.84407 17.8518 1.76805 17.6595 1.76807 17.4271V12.1277C1.76807 11.8986 1.84409 11.708 1.99615 11.556C2.14821 11.4039 2.34045 11.3279 2.57288 11.3279H7.87223C8.10134 11.3279 8.29193 11.4039 8.44398 11.556C8.59604 11.708 8.67207 11.8986 8.67207 12.1277V17.4271C8.67207 17.6595 8.59604 17.8518 8.44398 18.0038C8.29193 18.1559 8.10134 18.2319 7.87221 18.2319L2.57286 18.2319ZM3.38355 7.41258H7.05655V3.7346H3.38355V7.41258ZM14.2907 8.44294L16.9044 5.83423L14.2907 3.21558L11.682 5.83423L14.2907 8.44294ZM12.6032 16.6164H16.2653V12.9592H12.6032V16.6164ZM3.38355 16.6164H7.05655V12.9434H3.38355V16.6164Z"
      fill={fill}
    />
  </svg>
);

export const InstagramIcon = ({
  width,
  height,
  fill = '',
  innerFill = '',
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_2194_9699)">
      <path
        d="M10 0C7.28333 0 6.94417 0.0125 5.8775 0.06C4.8125 0.11 4.0875 0.2775 3.45 0.525C2.7925 0.78 2.23417 1.1225 1.67833 1.67833C1.1225 2.23417 0.779167 2.79167 0.525 3.45C0.2775 4.0875 0.109167 4.8125 0.06 5.8775C0.01 6.94417 0 7.28333 0 10C0 12.7167 0.0125 13.0558 0.06 14.1225C0.11 15.1867 0.2775 15.9125 0.525 16.55C0.776077 17.2174 1.16966 17.822 1.67833 18.3217C2.17773 18.8307 2.78241 19.2243 3.45 19.475C4.08833 19.7217 4.81333 19.8908 5.8775 19.94C6.94417 19.99 7.28333 20 10 20C12.7167 20 13.0558 19.9875 14.1225 19.94C15.1867 19.89 15.9125 19.7217 16.55 19.475C17.2172 19.2236 17.8218 18.8301 18.3217 18.3217C18.8309 17.8224 19.2245 17.2177 19.475 16.55C19.7217 15.9125 19.8908 15.1867 19.94 14.1225C19.99 13.0558 20 12.7167 20 10C20 7.28333 19.9875 6.94417 19.94 5.8775C19.89 4.81333 19.7217 4.08667 19.475 3.45C19.2238 2.78268 18.8302 2.17811 18.3217 1.67833C17.8226 1.16887 17.2178 0.775158 16.55 0.525C15.9125 0.2775 15.1867 0.109167 14.1225 0.06C13.0558 0.01 12.7167 0 10 0ZM10 1.8C12.6692 1.8 12.9875 1.81333 14.0417 1.85917C15.0167 1.905 15.5458 2.06667 15.8975 2.205C16.3658 2.38583 16.6975 2.6025 17.0492 2.95167C17.3983 3.30167 17.615 3.63417 17.7958 4.1025C17.9325 4.45417 18.0958 4.98333 18.14 5.95833C18.1875 7.01333 18.1983 7.33 18.1983 10C18.1983 12.67 18.1858 12.9875 18.1367 14.0417C18.0858 15.0167 17.9233 15.5458 17.7858 15.8975C17.6232 16.3315 17.3675 16.7246 17.0367 17.0492C16.7134 17.3802 16.3206 17.6353 15.8867 17.7958C15.5367 17.9325 14.9992 18.0958 14.0242 18.14C12.9625 18.1875 12.65 18.1983 9.975 18.1983C7.29917 18.1983 6.98667 18.1858 5.92583 18.1367C4.95 18.0858 4.4125 17.9233 4.0625 17.7858C3.62825 17.6252 3.23556 17.3692 2.91333 17.0367C2.57882 16.7156 2.32226 16.3222 2.16333 15.8867C2.02583 15.5367 1.86417 14.9992 1.81333 14.0242C1.77583 12.9742 1.7625 12.65 1.7625 9.9875C1.7625 7.32417 1.77583 6.99917 1.81333 5.93667C1.86417 4.96167 2.02583 4.425 2.16333 4.075C2.33833 3.6 2.5625 3.275 2.91333 2.92417C3.2625 2.575 3.58833 2.35 4.0625 2.17583C4.4125 2.0375 4.93833 1.875 5.91333 1.825C6.97583 1.7875 7.28833 1.775 9.9625 1.775L10 1.8ZM10 4.865C9.32566 4.865 8.65793 4.99782 8.03492 5.25588C7.41191 5.51394 6.84584 5.89218 6.36901 6.36901C5.89218 6.84584 5.51394 7.41191 5.25588 8.03492C4.99782 8.65793 4.865 9.32566 4.865 10C4.865 10.6743 4.99782 11.3421 5.25588 11.9651C5.51394 12.5881 5.89218 13.1542 6.36901 13.631C6.84584 14.1078 7.41191 14.4861 8.03492 14.7441C8.65793 15.0022 9.32566 15.135 10 15.135C11.3619 15.135 12.668 14.594 13.631 13.631C14.594 12.668 15.135 11.3619 15.135 10C15.135 8.63811 14.594 7.33201 13.631 6.36901C12.668 5.40601 11.3619 4.865 10 4.865ZM10 13.3333C8.15833 13.3333 6.66667 11.8417 6.66667 10C6.66667 8.15833 8.15833 6.66667 10 6.66667C11.8417 6.66667 13.3333 8.15833 13.3333 10C13.3333 11.8417 11.8417 13.3333 10 13.3333ZM16.5383 4.6625C16.5268 4.97302 16.3953 5.26697 16.1715 5.48256C15.9477 5.69815 15.6491 5.8186 15.3383 5.8186C15.0276 5.8186 14.729 5.69815 14.5052 5.48256C14.2814 5.26697 14.1499 4.97302 14.1383 4.6625C14.1383 4.34424 14.2648 4.03902 14.4898 3.81397C14.7148 3.58893 15.0201 3.4625 15.3383 3.4625C15.6566 3.4625 15.9618 3.58893 16.1869 3.81397C16.4119 4.03902 16.5383 4.34424 16.5383 4.6625Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_2194_9699">
        <rect width={width} height={height} fill={innerFill} />
      </clipPath>
    </defs>
  </svg>
);

export const AparatIcon = ({
  width,
  height,
  fill = '',
  innerFill = '',
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_2194_9708)">
      <path
        d="M10.0006 1.32839C2.27559 1.32589 -1.59357 10.6642 3.86726 16.1267C5.07957 17.3393 6.62426 18.1652 8.30597 18.4999C9.98768 18.8346 11.7309 18.6631 13.3151 18.007C14.8993 17.3509 16.2534 16.2398 17.2061 14.8141C18.1587 13.3884 18.6672 11.7122 18.6673 9.99755C18.6673 5.21088 14.7881 1.33005 10.0006 1.32839ZM5.09143 5.65255C5.50893 3.48755 8.33559 2.90755 9.57143 4.73339C10.8073 6.55839 9.21976 8.96838 7.05476 8.55172C6.73543 8.49038 6.43132 8.36671 6.1598 8.18779C5.88829 8.00887 5.65469 7.7782 5.47236 7.50896C5.29003 7.23972 5.16254 6.93719 5.09718 6.61866C5.03181 6.30013 5.02986 5.97184 5.09143 5.65255ZM8.69309 13.1426C8.27309 15.3067 5.44559 15.8826 4.21226 14.0559C2.97893 12.2292 4.56809 9.82255 6.73309 10.2401C7.05246 10.3018 7.35653 10.4258 7.62793 10.6051C7.89932 10.7844 8.1327 11.0155 8.31474 11.285C8.49677 11.5546 8.62388 11.8574 8.6888 12.1761C8.75372 12.4949 8.75518 12.8233 8.69309 13.1426ZM9.74309 11.1384C8.78309 10.9526 8.52476 9.69922 9.33393 9.14922C10.1423 8.59922 11.2139 9.29922 11.0339 10.2609C11.0072 10.4034 10.9526 10.5392 10.8733 10.6606C10.7939 10.7819 10.6913 10.8864 10.5714 10.9679C10.4515 11.0495 10.3167 11.1065 10.1747 11.1358C10.0327 11.165 9.88545 11.1659 9.74309 11.1384ZM14.9081 14.3367C14.4906 16.5017 11.6639 17.0809 10.4281 15.2559C9.19143 13.43 10.7789 11.0209 12.9448 11.4367C13.2642 11.4981 13.5684 11.6217 13.8399 11.8007C14.1115 11.9797 14.3452 12.2105 14.5275 12.4798C14.7098 12.7491 14.8373 13.0517 14.9026 13.3704C14.9679 13.689 14.9698 14.0174 14.9081 14.3367ZM13.2689 9.75172C11.1039 9.33422 10.5248 6.50505 12.3506 5.26839C14.1756 4.03255 16.5848 5.62005 16.1689 7.78505C16.108 8.10476 15.9846 8.40932 15.8057 8.68127C15.6269 8.95322 15.3962 9.18724 15.1269 9.36991C14.8575 9.55259 14.5547 9.68035 14.2359 9.74586C13.9171 9.81138 13.5885 9.81337 13.2689 9.75172ZM11.3248 19.3867L13.2114 19.8951C14.0047 20.1056 14.8492 19.9924 15.5591 19.5805C16.269 19.1686 16.7863 18.4916 16.9973 17.6984L17.5306 15.6967C16.0291 17.6968 13.7984 19.023 11.3239 19.3867H11.3248ZM17.6939 2.99922L15.7248 2.47505C16.7199 3.24051 17.5531 4.196 18.1759 5.28608C18.7988 6.37615 19.1989 7.57908 19.3531 8.82505L19.8948 6.77588C20.102 5.98316 19.9866 5.1406 19.5738 4.43283C19.1609 3.72507 18.4843 3.20984 17.6923 3.00005L17.6939 2.99922ZM0.55976 11.5076L0.108926 13.2076C-0.101576 14.0009 0.0115709 14.8453 0.423491 15.5552C0.835412 16.2652 1.51239 16.7824 2.30559 16.9934L4.06143 17.4617C2.18687 15.9879 0.937166 13.862 0.55976 11.5076ZM8.63059 0.585052L6.79143 0.105052C6.39833 0.000339131 5.98846 -0.0258745 5.58523 0.02791C5.182 0.0816945 4.79332 0.214423 4.44142 0.418507C4.08951 0.622591 3.78128 0.89403 3.53434 1.21731C3.2874 1.54058 3.1066 1.90936 3.00226 2.30255L2.54309 4.03755C4.05786 2.15225 6.23506 0.917158 8.63059 0.585052Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_2194_9708">
        <rect width={width} height={height} fill={innerFill} />
      </clipPath>
    </defs>
  </svg>
);

export const LinkedintIcon = ({
  width,
  height,
  fill = '',
  innerFill = '',
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_2194_9697)">
      <path
        d="M17.0392 17.0433H14.0775V12.4025C14.0775 11.2958 14.055 9.87167 12.5342 9.87167C10.99 9.87167 10.7542 11.0758 10.7542 12.3208V17.0433H7.7925V7.5H10.6375V8.80083H10.6758C11.0733 8.05083 12.04 7.25917 13.4842 7.25917C16.485 7.25917 17.04 9.23417 17.04 11.805L17.0392 17.0433ZM4.4475 6.19417C4.22156 6.19428 3.99783 6.14983 3.78909 6.06337C3.58035 5.97691 3.39071 5.85013 3.23103 5.69029C3.07135 5.53045 2.94475 5.34069 2.85849 5.13187C2.77224 4.92305 2.728 4.69927 2.72833 4.47333C2.7285 4.13315 2.82954 3.80065 3.01867 3.51789C3.2078 3.23513 3.47654 3.01481 3.79089 2.88478C4.10524 2.75475 4.45109 2.72085 4.78471 2.78738C5.11832 2.85391 5.42472 3.01787 5.66515 3.25853C5.90558 3.4992 6.06924 3.80575 6.13545 4.13943C6.20165 4.47311 6.16742 4.81893 6.03709 5.13315C5.90675 5.44738 5.68616 5.7159 5.40322 5.90476C5.12028 6.09362 4.78768 6.19433 4.4475 6.19417ZM5.9325 17.0433H2.9625V7.5H5.9325V17.0433ZM18.5208 0H1.47583C0.66 0 0 0.645 0 1.44083V18.5592C0 19.3558 0.66 20 1.47583 20H18.5183C19.3333 20 20 19.3558 20 18.5592V1.44083C20 0.645 19.3333 0 18.5183 0H18.5208Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_2194_9697">
        <rect width={width} height={height} fill={innerFill} />
      </clipPath>
    </defs>
  </svg>
);
export const FilterIcon = ({
  width,
  height,
  fill = '#000',
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.083 11.25A2.917 2.917 0 1 1 4.287 15h-2.62v-1.667h2.62a2.918 2.918 0 0 1 2.796-2.083zm0 1.667a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zm11.25.416V15h-6.666v-1.667h6.666zM12.917 2.917c1.32 0 2.437.878 2.795 2.083h2.621v1.667h-2.62A2.918 2.918 0 0 1 10 5.833a2.917 2.917 0 0 1 2.916-2.916zm0 1.666a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zM8.332 5v1.667H1.666V5h6.667z"
      fill={fill}
    />
  </svg>
);

export const TimerIcon = ({
  width = 32,
  height = 32,
  fill = '#fff',
  className = '',
}: IconType) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 15.8333C13.2217 15.8333 15.8333 13.2217 15.8333 10C15.8333 6.77834 13.2217 4.16667 10 4.16667C6.77834 4.16667 4.16667 6.77834 4.16667 10C4.16667 13.2217 6.77834 15.8333 10 15.8333ZM10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5ZM10.8333 9.64167V5.33335H9.16667V10.3295L9.16542 10.3308L9.16667 10.332V10.3334H9.16799L11.7715 12.9368L12.95 11.7583L10.8333 9.64167Z"
      fill={fill}
    />
  </svg>
);

export const TimerFillIcon = ({
  width = 24,
  height = 24,
  fill = 'black',
  className = '',
  gradient = false,
}: IconType) => {
  if (gradient) {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604C2.12132 9.15076 2.12132 14.8492 5.63604 18.364C9.15076 21.8787 14.8492 21.8787 18.364 18.364C21.8787 14.8492 21.8787 9.15076 18.364 5.63604ZM12.9 11.5183V7.5H11.1V12.4817L14.9496 15.0481L15.9481 13.5504L12.9 11.5183Z"
          fill="url(#paint0_linear_1404_24109)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1404_24109"
            x1="3"
            y1="3"
            x2="21.4253"
            y2="3.44647"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF7733" />
            <stop offset="0.50153" stop-color="#FF5722" />
            <stop offset="1" stop-color="#E64917" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604C2.12132 9.15076 2.12132 14.8492 5.63604 18.364C9.15076 21.8787 14.8492 21.8787 18.364 18.364C21.8787 14.8492 21.8787 9.15076 18.364 5.63604ZM12.9 11.5183V7.5H11.1V12.4817L14.9496 15.0481L15.9481 13.5504L12.9 11.5183Z"
        fill={fill}
      />
    </svg>
  );
};

export const FailIcon = ({
  width = 32,
  height = 32,
  fill = '#E11900',
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M14 20.667h4v4h-4v-4zm0-13.334h4V18h-4V7.333z" fill={fill} />
  </svg>
);

export const MessagesIcon = ({
  width = 24,
  height = 24,
  fill = '#545454',
  className = '',
}: IconType) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 4a2 2 0 0 1 1.994 1.85L22 6v12a2 2 0 0 1-1.85 1.994L20 20H4a2 2 0 0 1-1.995-1.85L2 18V6a2 2 0 0 1 1.85-1.995L4 4h16zm0 2H4v12h16V6zm-2.444 2.15.883 1.795-6.44 3.17-6.392-3.171.89-1.792L12 10.884l5.555-2.733z"
      fill={fill}
    />
  </svg>
);

export const LocationOutline2Icon = ({
  width = 24,
  height = 24,
  fill = '#545454',
  className = '',
}: IconType) => {
  if (height === 20 && width === 20) {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.8334 18.3337V20.0003H9.16671V18.3337H10.8334ZM10 1.66699C13.6819 1.66699 16.6667 4.65176 16.6667 8.33366C16.6667 10.7341 15.3419 12.848 13.2268 14.1529L12.7912 14.4133C12.6477 14.5026 12.5123 14.5936 12.3849 14.6862C11.7221 15.1674 11.3044 15.6614 11.0595 16.1533L11.0348 16.2075L10.9789 16.3512L10.7889 16.8907L10.7345 17.0291C10.7084 17.0905 10.6844 17.1385 10.6636 17.1651L10.6243 17.2116L10.5577 17.2837C10.5182 17.3216 10.4791 17.3477 10.4201 17.372L10.3538 17.396L10.2088 17.4373L10 17.4901L9.71267 17.4162C9.57842 17.3782 9.51536 17.3492 9.45611 17.2963L9.41134 17.2517L9.33736 17.1662C9.32349 17.1485 9.30813 17.1212 9.29168 17.0868L9.23943 16.9644L9.21156 16.8914L9.02023 16.35L8.99109 16.2727L8.93876 16.151C8.69123 15.6563 8.26864 15.1594 7.59799 14.6751C7.47206 14.5842 7.3385 14.4948 7.19705 14.4069L6.76503 14.1489C4.65232 12.8458 3.33337 10.7341 3.33337 8.33366C3.33337 4.65176 6.31814 1.66699 10 1.66699ZM10 3.33366C7.23862 3.33366 5.00004 5.57224 5.00004 8.33366C5.00004 10.1118 5.98459 11.6987 7.61307 12.7136L8.0781 12.9922C8.2516 13.1 8.41672 13.2106 8.57365 13.3239C9.0814 13.6905 9.49467 14.0777 9.82427 14.4794L9.99921 14.7053L10.1703 14.4844C10.3928 14.2122 10.6538 13.9466 10.9565 13.6897L11.1915 13.4987L11.4055 13.3376C11.5647 13.222 11.7324 13.1093 11.9087 12.9995L12.3786 12.7177C14.0102 11.7006 15 10.1108 15 8.33366C15 5.57224 12.7615 3.33366 10 3.33366ZM10 5.83366C11.3808 5.83366 12.5 6.95295 12.5 8.33366C12.5 9.71437 11.3808 10.8337 10 10.8337C8.61933 10.8337 7.50004 9.71437 7.50004 8.33366C7.50004 6.95295 8.61933 5.83366 10 5.83366ZM10 7.50033C9.5398 7.50033 9.16671 7.87342 9.16671 8.33366C9.16671 8.7939 9.5398 9.16699 10 9.16699C10.4603 9.16699 10.8334 8.7939 10.8334 8.33366C10.8334 7.87342 10.4603 7.50033 10 7.50033Z"
          fill="black"
        />
      </svg>
    );
  }
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 22v2h-2v-2h2zM12 2a8 8 0 0 1 8 8c0 2.88-1.59 5.417-4.128 6.983l-.523.313a8.264 8.264 0 0 0-.487.327c-.796.578-1.297 1.17-1.59 1.76l-.03.066-.067.172-.228.648-.066.166a.806.806 0 0 1-.085.163l-.047.056-.08.086a.49.49 0 0 1-.165.106l-.08.029-.173.05-.251.063-.345-.089c-.16-.046-.237-.08-.308-.144l-.053-.053-.09-.103a.54.54 0 0 1-.054-.095l-.063-.147-.033-.088-.23-.65-.035-.092-.063-.146c-.297-.594-.804-1.19-1.608-1.771a8.314 8.314 0 0 0-.482-.322l-.518-.31C5.583 15.414 4 12.88 4 10a8 8 0 0 1 8-8zm0 2a6 6 0 0 0-6 6c0 2.134 1.181 4.038 3.136 5.256l.558.334c.208.13.406.262.594.398.61.44 1.106.905 1.501 1.387l.21.271.205-.265c.267-.327.58-.645.944-.954l.282-.229.257-.193c.19-.139.392-.274.603-.406l.564-.338C16.812 14.04 18 12.133 18 10a6 6 0 0 0-6-6zm0 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
        fill={fill}
      />
    </svg>
  );
};

export const WalletOutlineIcon = ({
  width = 24,
  height = 24,
  fill = '#000',
  className = '',
}: IconType) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M15.5 15.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" fill={fill} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 5V3H5l-.176.005a3 3 0 0 0-2.819 2.819L2 6v13l.005.15A2 2 0 0 0 4 21h16l.15-.006A2 2 0 0 0 22 19V9l-.006-.15A2 2 0 0 0 20 7H5l-.117-.007A1 1 0 0 1 5 5h15zM4 19V8.829l.148.048A3 3 0 0 0 5 9h15v10H4z"
      fill={fill}
    />
  </svg>
);

export const ExitOutlineIcon = ({
  width = 24,
  height = 24,
  className = '',
}: IconType) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clip-path="url(#a)">
      <path
        d="M15.325 16.275a1.11 1.11 0 0 1-.275-.737c0-.276.092-.505.275-.688l1.85-1.85H10a.967.967 0 0 1-.713-.287A.968.968 0 0 1 9 12c0-.283.096-.52.287-.713A.967.967 0 0 1 10 11h7.175l-1.85-1.85c-.2-.2-.3-.438-.3-.713 0-.274.1-.512.3-.712.183-.2.413-.3.688-.3.274 0 .504.092.687.275l3.6 3.6c.1.1.17.208.212.325.042.117.063.242.063.375s-.02.258-.063.375a.877.877 0 0 1-.212.325l-3.6 3.6c-.217.217-.454.313-.712.287a1.054 1.054 0 0 1-.663-.312zM5 21c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 19V5c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 3h6c.283 0 .52.096.713.288.191.191.287.429.287.712s-.096.52-.287.713A.968.968 0 0 1 11 5H5v14h6c.283 0 .52.096.713.288.191.191.287.429.287.712s-.096.52-.287.712A.968.968 0 0 1 11 21H5z"
        fill="#E11900"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const InviteFriendsIcon = ({
  width = 24,
  height = 24,
  className = '',
}: IconType) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clip-path="url(#a)" fill="#545454">
      <path d="M16.67 13.13C18.04 14.06 19 15.32 19 17v3h4v-3c0-2.18-3.57-3.47-6.33-3.87zM15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4c-.47 0-.91.1-1.33.24a5.98 5.98 0 0 1 0 7.52c.42.14.86.24 1.33.24zM9 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM9 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm6 5H3v-.99C3.2 16.29 6.3 15 9 15s5.8 1.29 6 2v1z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const Profilefill2Icon = ({
  width = 24,
  height = 24,
  fill = '#fff',
  className = '',
}: IconType) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clip-path="url(#a)">
      <path
        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill={fill} d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const ProfileOutline2Icon = ({
  width = 24,
  height = 24,
  className = '',
}: IconType) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clip-path="url(#a)">
      <path
        d="M12 5.9a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2zm0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1zM12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
        fill="#545454"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const NewTickIcon = ({
  width,
  height,
  stroke,
  className = '',
}: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10 2 4.4 7.6 2 5.2"
        stroke={stroke}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronDownIcon = ({
  width,
  height,
  stroke,
  className,
}: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.667 6.667 8 10l3.333-3.333"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StarIcon = ({
  width = 16,
  height = 15,
  fill = 'black',
  className,
}: IconType) => (
  <svg
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.99994 12.3916L11.4583 14.4833C12.0916 14.8666 12.8666 14.3 12.6999 13.5833L11.7833 9.64997L14.8416 6.99997C15.3999 6.51663 15.0999 5.59997 14.3666 5.54163L10.3416 5.19997L8.76661 1.4833C8.48327 0.808301 7.51661 0.808301 7.23327 1.4833L5.65827 5.19163L1.63327 5.5333C0.899939 5.59163 0.599938 6.5083 1.15827 6.99163L4.21661 9.64163L3.29994 13.575C3.13327 14.2916 3.90827 14.8583 4.5416 14.475L7.99994 12.3916Z"
      fill={fill}
    />
  </svg>
);

export const NewDeleteIcon = ({
  width = 24,
  height = 24,
  fill = '#E11900',
  className,
}: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 5H10V7H8V5C8 3.94564 8.81588 3.08183 9.85074 3.00549L10 3H14C15.0544 3 15.9182 3.81588 15.9945 4.85074L16 5V7H21V9H19V19C19 20.0544 18.1841 20.9182 17.1493 20.9945L17 21H7C5.94564 21 5.08183 20.1841 5.00549 19.1493L5 19V9H3V7H14V5ZM17 9H7V19H17V9Z"
        fill={fill}
      />
    </svg>
  );
};

export const NewEditIcon = ({
  width = 24,
  height = 24,
  fill = 'black',
  className,
}: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7168 4.11937L16.8262 4.22104L19.6547 7.04947C20.4002 7.79501 20.4341 8.98273 19.7563 9.76847L19.6547 9.87789L9.46227 20.0703H5.30542C4.52877 20.0703 3.88998 19.48 3.81316 18.7236L3.80542 18.5703V14.4134L13.9978 4.22104C14.7434 3.47549 15.9311 3.44161 16.7168 4.11937ZM20 18.0001V20.0001H12L14 18.0001H20ZM12.5836 8.46368L5.80598 15.2413V18.0697L8.63511 18.069L15.412 11.2921L12.5836 8.46368ZM15.412 5.63525L13.9978 7.04947L16.8262 9.87789L18.2404 8.46368L15.412 5.63525Z"
        fill={fill}
      />
    </svg>
  );
};

export const ArrowTopRightIcon = ({
  width = 24,
  height = 24,
  fill = 'black',
  className,
}: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.10606 11.211L3.96106 11.291C2.42406 12.209 2.79506 14.599 4.60806 14.961L8.30006 15.7L9.03906 19.392C9.41206 21.26 11.9371 21.598 12.7891 19.894L18.7891 7.89396C19.6491 6.17496 17.8251 4.35196 16.1061 5.21096L4.10606 11.211ZM17.0001 6.99996L11.0001 19L10.0001 14L5.00006 13L17.0001 6.99996Z"
        fill={fill}
      />
    </svg>
  );
};

export const PencilOutline = ({ width, height, fill, className }: IconType) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9307 3.43272L14.0219 3.51744L16.3789 5.87447C17.0002 6.49576 17.0284 7.48552 16.4636 8.1403L16.3789 8.23149L7.88525 16.7251H4.4212C3.77399 16.7251 3.24167 16.2333 3.17766 15.603L3.1712 15.4751V12.0111L11.6649 3.51744C12.2861 2.89616 13.2759 2.86792 13.9307 3.43272ZM16.6667 15V16.6667H9.99999L11.6667 15H16.6667ZM10.4863 7.05298L4.83833 12.701V15.058L7.19595 15.0574L12.8434 9.41L10.4863 7.05298ZM12.8434 4.69596L11.6649 5.87447L14.0219 8.23149L15.2004 7.05298L12.8434 4.69596Z"
        fill={fill}
      />
    </svg>
  );
};

export const ListWithTimer = ({ width, height, fill, className }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C13.3 1 14.4 1.84 14.82 3H18C19.1 3 20 3.9 20 5V11H18V5H15V8H9V5H6V20H9V22H6C4.9 22 4 21.1 4 20V5C4 3.9 4.9 3 6 3H9.18C9.6 1.84 10.7 1 12 1ZM15 12C16.3261 12 17.5979 12.5268 18.5355 13.4645C19.4732 14.4021 20 15.6739 20 17C20 18.3261 19.4732 19.5979 18.5355 20.5355C17.5979 21.4732 16.3261 22 15 22C13.6739 22 12.4021 21.4732 11.4645 20.5355C10.5268 19.5979 10 18.3261 10 17C10 15.6739 10.5268 14.4021 11.4645 13.4645C12.4021 12.5268 13.6739 12 15 12ZM15 13.667C14.5623 13.667 14.1289 13.7532 13.7245 13.9207C13.3201 14.0882 12.9527 14.3337 12.6432 14.6432C12.3337 14.9527 12.0882 15.3201 11.9207 15.7245C11.7532 16.1289 11.667 16.5623 11.667 17C11.667 17.4377 11.7532 17.8711 11.9207 18.2755C12.0882 18.6799 12.3337 19.0473 12.6432 19.3568C12.9527 19.6663 13.3201 19.9118 13.7245 20.0793C14.1289 20.2468 14.5623 20.333 15 20.333C15.884 20.333 16.7317 19.9818 17.3568 19.3568C17.9818 18.7317 18.333 17.884 18.333 17C18.333 16.116 17.9818 15.2683 17.3568 14.6432C16.7317 14.0182 15.884 13.667 15 13.667ZM15.347 14.917V16.652H17.083V17.694H14.306V14.917H15.347ZM12 3C11.45 3 11 3.45 11 4C11 4.55 11.45 5 12 5C12.55 5 13 4.55 13 4C13 3.45 12.55 3 12 3Z"
        fill={fill}
      />
    </svg>
  );
};

export const PinLocation = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 22V24H11V22H13ZM12 2C16.4183 2 20 5.58172 20 10C20 12.8805 18.4102 15.4172 15.8722 16.983L15.3494 17.2956C15.1772 17.4028 15.0147 17.512 14.8618 17.623C14.0665 18.2005 13.5653 18.7933 13.2714 19.3836L13.2417 19.4487L13.1747 19.6211L12.9467 20.2685L12.8814 20.4345C12.8501 20.5082 12.8212 20.5658 12.7962 20.5978L12.7491 20.6535L12.6692 20.7401C12.6218 20.7855 12.5749 20.8169 12.5041 20.846L12.4245 20.8748L12.2506 20.9244L12 20.9877L11.6551 20.899C11.4941 20.8534 11.4184 20.8186 11.3473 20.7552L11.2936 20.7016L11.2048 20.5991C11.1881 20.5778 11.1697 20.5451 11.15 20.5038L11.0873 20.3569L11.0538 20.2693L10.8242 19.6197L10.7893 19.5269L10.7265 19.3808C10.4294 18.7872 9.92232 18.1908 9.11754 17.6097C8.96643 17.5006 8.80615 17.3933 8.63641 17.2879L8.11799 16.9782C5.58274 15.4145 4 12.8805 4 10C4 5.58172 7.58172 2 12 2ZM12 4C8.68629 4 6 6.68629 6 10C6 12.1338 7.18145 14.0381 9.13564 15.256L9.69368 15.5902C9.90187 15.7196 10.1 15.8523 10.2883 15.9883C10.8976 16.4282 11.3936 16.8929 11.7891 17.3749L11.999 17.646L12.2043 17.3809C12.4713 17.0542 12.7845 16.7356 13.1478 16.4273L13.4297 16.198L13.6866 16.0047C13.8776 15.866 14.0788 15.7307 14.2904 15.599L14.8543 15.2609C16.8122 14.0404 18 12.1325 18 10C18 6.68629 15.3137 4 12 4ZM12 7C13.6569 7 15 8.34315 15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7ZM12 9C11.4477 9 11 9.44772 11 10C11 10.5523 11.4477 11 12 11C12.5523 11 13 10.5523 13 10C13 9.44772 12.5523 9 12 9Z"
        fill={fill}
      />
    </svg>
  );
};

export const CallOutlineIcon = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.325 12.8167C4.35 12.8167 5.34167 12.65 6.26667 12.35C6.55833 12.25 6.88333 12.325 7.10833 12.55L8.41667 14.1917C10.775 13.0667 12.9833 10.9417 14.1583 8.5L12.5333 7.11667C12.3083 6.88333 12.2417 6.55833 12.3333 6.26667C12.6417 5.34167 12.8 4.35 12.8 3.325C12.8 2.875 13.175 2.5 13.625 2.5H16.5083C16.9583 2.5 17.5 2.7 17.5 3.325C17.5 11.0667 11.0583 17.5 3.325 17.5C2.73333 17.5 2.5 16.975 2.5 16.5167V13.6417C2.5 13.1917 2.875 12.8167 3.325 12.8167Z"
        fill={fill}
      />
    </svg>
  );
};

export const WarninglineIcon = ({ width, height, fill }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 12.9173H11.25V15.4173H8.75V12.9173ZM8.75 4.58398H11.25V11.2507H8.75V4.58398Z"
        fill={fill}
      />
    </svg>
  );
};
export const CheckBoxIcon = ({ width, height, fill, className }: IconType) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_944_1025)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.743 14.996L19.157 16.41L14.5 21.067L11.964 18.531L13.379 17.117L14.499 18.238L17.743 14.996ZM17.449 3L21.089 7.092L20.999 7.17L21 13H19V9H5V19H10V21H5C4.49543 21.0002 4.00944 20.8096 3.63946 20.4665C3.26947 20.1234 3.04285 19.6532 3.005 19.15L3 19V7.171L2.91 7.091L6.55 3H17.45H17.449ZM16.551 5H7.447L5.667 7H18.33L16.551 5Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_944_1025">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DebitCardOutlineIcon = ({
  width = 24,
  height = 24,
  fill = '#B1B2B2',
  className,
}: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 4C21.0544 4 21.9182 4.81588 21.9945 5.85074L22 6V18C22 19.0544 21.1841 19.9182 20.1493 19.9945L20 20H4C2.94564 20 2.08183 19.1841 2.00549 18.1493L2 18V6C2 4.94564 2.81588 4.08183 3.85074 4.00549L4 4H20ZM20 11H4V18H20V11ZM10 13V15H6V13H10ZM20 6H4V9H20V6Z"
        fill={fill}
      />
    </svg>
  );
};

export const DebitCardFillIcon = ({
  width = 24,
  height = 24,
  fill,
  className,
  gradient,
}: IconType) => {
  if (gradient) {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M20 4C21.0544 4 21.9182 4.81588 21.9945 5.85074L22 6V9H2V6C2 4.94564 2.81588 4.08183 3.85074 4.00549L4 4H20Z"
          fill="url(#paint0_linear_1404_24133)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 11H22V18C22 19.0544 21.1841 19.9182 20.1493 19.9945L20 20H4C2.94564 20 2.08183 19.1841 2.00549 18.1493L2 18V11ZM10.0166 14H5.99512V16H10.0166V14Z"
          fill="url(#paint1_linear_1404_24133)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1404_24133"
            x1="2"
            y1="4"
            x2="22.4658"
            y2="4.61989"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF7733" />
            <stop offset="0.50153" stop-color="#FF5722" />
            <stop offset="1" stop-color="#E64917" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1404_24133"
            x1="2"
            y1="4"
            x2="22.4658"
            y2="4.61989"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF7733" />
            <stop offset="0.50153" stop-color="#FF5722" />
            <stop offset="1" stop-color="#E64917" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M20 4C21.0544 4 21.9182 4.81588 21.9945 5.85074L22 6V9H2V6C2 4.94564 2.81588 4.08183 3.85074 4.00549L4 4H20Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 11H22V18C22 19.0544 21.1841 19.9182 20.1493 19.9945L20 20H4C2.94564 20 2.08183 19.1841 2.00549 18.1493L2 18V11ZM10.0166 14H5.99512V16H10.0166V14Z"
        fill={fill}
      />
    </svg>
  );
};

export const StoreOutlineIcon = ({
  width = 24,
  height = 24,
  fill = 'black',
  className,
}: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.958 11.05V19C20.958 19.55 20.763 20.0208 20.3732 20.4125C19.9834 20.8042 19.5147 21 18.9673 21H5.0327C4.48527 21 4.01664 20.8042 3.6268 20.4125C3.23697 20.0208 3.04205 19.55 3.04205 19V11.05C2.66051 10.7 2.36605 10.25 2.15869 9.7C1.95133 9.15 1.94719 8.55 2.14625 7.9L3.19135 4.5C3.32406 4.06667 3.56045 3.70833 3.90052 3.425C4.24059 3.14167 4.63457 3 5.08247 3H18.9175C19.3654 3 19.7553 3.1375 20.087 3.4125C20.4188 3.6875 20.6594 4.05 20.8087 4.5L21.8537 7.9C22.0528 8.55 22.0487 9.14167 21.8413 9.675C21.6339 10.2083 21.3395 10.6667 20.958 11.05ZM14.1897 10C14.6376 10 14.9777 9.84583 15.2099 9.5375C15.4422 9.22917 15.5334 8.88333 15.4836 8.5L14.9362 5H12.9953V8.7C12.9953 9.05 13.1115 9.35417 13.3437 9.6125C13.5759 9.87083 13.8579 10 14.1897 10ZM9.71075 10C10.0923 10 10.4033 9.87083 10.6439 9.6125C10.8844 9.35417 11.0047 9.05 11.0047 8.7V5H9.06378L8.51635 8.5C8.45 8.9 8.53709 9.25 8.77763 9.55C9.01816 9.85 9.3292 10 9.71075 10ZM5.28154 10C5.58013 10 5.84141 9.89167 6.06536 9.675C6.28931 9.45833 6.42616 9.18333 6.47593 8.85L7.02336 5H5.08247L4.08714 8.35C3.98761 8.68333 4.04152 9.04167 4.24888 9.425C4.45624 9.80833 4.80046 10 5.28154 10ZM18.7185 10C19.1995 10 19.5479 9.80833 19.7636 9.425C19.9792 9.04167 20.029 8.68333 19.9129 8.35L18.8678 5H16.9766L17.5241 8.85C17.5738 9.18333 17.7107 9.45833 17.9346 9.675C18.1586 9.89167 18.4199 10 18.7185 10ZM5.0327 19H18.9673V11.95C18.8844 11.9833 18.8304 12 18.8056 12H18.7185C18.2706 12 17.8766 11.925 17.5365 11.775C17.1964 11.625 16.8605 11.3833 16.5287 11.05C16.2301 11.35 15.8901 11.5833 15.5085 11.75C15.127 11.9167 14.7206 12 14.2893 12C13.8414 12 13.4225 11.9167 13.0327 11.75C12.6428 11.5833 12.2986 11.35 12 11.05C11.718 11.35 11.3904 11.5833 11.0171 11.75C10.6439 11.9167 10.2416 12 9.81028 12C9.3292 12 8.89375 11.9167 8.50391 11.75C8.11407 11.5833 7.76986 11.35 7.47126 11.05C7.12289 11.4 6.77868 11.6458 6.4386 11.7875C6.09853 11.9292 5.71284 12 5.28154 12H5.16956C5.12809 12 5.08247 11.9833 5.0327 11.95V19Z"
        fill={fill}
      />
    </svg>
  );
};

export const StoreFillIcon = ({
  width = 24,
  height = 24,
  fill = 'black',
  className,
  gradient = false,
}: IconType) => {
  if (gradient) {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.958 11.05V19C20.958 19.55 20.763 20.0208 20.3732 20.4125C19.9834 20.8042 19.5147 21 18.9673 21H5.0327C4.48527 21 4.01664 20.8042 3.6268 20.4125C3.23697 20.0208 3.04205 19.55 3.04205 19V11.05C2.66051 10.7 2.36605 10.25 2.15869 9.7C1.95133 9.15 1.94719 8.55 2.14625 7.9L3.19135 4.5C3.32406 4.06667 3.56045 3.70833 3.90052 3.425C4.24059 3.14167 4.63457 3 5.08247 3H18.9175C19.3654 3 19.7553 3.1375 20.087 3.4125C20.4188 3.6875 20.6594 4.05 20.8087 4.5L21.8537 7.9C22.0528 8.55 22.0487 9.14167 21.8413 9.675C21.6339 10.2083 21.3395 10.6667 20.958 11.05ZM14.1897 10C14.6376 10 14.9777 9.84583 15.2099 9.5375C15.4422 9.22917 15.5334 8.88333 15.4836 8.5L14.9362 5H12.9953V8.7C12.9953 9.05 13.1115 9.35417 13.3437 9.6125C13.5759 9.87083 13.8579 10 14.1897 10ZM9.71075 10C10.0923 10 10.4033 9.87083 10.6439 9.6125C10.8844 9.35417 11.0047 9.05 11.0047 8.7V5H9.06378L8.51635 8.5C8.45 8.9 8.53709 9.25 8.77763 9.55C9.01816 9.85 9.3292 10 9.71075 10ZM5.28154 10C5.58013 10 5.84141 9.89167 6.06536 9.675C6.28931 9.45833 6.42616 9.18333 6.47593 8.85L7.02336 5H5.08247L4.08714 8.35C3.98761 8.68333 4.04152 9.04167 4.24888 9.425C4.45624 9.80833 4.80046 10 5.28154 10ZM18.7185 10C19.1995 10 19.5479 9.80833 19.7636 9.425C19.9792 9.04167 20.029 8.68333 19.9129 8.35L18.8678 5H16.9766L17.5241 8.85C17.5738 9.18333 17.7107 9.45833 17.9346 9.675C18.1586 9.89167 18.4199 10 18.7185 10Z"
          fill="url(#paint0_linear_1404_24154)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1404_24154"
            x1="2"
            y1="3"
            x2="22.4698"
            y2="3.55112"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF7733" />
            <stop offset="0.50153" stop-color="#FF5722" />
            <stop offset="1" stop-color="#E64917" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.958 11.05V19C20.958 19.55 20.763 20.0208 20.3732 20.4125C19.9834 20.8042 19.5147 21 18.9673 21H5.0327C4.48527 21 4.01664 20.8042 3.6268 20.4125C3.23697 20.0208 3.04205 19.55 3.04205 19V11.05C2.66051 10.7 2.36605 10.25 2.15869 9.7C1.95133 9.15 1.94719 8.55 2.14625 7.9L3.19135 4.5C3.32406 4.06667 3.56045 3.70833 3.90052 3.425C4.24059 3.14167 4.63457 3 5.08247 3H18.9175C19.3654 3 19.7553 3.1375 20.087 3.4125C20.4188 3.6875 20.6594 4.05 20.8087 4.5L21.8537 7.9C22.0528 8.55 22.0487 9.14167 21.8413 9.675C21.6339 10.2083 21.3395 10.6667 20.958 11.05ZM14.1897 10C14.6376 10 14.9777 9.84583 15.2099 9.5375C15.4422 9.22917 15.5334 8.88333 15.4836 8.5L14.9362 5H12.9953V8.7C12.9953 9.05 13.1115 9.35417 13.3437 9.6125C13.5759 9.87083 13.8579 10 14.1897 10ZM9.71075 10C10.0923 10 10.4033 9.87083 10.6439 9.6125C10.8844 9.35417 11.0047 9.05 11.0047 8.7V5H9.06378L8.51635 8.5C8.45 8.9 8.53709 9.25 8.77763 9.55C9.01816 9.85 9.3292 10 9.71075 10ZM5.28154 10C5.58013 10 5.84141 9.89167 6.06536 9.675C6.28931 9.45833 6.42616 9.18333 6.47593 8.85L7.02336 5H5.08247L4.08714 8.35C3.98761 8.68333 4.04152 9.04167 4.24888 9.425C4.45624 9.80833 4.80046 10 5.28154 10ZM18.7185 10C19.1995 10 19.5479 9.80833 19.7636 9.425C19.9792 9.04167 20.029 8.68333 19.9129 8.35L18.8678 5H16.9766L17.5241 8.85C17.5738 9.18333 17.7107 9.45833 17.9346 9.675C18.1586 9.89167 18.4199 10 18.7185 10Z"
        fill={fill}
      />
    </svg>
  );
};

export const ClipboardClockIcon = ({
  width = 20,
  height = 20,
  fill = 'black',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99992 0.833252C8.08325 0.833252 8.99992 1.53325 9.34992 2.49992H11.9999C12.9166 2.49992 13.6666 3.24992 13.6666 4.16659V9.16658H11.9999V4.16659H9.49992V6.66658H4.49992V4.16659H1.99992V16.6666H4.49992V18.3333H1.99992C1.08325 18.3333 0.333252 17.5833 0.333252 16.6666V4.16659C0.333252 3.24992 1.08325 2.49992 1.99992 2.49992H4.64992C4.99992 1.53325 5.91658 0.833252 6.99992 0.833252ZM9.49992 9.99992C10.605 9.99992 11.6648 10.4389 12.4462 11.2203C13.2276 12.0017 13.6666 13.0615 13.6666 14.1666C13.6666 15.2717 13.2276 16.3315 12.4462 17.1129C11.6648 17.8943 10.605 18.3333 9.49992 18.3333C8.39485 18.3333 7.33504 17.8943 6.55364 17.1129C5.77224 16.3315 5.33325 15.2717 5.33325 14.1666C5.33325 13.0615 5.77224 12.0017 6.55364 11.2203C7.33504 10.4389 8.39485 9.99992 9.49992 9.99992ZM9.49992 11.3891C9.13517 11.3891 8.774 11.4609 8.43701 11.6005C8.10003 11.7401 7.79384 11.9447 7.53593 12.2026C7.27801 12.4605 7.07343 12.7667 6.93384 13.1037C6.79426 13.4407 6.72242 13.8018 6.72242 14.1666C6.72242 14.5313 6.79426 14.8925 6.93384 15.2295C7.07343 15.5665 7.27801 15.8727 7.53593 16.1306C7.79384 16.3885 8.10003 16.5931 8.43701 16.7327C8.774 16.8722 9.13517 16.9441 9.49992 16.9441C10.2366 16.9441 10.943 16.6515 11.4639 16.1306C11.9848 15.6097 12.2774 14.9032 12.2774 14.1666C12.2774 13.4299 11.9848 12.7235 11.4639 12.2026C10.943 11.6817 10.2366 11.3891 9.49992 11.3891ZM9.78909 12.4308V13.8766H11.2358V14.7449H8.92159V12.4308H9.78909ZM6.99992 2.49992C6.54158 2.49992 6.16658 2.87492 6.16658 3.33325C6.16658 3.79159 6.54158 4.16659 6.99992 4.16659C7.45825 4.16659 7.83325 3.79159 7.83325 3.33325C7.83325 2.87492 7.45825 2.49992 6.99992 2.49992Z"
        fill={fill}
      />
    </svg>
  );
};

export const CouponPuchedFillIcon = ({
  width,
  height,
  fill = 'white',
}: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 4C21.0544 4 21.9182 4.81588 21.9945 5.85074L22 6V10C20.8954 10 20 10.8954 20 12C20 13.0544 20.8159 13.9182 21.8507 13.9945L22 14V18C22 19.0544 21.1841 19.9182 20.1493 19.9945L20 20H4C2.94564 20 2.08183 19.1841 2.00549 18.1493L2 18V14C3.10457 14 4 13.1046 4 12C4 10.9456 3.18412 10.0818 2.14926 10.0055L2 10V6C2 4.94564 2.81588 4.08183 3.85074 4.00549L4 4H20ZM14.8284 7.75736L7.75736 14.8284L9.17157 16.2426L16.2426 9.17157L14.8284 7.75736ZM16 14H14V16H16V14ZM10 8H8V10H10V8Z"
        fill={fill}
      />
    </svg>
  );
};

export const ChevronUpIcon = ({ width, height, fill = 'black' }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4853 15.364L11.9505 11.8291L8.41421 15.364L7 13.9497L11.9497 9L16.8995 13.9497L15.4853 15.364Z"
        fill={fill}
      />
    </svg>
  );
};
export const HeartIcon = ({
  width = 22,
  height = 19,
  stroke = 'black',
  fill = 'white',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Outer Heart Shape */}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.8389 1.63633C21.9271 3.72456 21.9851 7.07419 20.0129 9.23249L19.8389 9.41451L11 18.2533L2.16121 9.41448C0.0133221 7.26659 0.0133221 3.78419 2.16121 1.6363C4.24943 -0.451917 7.59906 -0.509923 9.75736 1.46228L9.93938 1.6363L10.9993 2.69539L12.0607 1.63633C14.2086 -0.511549 17.691 -0.511549 19.8389 1.63633Z"
      fill={stroke}
    />

    {/* Inner Heart Shape */}
    <path
      d="M13.6245 2.90933L13.4749 3.05055L10.9993 5.52539L8.52517 3.05052C7.25283 1.77818 5.24462 1.69022 3.87053 2.78662L3.71487 2.91839L3.57542 3.05052C2.2574 4.36854 2.21033 6.47622 3.4342 7.85065L3.57542 8.00026L10.9993 15.4254L18.4247 8.0003C19.697 6.72796 19.785 4.71974 18.6886 3.34566L18.5568 3.19L18.4247 3.05055C17.1555 1.78134 15.154 1.69069 13.7802 2.77858L13.6245 2.90933Z"
      fill={fill}
    />
  </svg>
);

export const ChatFillIcon = ({ width = 13, height = 16, fill = '#747575' }) => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.33333 0H10.6667C11.4 0 11.9933 0.6 11.9933 1.33333L12 12.6667L9.33333 10H1.33333C0.599999 10 0 9.4 0 8.66667V1.33333C0 0.6 0.599999 0 1.33333 0ZM8 5.33333H9.33333V4H8V5.33333ZM5.33333 5.33333H6.66667V4H5.33333V5.33333ZM2.66667 5.33333H4V4H2.66667V5.33333Z"
      fill={fill}
    />
  </svg>
);

export const ArrowUpArrowDownIcon = ({
  width = 24,
  height = 24,
  fill = 'black',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.894 6.65381L7.922 2L3 6.65381L4.383 8.104L7.013 5.68408V18H9.02V5.68408L11.542 8.104L12.894 6.65381ZM19.647 15.897L17.047 18.3169V6.0708H15.04V18.3159L12.488 15.896L11.121 17.3462L16.086 22L21 17.3462L19.647 15.897Z"
      fill="black"
    />
  </svg>
);

export const SliderHorizontalIcon = ({
  width = 24,
  height = 24,
  fill = 'black',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 13.5C10.433 13.5 12 15.067 12 17C12 18.933 10.433 20.5 8.5 20.5C6.9148 20.5 5.57573 19.4462 5.14519 18.0008L2 18V16L5.14489 16.0002C5.57511 14.5543 6.91443 13.5 8.5 13.5ZM8.5 15.5C7.67157 15.5 7 16.1716 7 17C7 17.8284 7.67157 18.5 8.5 18.5C9.32843 18.5 10 17.8284 10 17C10 16.1716 9.32843 15.5 8.5 15.5ZM22 16V18H14V16H22ZM15.5 3.5C17.0856 3.5 18.4249 4.55433 18.8551 6.00016L22 6V8L18.8548 8.00084C18.4243 9.44615 17.0852 10.5 15.5 10.5C13.567 10.5 12 8.933 12 7C12 5.067 13.567 3.5 15.5 3.5ZM15.5 5.5C14.6716 5.5 14 6.17157 14 7C14 7.82843 14.6716 8.5 15.5 8.5C16.3284 8.5 17 7.82843 17 7C17 6.17157 16.3284 5.5 15.5 5.5ZM10 6V8H2V6H10Z"
      fill="black"
    />
  </svg>
);

export const ChevronRightIcon = ({
  width = 24,
  height = 24,
  fill = 'black',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.55029 15.5356L12.0851 12.0007L8.55029 8.46451L9.96451 7.05029L14.9143 12L9.96451 16.9498L8.55029 15.5356Z"
      fill={fill}
    />
  </svg>
);

export const CircleCheckFillIcon = ({
  width = 24,
  height = 24,
  fill = 'black',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM16.2929 8.29297L11 13.5859L8.70712 11.293L7.29291 12.7072L11 16.4143L17.7071 9.70718L16.2929 8.29297Z"
      fill={fill}
    />
  </svg>
);

export const CircleCrossFillIcon = ({
  width = 24,
  height = 24,
  fill = 'black',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM14.1213 8.46447L15.5355 9.87868L13.414 12L15.5355 14.1213L14.1213 15.5355L12 13.414L9.87868 15.5355L8.46447 14.1213L10.586 12L8.46447 9.87868L9.87868 8.46447L12 10.586L14.1213 8.46447Z"
      fill={fill}
    />
  </svg>
);

export const DoctorFillIcon = ({
  fill = 'black',
  width = 24,
  height = 24,
  gradient = false,
}) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 0V2H2V6C2 8.21 3.79 10 6 10C8.21 10 10 8.21 10 6V2H8V0H11C11.2652 0 11.5196 0.105357 11.7071 0.292893C11.8946 0.48043 12 0.734784 12 1V6C11.9998 7.41797 11.4976 8.79009 10.5824 9.87315C9.66719 10.9562 8.39807 11.6803 7 11.917V13.5C6.99945 14.3196 7.28656 15.1134 7.81129 15.7431C8.33601 16.3727 9.06506 16.7982 9.87135 16.9454C10.6776 17.0926 11.51 16.9522 12.2234 16.5486C12.9368 16.1451 13.4859 15.5039 13.775 14.737C13.1315 14.4484 12.6103 13.9424 12.3028 13.3078C11.9953 12.6732 11.9212 11.9505 12.0935 11.2666C12.2658 10.5828 12.6735 9.98154 13.245 9.56839C13.8165 9.15525 14.5153 8.95664 15.2187 9.00745C15.9221 9.05825 16.5851 9.35522 17.0913 9.84621C17.5975 10.3372 17.9145 10.9908 17.9868 11.6923C18.059 12.3938 17.8818 13.0983 17.4863 13.6822C17.0908 14.266 16.5023 14.6919 15.824 14.885C15.4881 16.1808 14.6911 17.3096 13.5825 18.0598C12.4739 18.81 11.1297 19.1302 9.80193 18.9603C8.47414 18.7904 7.2539 18.1421 6.3699 17.1369C5.4859 16.1317 4.99884 14.8386 5 13.5V11.917C3.60184 11.6805 2.33261 10.9565 1.41736 9.87335C0.502115 8.79025 -1.77509e-05 7.41803 4.70646e-10 6V1C4.70646e-10 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H4Z"
      fill={gradient ? `url(#paint0_linear_2797_21189)` : fill}
    />
    {gradient && (
      <defs>
        <linearGradient
          id="paint0_linear_2797_21189"
          x1="0"
          y1="0"
          x2="18.4291"
          y2="0.423009"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF7733" />
          <stop offset="0.50153" stop-color="#FF5722" />
          <stop offset="1" stop-color="#E64917" />
        </linearGradient>
      </defs>
    )}
  </svg>
);

export const CircleInfromationIcon = ({
  width = 24,
  height = 24,
  fill = 'black',
}) => (
  <svg width={width} height={height} viewBox="0 0 24 24">
    <path
      d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
      fill={fill}
    />
  </svg>
);

export const HomeHealthIcon = ({
  width = 1,
  height = 1,
  fill = '#747575',
  className = '',
}) => (
  <svg
    width={`${width}rem`}
    height={`${height}rem`}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14 8.51613C14.0024 7.38498 13.0688 6.46625 11.9148 6.46389C10.7608 6.46154 9.82357 7.37668 9.82117 8.50783C9.81919 9.44331 10.4642 10.2612 11.3882 10.495V11.0762C11.3882 12.494 10.2158 13.6433 8.76941 13.6433C7.32307 13.6433 6.15061 12.494 6.15061 11.0762C6.20369 9.84116 6.76995 8.68123 7.71766 7.86573H7.64707C8.66071 7.21753 9.27962 6.11821 9.29882 4.93198V2.87005C9.29882 2.02175 8.59732 1.33398 7.73178 1.33398C7.72712 1.33398 7.72232 1.33398 7.71766 1.33398H6.94119C6.65277 1.33398 6.41885 1.56329 6.41885 1.84601C6.41885 2.12873 6.65277 2.35803 6.94119 2.35803H7.71766C8.00608 2.35803 8.24001 2.58733 8.24001 2.87005V4.93198C8.24001 6.34045 7.07926 7.48448 5.64238 7.49209C4.19999 7.4997 3.02429 6.35969 3.01652 4.94582C3.01652 4.94125 3.01652 4.93654 3.01652 4.93198V2.87005C3.01652 2.58733 3.25045 2.35803 3.53887 2.35803H4.27298C4.5614 2.35803 4.79533 2.12873 4.79519 1.84587C4.79519 1.56315 4.5614 1.33398 4.27298 1.33398H3.53887C2.68448 1.34907 2.00001 2.03241 2.00001 2.87005V4.93198C1.99696 6.10008 2.5769 7.19567 3.55299 7.86573C4.49547 8.68358 5.0565 9.84324 5.10592 11.0762C5.10592 13.0596 6.74609 14.6673 8.76941 14.6673C10.7927 14.6673 12.4329 13.0596 12.4329 11.0762V10.495C13.3539 10.262 13.998 9.44857 14 8.51613ZM11.8823 9.54018C11.3053 9.54018 10.8376 9.08171 10.8376 8.51613C10.8376 7.95056 11.3053 7.49209 11.8823 7.49209C12.4593 7.49209 12.927 7.95056 12.927 8.51613C12.927 9.08171 12.4593 9.54018 11.8823 9.54018Z"
      fill={fill}
    />
  </svg>
);
